webpackJsonp([12],{

/***/ "+0PG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("Pq8k");

var _reactRedux = __webpack_require__("RH2O");

var _actionTypes = __webpack_require__("EA8k");

var _favorites = __webpack_require__("7Tur");

var _navigation = __webpack_require__("LYcX");

var _uiActions = __webpack_require__("rj0T");

var _i18n = __webpack_require__("lg9U");

var _patterns = __webpack_require__("MTZW");

var _sewpats = __webpack_require__("iBUI");

var _PatternGalleryBarFull = __webpack_require__("nOk+");

var _PatternGalleryBarFull2 = _interopRequireDefault(_PatternGalleryBarFull);

var _PatternGalleryBarSmall = __webpack_require__("7shp");

var _PatternGalleryBarSmall2 = _interopRequireDefault(_PatternGalleryBarSmall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PatternGalleryAppBar = function PatternGalleryAppBar(_ref) {
    var type = _ref.type,
        props = _objectWithoutProperties(_ref, ['type']);

    if (type === 'small') {
        return _react2.default.createElement(_PatternGalleryBarSmall2.default, props);
    }
    return _react2.default.createElement(_PatternGalleryBarFull2.default, props);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        removeFromFavorites: function removeFromFavorites(patternid, sewpatId, query) {
            return dispatch((0, _favorites.removeFromFavorites)(patternid, sewpatId, query));
        },
        addToFavorites: function addToFavorites(patternid, sewpatId, query) {
            return dispatch((0, _favorites.addToFavorites)(patternid, sewpatId, query));
        },
        goToPattern: function goToPattern(patternid, sewpatId, query) {
            return dispatch((0, _navigation.goToPattern)(patternid, sewpatId, query));
        },
        showAddedToFavorites: function showAddedToFavorites(id) {
            return dispatch((0, _uiActions.showSnack)(id, 'SNACK_PATTERN_ADDED_TO_FAVORITES', null, 2000, null));
        }
    };
};

var makeMapStateToProps = function makeMapStateToProps(initialState, initialOwnProps) {
    var remove = initialOwnProps.favoritesMode === false ? false : initialState.location.type === _actionTypes.NAVIGATED_TO_LOVED_PATTERNS;
    var sewpatId = (0, _sewpats.getActiveSewpatId)(initialState);
    var mapStateToProps = function mapStateToProps(state, ownProps) {
        var patternid = ownProps.patternid,
            query = ownProps.query,
            type = ownProps.type;

        var iconMore = (0, _i18n.getMessage)(initialState, 'ICON_LABEL_MORE');
        var labelAddToFavorites = (0, _i18n.getMessage)(initialState, 'ICON_LABEL_ADDTOFAVORITES');
        var labelRemoveFromFavorites = (0, _i18n.getMessage)(initialState, 'ICON_LABEL_REMOVE_FROM_FAVORITES');
        var labelColoring = (0, _i18n.getMessage)(initialState, 'ICON_LABEL_COLORING');
        var labelAddToCart = (0, _i18n.getMessage)(initialState, 'ICON_LABEL_ADD_TO_CART');
        var patterns = (0, _patterns.getPatterns)(state);
        var designer = (0, _patterns.getPatternDesigner)(state, patternid);
        var imgSrc = ownProps.imgSrc;
        return {
            type: type,
            pattern: patterns[patternid],
            removeFavorites: remove,
            query: query,
            imgSrc: imgSrc,
            designerName: designer.name,
            sewpatId: sewpatId,
            iconMore: iconMore,
            labelAddToCart: labelAddToCart,
            labelAddToFavorites: labelAddToFavorites,
            labelRemoveFromFavorites: labelRemoveFromFavorites,
            labelColoring: labelColoring
        };
    };
    return mapStateToProps;
};

exports.default = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps)(PatternGalleryAppBar);


(0, _reactIntl.defineMessages)({
    labelMore: {
        id: 'ICON_LABEL_MORE',
        description: 'Label text for more menu icon',
        defaultMessage: 'Mehr'
    },
    snackFavorite: {
        id: 'SNACK_PATTERN_ADDED_TO_FAVORITES',
        description: 'Message to show after a user added a pattern to favorites',
        defaultMessage: 'Motiv in Merkliste gespeichert.'
    },
    labelShare: {
        id: 'ICON_LABEL_SHARE',
        description: 'Label text for share icon',
        defaultMessage: 'Teilen'
    },
    labelAddToFavorites: {
        id: 'ICON_LABEL_ADDTOFAVORITES',
        description: 'Label text for addToFavorites icon',
        defaultMessage: 'Merken'
    },
    labelRemoveFromFavorites: {
        id: 'ICON_LABEL_REMOVE_FROM_FAVORITES',
        description: 'Label text for remove from favorites icon',
        defaultMessage: 'Entfernen'
    },
    labelColoring: {
        id: 'ICON_LABEL_COLORING',
        description: 'Label text for coloring icon',
        defaultMessage: 'Einfärben'
    },
    labelAddToCart: {
        id: 'ICON_LABEL_ADD_TO_CART',
        description: 'Label text for add to cart icon',
        defaultMessage: 'Einpacken'
    }
});

/***/ }),

/***/ "+QDb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _warning = _interopRequireDefault(__webpack_require__("mG8X"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      justifyContent: 'center',
      height: 56,
      backgroundColor: theme.palette.background.paper
    }
  };
};

exports.styles = styles;

function BottomNavigation(props) {
  var childrenProp = props.children,
      classes = props.classes,
      classNameProp = props.className,
      onChange = props.onChange,
      showLabels = props.showLabels,
      value = props.value,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "onChange", "showLabels", "value"]);
  var className = (0, _classnames.default)(classes.root, classNameProp);

  var children = _react.default.Children.map(childrenProp, function (child, childIndex) {
    if (!_react.default.isValidElement(child)) {
      return null;
    }

     false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the BottomNavigation component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
    var childValue = child.props.value === undefined ? childIndex : child.props.value;
    return _react.default.cloneElement(child, {
      selected: childValue === value,
      showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
      value: childValue,
      onChange: onChange
    });
  });

  return _react.default.createElement("div", (0, _extends2.default)({
    className: className
  }, other), children);
}

BottomNavigation.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {any} value We default to the index of the child
   */
  onChange: _propTypes.default.func,

  /**
   * If `true`, all `BottomNavigationAction`s will show their labels.
   * By default, only the selected `BottomNavigationAction` will show its label.
   */
  showLabels: _propTypes.default.bool,

  /**
   * The value of the currently selected `BottomNavigationAction`.
   */
  value: _propTypes.default.any
} : {};
BottomNavigation.defaultProps = {
  showLabels: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiBottomNavigation'
})(BottomNavigation);

exports.default = _default;

/***/ }),

/***/ "+fsC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItem.default;
  }
});

var _ListItem = _interopRequireDefault(__webpack_require__("L4KW"));

/***/ }),

/***/ "0hRY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var _Paper = _interopRequireDefault(__webpack_require__("L4iW"));

var _Typography = _interopRequireDefault(__webpack_require__("ALEy"));

var _colorManipulator = __webpack_require__("1wwW");

// @inheritedComponent Paper
var styles = function styles(theme) {
  var _root;

  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
  var backgroundColor = (0, _colorManipulator.emphasize)(theme.palette.background.default, emphasis);
  return {
    /* Styles applied to the root element. */
    root: (_root = {
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      padding: '6px 24px'
    }, (0, _defineProperty2.default)(_root, theme.breakpoints.up('md'), {
      minWidth: 288,
      maxWidth: 568,
      borderRadius: theme.shape.borderRadius
    }), (0, _defineProperty2.default)(_root, theme.breakpoints.down('sm'), {
      flexGrow: 1
    }), _root),

    /* Styles applied to the message wrapper element. */
    message: {
      padding: '8px 0'
    },

    /* Styles applied to the action wrapper element if `action` is provided. */
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: 24,
      marginRight: -8
    }
  };
};

exports.styles = styles;

function SnackbarContent(props) {
  var action = props.action,
      classes = props.classes,
      className = props.className,
      message = props.message,
      other = (0, _objectWithoutProperties2.default)(props, ["action", "classes", "className", "message"]);
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    component: _Typography.default,
    headlineMapping: {
      body1: 'div'
    },
    role: "alertdialog",
    square: true,
    elevation: 6,
    className: (0, _classnames.default)(classes.root, className)
  }, other), _react.default.createElement("div", {
    className: classes.message
  }, message), action ? _react.default.createElement("div", {
    className: classes.action
  }, action) : null);
}

SnackbarContent.propTypes =  false ? {
  /**
   * The action to display.
   */
  action: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The message to display.
   */
  message: _propTypes.default.node
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSnackbarContent'
})(SnackbarContent);

exports.default = _default;

/***/ }),

/***/ "0yCV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Popover.default;
  }
});

var _Popover = _interopRequireDefault(__webpack_require__("qZFC"));

/***/ }),

/***/ "1A5N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _MenuItem.default;
  }
});

var _MenuItem = _interopRequireDefault(__webpack_require__("O7GD"));

/***/ }),

/***/ "1fQI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = parseRootMargin;
/* harmony export (immutable) */ __webpack_exports__["d"] = shallowCompare;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hasOwnProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return toString; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isChildrenWithRef;
/* harmony export (immutable) */ __webpack_exports__["e"] = thresholdCacheKey;
var _a;
var marginRE = /^-?\d*\.?\d+(px|%)$/;
function parseRootMargin(rootMargin) {
    var marginString = rootMargin ? rootMargin.trim() : '0px';
    var result = marginString.split(/\s+/).map(function (margin) {
        if (!marginRE.test(margin)) {
            throw new Error('rootMargin must be a string literal containing pixels and/or percent values');
        }
        return margin;
    });
    var m0 = result.shift();
    var _a = result[0], m1 = _a === void 0 ? m0 : _a, _b = result[1], m2 = _b === void 0 ? m0 : _b, _c = result[2], m3 = _c === void 0 ? m1 : _c;
    return m0 + " " + m1 + " " + m2 + " " + m3;
}
function shallowCompare(next, prev) {
    if (Array.isArray(next) && Array.isArray(prev)) {
        if (next.length === prev.length) {
            return next.some(function (_, index) { return shallowCompare(next[index], prev[index]); });
        }
    }
    return next !== prev;
}
var hasOwnProperty = (_a = Object.prototype, _a.hasOwnProperty), toString = _a.toString;
function isChildrenWithRef(children) {
    return children && hasOwnProperty.call(children, 'ref');
}
function thresholdCacheKey(threshold) {
    if (!threshold || typeof threshold === 'number') {
        return threshold;
    }
    return threshold.join(',');
}


/***/ }),

/***/ "1k1m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _List.default;
  }
});

var _List = _interopRequireDefault(__webpack_require__("Bj+1"));

/***/ }),

/***/ "1nqX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _Snackbar = __webpack_require__("HH1Q");

var _Snackbar2 = _interopRequireDefault(_Snackbar);

var _reactRedux = __webpack_require__("RH2O");

var _uiActions = __webpack_require__("rj0T");

var _ui = __webpack_require__("T180");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SnackBar = function (_React$Component) {
    _inherits(SnackBar, _React$Component);

    function SnackBar() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SnackBar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SnackBar.__proto__ || Object.getPrototypeOf(SnackBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            snack: null,
            visible: false
        }, _this.showSnack = function (snack) {
            _this.hideSnack().then(function () {
                _this.setState({ snack: snack, visible: false });
                setTimeout(function () {
                    _this.setState({ visible: true });
                    if (snack.autohide) {
                        _this.snackTimer = setTimeout(function () {
                            _this.props.dismissSnack(snack.id);
                        }, snack.autohide);
                    }
                }, 1);
            });
        }, _this.transitionEndHandler = function () {
            if (_this.afterTransition) {
                _this.afterTransition();
                _this.afterTransition = null;
            }
        }, _this.hideSnack = function () {
            if (!_this.state.snack) {
                return Promise.resolve();
            }
            return new Promise(function (resolve) {
                _this.clearDismissTimer();
                _this.setState({ visible: false });
                _this.afterTransition = function () {
                    _this.setState({ snack: null });
                    resolve();
                };
            });
        }, _this.clearDismissTimer = function () {
            if (_this.snackTimer) {
                clearTimeout(_this.snackTimer);
                _this.snackTimer = null;
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SnackBar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.snack) {
                this.showSnack(this.props.snack);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var snack = this.props.snack;
            var nextSnack = nextProps.snack;
            var visibleSnack = this.state.snack;
            var isInactive = this.props.inactive;
            var willInactivate = nextProps.inactive;
            if (!willInactivate && (nextSnack && !snack || nextSnack && nextSnack.id !== (snack || {}).id)) {
                this.showSnack(nextSnack); // Active, and a new snack stands in line in the queue. Show it!
            } else if (isInactive && !willInactivate && snack && !visibleSnack) {
                this.showSnack(snack); // Will be active, and we have a snack. Show it!
            } else if (!isInactive && willInactivate && visibleSnack) {
                this.hideSnack(); // Will deactivate, remove the snack until we become active again
            } else if (!nextSnack && snack) {
                this.hideSnack(); // The current snack has been removed from the queue, no one stands in line. Hide it!
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearDismissTimer();
        }
    }, {
        key: 'render',
        value: function render() {
            var snack = this.state.snack;


            if (!snack) {
                return null;
            }

            // const Action = snack.action || null;

            return _react2.default.createElement(_Snackbar2.default, {
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                onTransitionEnd: this.transitionEndHandler,
                open: this.state.visible,
                onClose: this.hideSnack,
                SnackbarContentProps: {
                    'aria-describedby': 'message-id'
                },
                message: _react2.default.createElement(
                    'span',
                    { id: snack.id },
                    snack.label
                )
            });
        }
    }]);

    return SnackBar;
}(_react2.default.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dismissSnack: function dismissSnack(id) {
            return dispatch((0, _uiActions.dismissSnack)(id));
        }
    };
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        snack: (0, _ui.getPopulatedSnack)(state)
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SnackBar);

/***/ }),

/***/ "2+hv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _categoriestrail = __webpack_require__("mLwN");

var _i18n = __webpack_require__("lg9U");

var _reactRedux = __webpack_require__("RH2O");

var _InternalLink = __webpack_require__("XSs2");

var _InternalLink2 = _interopRequireDefault(_InternalLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CategoriesTrail = function CategoriesTrail(_ref) {
    var trail = _ref.trail,
        title = _ref.title,
        props = _objectWithoutProperties(_ref, ['trail', 'title']);

    var StyledThing = _styledComponents2.default.div.withConfig({
        displayName: 'CategoriesTrail__StyledThing',
        componentId: 'sc-lcpwbn-0'
    })(['\n        font-size: 0.9em;\n        display: flex;\n        flex-wrap: nowrap;\n        flex-direction: row;\n        \n        & .stolo-breadcrumb-item-spacer {\n          color: ', ';\n          padding: 0 ', ';\n        }\n    '], function (props) {
        return props.theme.palette.blueGrey[300];
    }, function (props) {
        return props.theme.space[4];
    });

    var length = trail.length;

    if (length > 0) {
        var items = trail.map(function (location, index) {
            if (index < length - 1) {
                return _react2.default.createElement(
                    'div',
                    { className: 'stolo-breadcrumb-item', key: index },
                    _react2.default.createElement(
                        _InternalLink2.default,
                        _extends({
                            to: { type: location.type, payload: location.payload }
                        }, props),
                        location.title || title
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'stolo-breadcrumb-item-spacer' },
                        '\xBB'
                    )
                );
            }
            // This the last element in the trail. We don't want this to
            // be a link
            return _react2.default.createElement(
                'div',
                { className: 'stolo-breadcrumb-item', key: index },
                location.title
            );
        });

        return _react2.default.createElement(
            StyledThing,
            null,
            items
        );
    }
    return null;
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        trail: (0, _categoriestrail.getCategoriesTrail)(state),
        title: (0, _i18n.getMessage)(state, "TOPCATEGORIES")
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CategoriesTrail);

/***/ }),

/***/ "3efK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _LinearProgress = __webpack_require__("4hEJ");

var _LinearProgress2 = _interopRequireDefault(_LinearProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinearProgress = function LinearProgress() {
    var StyledThing = (0, _styledComponents2.default)(_LinearProgress2.default).withConfig({
        displayName: 'LinearProgress__StyledThing',
        componentId: 'sc-1g4qfai-0'
    })(['\n      margin: ', ' 0;\n    '], function (props) {
        return props.theme.space[10];
    });

    return _react2.default.createElement(StyledThing, null);
};

exports.default = LinearProgress;

/***/ }),

/***/ "3ru4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useIntersectionObserver */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__observer__ = __webpack_require__("XhuR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("1fQI");



var noop = function () { };
/**
 * useIntersectionObserver hook that has almost the same api as <Observer />
 *
 * @param {ChangeHandler} onChange Function that will be invoked whenever the intersection value for this element changes.
 * @param {Options} options Option to customize instersction observer instance or disable it
 *
 * @example
 * const App = () => {
 *   const onChange = ({ isIntersecting }) => console.log({ isIntersecting })
 *   const ref = useIntersectionObserver(onChange)
 *
 *   return <div ref={ref} />
 * }
 */
var useIntersectionObserver = function (
/**
 * Function that will be invoked whenever the intersection value for this element changes.
 */
onChange, _a) {
    var _b = _a === void 0 ? {} : _a, root = _b.root, rootMargin = _b.rootMargin, threshold = _b.threshold, disabled = _b.disabled;
    var observingRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
    var instanceRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({
        // unobserve function needs an instance and instance.handleChange needs an unobserve to be caught by closure.
        // So it's essentially a circular reference that's resolved by assigning handleChange later
        handleChange: function (event) {
            /* istanbul ignore next line */
            onChange(event, noop);
        },
    });
    var unobserve = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        if (instanceRef.current.target && observingRef.current) {
            Object(__WEBPACK_IMPORTED_MODULE_1__observer__["c" /* unobserveElement */])(instanceRef.current, instanceRef.current.target);
            observingRef.current = false;
        }
    }, []);
    instanceRef.current.handleChange = function handleChange(event) {
        /* istanbul ignore next line */
        onChange(event, unobserve);
    };
    var observe = function () {
        if (instanceRef.current.observer &&
            instanceRef.current.target &&
            !observingRef.current) {
            Object(__WEBPACK_IMPORTED_MODULE_1__observer__["b" /* observeElement */])(instanceRef.current);
            observingRef.current = true;
        }
    };
    var memoizedThreshold = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () { return threshold; }, [
        Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* thresholdCacheKey */])(threshold),
    ]);
    var observer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
        if (disabled) {
            unobserve();
            instanceRef.current.observer = undefined;
            return undefined;
        }
        var rootOption = typeof root === 'string' ? document.querySelector(root) : root;
        var obs = Object(__WEBPACK_IMPORTED_MODULE_1__observer__["a" /* createObserver */])({
            root: rootOption,
            rootMargin: rootMargin,
            threshold: memoizedThreshold,
        });
        instanceRef.current.observer = obs;
        unobserve();
        observe();
        return obs;
    }, [root, rootMargin, memoizedThreshold, disabled]);
    var setRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (node) {
        var isNewNode = node != null && instanceRef.current.target !== node;
        if (!observer) {
            unobserve();
        }
        if (isNewNode) {
            unobserve();
            instanceRef.current.target = node;
            observe();
        }
        if (!node) {
            unobserve();
            instanceRef.current.target = undefined;
        }
    }, [observer]);
    return [setRef, unobserve];
};


/***/ }),

/***/ "3sMm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__("HBRR"));

var _createClass2 = _interopRequireDefault(__webpack_require__("ud+X"));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__("rjj8"));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__("X+J+"));

var _inherits2 = _interopRequireDefault(__webpack_require__("ymoH"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _Transition = _interopRequireDefault(__webpack_require__("TAxY"));

var _transitions = __webpack_require__("z+QM");

var _withTheme = _interopRequireDefault(__webpack_require__("MDtq"));

var _utils = __webpack_require__("T1RF");

// @inheritedComponent Transition
var styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
/**
 * The Fade transition is used by the [Modal](/utils/modal) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Fade, _React$Component);

  function Fade() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Fade);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Fade)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleEnter = function (node) {
      var theme = _this.props.theme;
      (0, _utils.reflow)(node); // So the animation always start from the start.

      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
      node.style.transition = theme.transitions.create('opacity', transitionProps);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleExit = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
      node.style.transition = theme.transitions.create('opacity', transitionProps);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Fade, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onEnter = _this$props.onEnter,
          onExit = _this$props.onExit,
          styleProp = _this$props.style,
          theme = _this$props.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "onEnter", "onExit", "style", "theme"]);
      var style = (0, _extends2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        appear: true,
        onEnter: this.handleEnter,
        onExit: this.handleExit
      }, other), function (state, childProps) {
        return _react.default.cloneElement(children, (0, _extends2.default)({
          style: (0, _extends2.default)({
            opacity: 0,
            willChange: 'opacity'
          }, styles[state], style)
        }, childProps));
      });
    }
  }]);
  return Fade;
}(_react.default.Component);

Fade.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : {};
Fade.defaultProps = {
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withTheme.default)()(Fade);

exports.default = _default;

/***/ }),

/***/ "3yX0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Menu = __webpack_require__("BAI3");

var _Menu2 = _interopRequireDefault(_Menu);

var _MenuItem = __webpack_require__("1A5N");

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _queryString = __webpack_require__("OAwv");

var _queryString2 = _interopRequireDefault(_queryString);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _uiActions = __webpack_require__("rj0T");

var _i18n = __webpack_require__("lg9U");

var _page = __webpack_require__("4f5n");

var _ActionableIcon = __webpack_require__("uX6S");

var _ActionableIcon2 = _interopRequireDefault(_ActionableIcon);

var _Icon = __webpack_require__("PlKq");

var _Icon2 = _interopRequireDefault(_Icon);

var _PinterestIcon = __webpack_require__("OhP/");

var _PinterestIcon2 = _interopRequireDefault(_PinterestIcon);

var _FlatInputShareMenu = __webpack_require__("AuuR");

var _FlatInputShareMenu2 = _interopRequireDefault(_FlatInputShareMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO Merge with PinterestButton.

var PatternGalleryActionBarMenu = function (_React$Component) {
    _inherits(PatternGalleryActionBarMenu, _React$Component);

    function PatternGalleryActionBarMenu() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PatternGalleryActionBarMenu);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PatternGalleryActionBarMenu.__proto__ || Object.getPrototypeOf(PatternGalleryActionBarMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            anchorEl: null,
            open: false
        }, _this.handleClick = function (event) {
            _this.setState({
                open: true,
                anchorEl: event.currentTarget
            });
        }, _this.handleRequestClose = function () {
            _this.setState({
                open: false,
                anchorEl: null
            });
        }, _this.handleNavigationToPattern = function () {
            _this.props.navigateToPattern();
        }, _this.button = null, _this.pinProps = {
            name: 'icon-pinterest2',
            width: '1.3em',
            height: '1.3em',
            iconColor: 'blueGrey.700'
        }, _this.linkProps = {
            name: 'icon-link',
            width: '1.4em',
            height: '1.2em',
            iconColor: 'blueGrey.700'
        }, _this.onCopyClick = function () {
            if (_this.input && _this.input.select) {
                // select text
                _this.input.select();
                try {
                    // copy text
                    document.execCommand('copy');
                    _this.input.blur();
                } catch (err) {
                    alert('please press Ctrl/Cmd+C to copy');
                }
            }
            _this.props.showSavedToClipBoard(Date.now());
            _this.handleRequestClose();
        }, _this.getUri = function () {
            var uri = _this.props.shareBaseUri;
            uri = uri + '/schnoff/' + _this.props.sewpatId + '/' + _this.props.pattern.id;
            if (_this.props.query) {
                var query = _queryString2.default.stringify(_this.props.query);
                if (query.length > 0) {
                    uri = uri + '?' + query;
                }
            }
            return uri;
        }, _this.getMedia = function () {
            return _this.props.imgSrc || (((_this.props.pattern || {}).thumbnails || {}).xlargeDiscreet || {}).url;
        }, _this.getDescription = function () {
            var pattern = _this.props.pattern;
            var description = _this.props.sharePinterestPrefix + ' | ' + pattern.title + ': ' + pattern.description;
            return description;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PatternGalleryActionBarMenu, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var StyledMenuText = _styledComponents2.default.span.withConfig({
                displayName: 'PatternGalleryActionBarMenu__StyledMenuText',
                componentId: 'sc-1fw7yt3-0'
            })(['\n          margin-left: ', ';\n        '], function (props) {
                return props.theme.space[5];
            });

            var StyledMenuIcon = (0, _styledComponents2.default)(_Icon2.default).withConfig({
                displayName: 'PatternGalleryActionBarMenu__StyledMenuIcon',
                componentId: 'sc-1fw7yt3-1'
            })(['\n            &.stolo-appbar-menu {\n              margin: 0;\n            }\n        ']);

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    {
                        id: this.props.pattern.id,
                        key: this.props.pattern.id,
                        onClick: this.state.open ? null : this.handleClick
                    },
                    _react2.default.createElement(_ActionableIcon2.default, {
                        iconProps: {
                            name: 'icon-more_vert',
                            height: '1.75rem',
                            iconColor: 'blueGrey.700'
                        },
                        handleClick: function handleClick() {}
                    })
                ),
                _react2.default.createElement(
                    _Menu2.default,
                    {
                        id: 'simple-menu',
                        anchorEl: this.state.anchorEl,
                        open: this.state.open,
                        onClose: this.handleRequestClose
                    },
                    _react2.default.createElement(
                        _MenuItem2.default,
                        { onClick: this.handleRequestClose },
                        _react2.default.createElement(_PinterestIcon2.default, {
                            iconProps: this.pinProps,
                            buttonText: this.props.sharePinterestLabel,
                            shareTarget: this.getUri(),
                            media: this.getMedia(),
                            description: this.getDescription()
                        })
                    ),
                    _react2.default.createElement(
                        _MenuItem2.default,
                        {
                            component: 'div',
                            ref: function ref(element) {
                                _this2.button = element;
                            }, onClick: this.onCopyClick
                        },
                        _react2.default.createElement(
                            _FlatInputShareMenu2.default,
                            null,
                            _react2.default.createElement(_Icon2.default, this.linkProps),
                            ' ',
                            this.props.shareLinkLabel,
                            _react2.default.createElement('input', {
                                ref: function ref(element) {
                                    _this2.input = element;
                                },
                                type: 'text',
                                value: this.getUri(),
                                readOnly: true
                            })
                        )
                    ),
                    _react2.default.createElement(
                        _MenuItem2.default,
                        { onClick: this.handleNavigationToPattern },
                        _react2.default.createElement(StyledMenuIcon, {
                            className: 'stolo-appbar-menu', name: 'icon-palette',
                            width: '1.5rem', height: '1.5rem',
                            iconColor: 'blueGrey.700'
                        }),
                        _react2.default.createElement(
                            StyledMenuText,
                            null,
                            this.props.labelColoring
                        )
                    )
                )
            );
        }
    }]);

    return PatternGalleryActionBarMenu;
}(_react2.default.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        showSavedToClipBoard: function showSavedToClipBoard(id) {
            return dispatch((0, _uiActions.showSnack)(id, 'SNACK_LINK_COPIED_TO_CLIPBOARD', null, 3000, null));
        }
    };
};

var makeMapStateToProps = function makeMapStateToProps(initialState, initialOwnProps) {
    var sharePinterestLabel = (0, _i18n.getMessage)(initialState, 'SHARE_ON_PINTEREST_BUTTON_LABEL');
    var sharePinterestPrefix = (0, _i18n.getMessage)(initialState, 'SHARE_ON_PINTEREST_DEFAULT_PREFIX');
    var shareMenuLabel = (0, _i18n.getMessage)(initialState, 'ICON_LABEL_SHARE');
    var shareLinkLabel = (0, _i18n.getMessage)(initialState, initialOwnProps.messageId || 'SHARE_COPY_LINK_BUTTON_LABEL');
    var labelColoring = (0, _i18n.getMessage)(initialState, 'ICON_LABEL_COLORING');
    var mapStateToProps = function mapStateToProps(state) {
        return _extends({
            sharePinterestLabel: sharePinterestLabel,
            sharePinterestPrefix: sharePinterestPrefix,
            shareLinkLabel: shareLinkLabel,
            shareMenuLabel: shareMenuLabel,
            labelColoring: labelColoring,
            shareBaseUri: (0, _page.getCurrentBaseUri)(state)
        }, initialOwnProps);
    };
    return mapStateToProps;
};

PatternGalleryActionBarMenu.propTypes = {
    pattern: _propTypes2.default.object.required,
    imgSrc: _propTypes2.default.string,
    shareBaseUri: _propTypes2.default.string,
    navigateToPattern: _propTypes2.default.func.required,
    showSavedToClipBoard: _propTypes2.default.func,
    sharePinterestLabel: _propTypes2.default.string,
    sharePinterestPrefix: _propTypes2.default.string,
    shareLinkLabel: _propTypes2.default.string,
    shareMenuLabel: _propTypes2.default.string,
    labelColoring: _propTypes2.default.string,
    labelSelectFabric: _propTypes2.default.string,
    query: _propTypes2.default.object
};

exports.default = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps)(PatternGalleryActionBarMenu);

/***/ }),

/***/ "6Gx2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _BottomNavigation.default;
  }
});

var _BottomNavigation = _interopRequireDefault(__webpack_require__("+QDb"));

/***/ }),

/***/ "6aW6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";



/***/ }),

/***/ "7ICJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function unsupportedProp(props, propName, componentName, location, propFullName) {
  /* istanbul ignore if */
  if (true) {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The property `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}

var _default = unsupportedProp;
exports.default = _default;

/***/ }),

/***/ "7Tur":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.removeFromFavorites = exports.addToFavorites = undefined;

var _actionTypes = __webpack_require__("EA8k");

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Dispatches the Added to favorites action with
 * current date attached.
 *
 * @param patternid
 * @returns {function(*)}
 */
var addToFavorites = exports.addToFavorites = function addToFavorites(patternid, sewpatId, query) {
    return {
        type: types.ADDED_TO_FAVORITES,
        patternid: patternid,
        sewpatId: sewpatId,
        query: query || {},
        date: Date.now()
    };
}; /**
    * Created by ok on 7/14/17.
    */
var removeFromFavorites = exports.removeFromFavorites = function removeFromFavorites(patternid, sewpatId) {
    var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return {
        type: types.REMOVED_FROM_FAVORITES,
        patternid: patternid,
        sewpatId: sewpatId,
        query: query
    };
};

/***/ }),

/***/ "7shp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BottomNavigation = __webpack_require__("6Gx2");

var _BottomNavigation2 = _interopRequireDefault(_BottomNavigation);

var _BottomNavigationAction = __webpack_require__("jaTo");

var _BottomNavigationAction2 = _interopRequireDefault(_BottomNavigationAction);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Icon = __webpack_require__("PlKq");

var _Icon2 = _interopRequireDefault(_Icon);

var _SnackBar = __webpack_require__("1nqX");

var _SnackBar2 = _interopRequireDefault(_SnackBar);

var _IconText = __webpack_require__("lyam");

var _IconText2 = _interopRequireDefault(_IconText);

var _PatternGalleryActionBarMenu = __webpack_require__("3yX0");

var _PatternGalleryActionBarMenu2 = _interopRequireDefault(_PatternGalleryActionBarMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = (0, _styledComponents2.default)(_BottomNavigation2.default).withConfig({
    displayName: 'PatternGalleryBarSmall__ActionBar',
    componentId: 'sc-1tyd65q-0'
})(['\n\n    &.schnoffle-patterngallery-small {\n      height: 3rem;\n      position: relative;\n    }\n\n    & span {\n      line-height: 1;\n      font-size: 0.8rem;\n    }\n']);

var StyledMoreButton = (0, _styledComponents2.default)(_BottomNavigationAction2.default).withConfig({
    displayName: 'PatternGalleryBarSmall__StyledMoreButton',
    componentId: 'sc-1tyd65q-1'
})(['\n    padding-top: 0px;\n']);

var PatternGalleryBarSmall = function PatternGalleryBarSmall(_ref) {
    var iconMore = _ref.iconMore,
        labelAddToCart = _ref.labelAddToCart,
        labelAddToFavorites = _ref.labelAddToFavorites,
        labelRemoveFromFavorites = _ref.labelRemoveFromFavorites,
        labelColoring = _ref.labelColoring,
        pattern = _ref.pattern,
        addToFavorites = _ref.addToFavorites,
        removeFromFavorites = _ref.removeFromFavorites,
        goToPattern = _ref.goToPattern,
        removeFavorites = _ref.removeFavorites,
        query = _ref.query,
        showAddedToFavorites = _ref.showAddedToFavorites,
        imgSrc = _ref.imgSrc,
        sewpatId = _ref.sewpatId;

    var handleAddToFavorites = function handleAddToFavorites() {
        addToFavorites(pattern.id);
        showAddedToFavorites(Date.now());
    };

    var handleRemoveFromFavorites = function handleRemoveFromFavorites() {
        removeFromFavorites(pattern.id, sewpatId, query);
    };

    var handleGoToPattern = function handleGoToPattern() {
        goToPattern(pattern.id, sewpatId, query);
    };

    var FavoritesAction = function FavoritesAction() {
        if (removeFavorites !== true) {
            return _react2.default.createElement(_BottomNavigationAction2.default, {
                onClick: handleAddToFavorites,
                label: _react2.default.createElement(
                    _IconText2.default,
                    null,
                    labelAddToFavorites
                ),
                value: 'addtofavorite',
                icon: _react2.default.createElement(_Icon2.default, {
                    name: 'icon-heartadd',
                    width: '1.5rem',
                    height: '1.5rem',
                    iconColor: 'blueGrey.700'
                })
            });
        }
        return _react2.default.createElement(_BottomNavigationAction2.default, {
            onClick: handleRemoveFromFavorites,
            label: _react2.default.createElement(
                _IconText2.default,
                null,
                labelRemoveFromFavorites
            ),
            value: 'removefavorite',
            icon: _react2.default.createElement(_Icon2.default, {
                name: 'icon-heartremove',
                width: '1.5rem',
                height: '1.5rem',
                iconColor: 'blueGrey.700'
            })
        });
    };

    return _react2.default.createElement(
        ActionBar,
        {
            className: 'schnoffle-patterngallery-small',
            showLabels: true,
            value: 'null'
        },
        FavoritesAction(),
        _react2.default.createElement(StyledMoreButton, {
            value: 'more', icon: _react2.default.createElement(_PatternGalleryActionBarMenu2.default, {
                patternid: pattern.id,
                label: iconMore,
                navigateToPattern: handleGoToPattern,
                addToFavorites: handleAddToFavorites,
                pattern: pattern,
                query: query,
                imgSrc: imgSrc,
                sewpatId: sewpatId,
                labelAddToCart: labelAddToCart
            }), component: 'div'
        }),
        _react2.default.createElement(_SnackBar2.default, null)
    );
};

exports.default = PatternGalleryBarSmall;

/***/ }),

/***/ "8/ml":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Heading = __webpack_require__("6GnX");

var _Heading2 = _interopRequireDefault(_Heading);

var _HorizontalDivider = __webpack_require__("SZDM");

var _HorizontalDivider2 = _interopRequireDefault(_HorizontalDivider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Text = function Text(_ref) {
    var colored = _ref.colored,
        children = _ref.children,
        className = _ref.className,
        margin = _ref.margin,
        left = _ref.left;

    var OuterTextContainer = _styledComponents2.default.div.withConfig({
        displayName: 'Text__OuterTextContainer',
        componentId: 'sc-89ig1k-0'
    })(['\n        background-color: ', ';\n        margin: ', ';\n    '], function (props) {
        return colored ? props.theme.palette.secondary.A200 : 'transparent';
    }, margin || '0');

    var InnerTextContainer = _styledComponents2.default.div.withConfig({
        displayName: 'Text__InnerTextContainer',
        componentId: 'sc-89ig1k-1'
    })(['\n        max-width: 66ch;\n        padding: ', ' ', ' ', ' ', ';\n        margin: ', ';\n    '], function (props) {
        return props.theme.space[5];
    }, function (props) {
        return props.theme.space[8];
    }, function (props) {
        return props.theme.space[5];
    }, function (props) {
        return props.theme.space[10];
    }, left ? '0' : '0 auto');

    return _react2.default.createElement(
        OuterTextContainer,
        { className: className },
        _react2.default.createElement(
            InnerTextContainer,
            null,
            children
        )
    );
};

Text.Heading = _Heading2.default;
Text.Divider = _HorizontalDivider2.default;

exports.default = Text;

/***/ }),

/***/ "8UK+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;
var BLACKLIST = ['template', 'script', 'style'];

function isHidable(node) {
  return node.nodeType === 1 && BLACKLIST.indexOf(node.tagName.toLowerCase()) === -1;
}

function siblings(container, mount, callback) {
  mount = [].concat(mount); // eslint-disable-line no-param-reassign

  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      callback(node);
    }
  });
}

function ariaHidden(show, node) {
  if (!node) {
    return;
  }

  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),

/***/ "ALEy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Typography.default;
  }
});

var _Typography = _interopRequireDefault(__webpack_require__("eudt"));

/***/ }),

/***/ "AuuR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.div.withConfig({
    displayName: 'FlatInputShareMenu',
    componentId: 'sc-kfsff0-0'
})(['\n\n    cursor: copy;\n    padding-top: 0.5em;\n        \n    & input {\n        border: none;\n        color: ', ';\n        font-size: ', ';\n        display: block;\n        background: transparent;\n\n        &:focus,\n        &:active\n        {\n          border: none;\n        }\n    }\n    '], function (props) {
    return props.theme.palette.blueGrey[700];
}, function (props) {
    return props.theme.fontSizes[6];
});

/***/ }),

/***/ "BAI3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Menu.default;
  }
});

var _Menu = _interopRequireDefault(__webpack_require__("ygcc"));

/***/ }),

/***/ "Biqn":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("fKPv");
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }
  return target;
}
module.exports = _objectSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "Bj+1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__("HBRR"));

var _createClass2 = _interopRequireDefault(__webpack_require__("ud+X"));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__("rjj8"));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__("X+J+"));

var _inherits2 = _interopRequireDefault(__webpack_require__("ymoH"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var styles = {
  /* Styles applied to the root element. */
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative'
  },

  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },

  /* Styles applied to the root element if `dense={true}` & `disablePadding={false}`. */
  dense: {
    paddingTop: 4,
    paddingBottom: 4
  },

  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
};
exports.styles = styles;

var List =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(List, _React$Component);

  function List() {
    (0, _classCallCheck2.default)(this, List);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(List).apply(this, arguments));
  }

  (0, _createClass2.default)(List, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        dense: this.props.dense
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          children = _this$props.children,
          classes = _this$props.classes,
          classNameProp = _this$props.className,
          Component = _this$props.component,
          dense = _this$props.dense,
          disablePadding = _this$props.disablePadding,
          subheader = _this$props.subheader,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.dense, dense && !disablePadding), (0, _defineProperty2.default)(_classNames, classes.padding, !disablePadding), (0, _defineProperty2.default)(_classNames, classes.subheader, subheader), _classNames), classNameProp);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: className
      }, other), subheader, children);
    }
  }]);
  return List;
}(_react.default.Component);

List.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items. The property is available to descendant components as the
   * `dense` context.
   */
  dense: _propTypes.default.bool,

  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: _propTypes.default.bool,

  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: _propTypes.default.node
} : {};
List.defaultProps = {
  component: 'ul',
  dense: false,
  disablePadding: false
};
List.childContextTypes = {
  dense: _propTypes.default.bool
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiList'
})(List);

exports.default = _default;

/***/ }),

/***/ "ChDW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("R6lU");

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__("gBd0"));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),

/***/ "CxMQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBody = isBody;
exports.default = isOverflowing;

var _isWindow = _interopRequireDefault(__webpack_require__("PuVx"));

var _ownerDocument = _interopRequireDefault(__webpack_require__("2BhH"));

var _ownerWindow = _interopRequireDefault(__webpack_require__("3zl2"));

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
} // Do we have a scroll bar?


function isOverflowing(container) {
  var doc = (0, _ownerDocument.default)(container);
  var win = (0, _ownerWindow.default)(doc);
  /* istanbul ignore next */

  if (!(0, _isWindow.default)(doc) && !isBody(container)) {
    return container.scrollHeight > container.clientHeight;
  } // Takes in account potential non zero margin on the body.


  var style = win.getComputedStyle(doc.body);
  var marginLeft = parseInt(style.getPropertyValue('margin-left'), 10);
  var marginRight = parseInt(style.getPropertyValue('margin-right'), 10);
  return marginLeft + doc.body.clientWidth + marginRight < win.innerWidth;
}

/***/ }),

/***/ "D1TY":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("twsF")();
}


/***/ }),

/***/ "DBHA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),

/***/ "DhMB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _PaginationButton = __webpack_require__("WkCf");

var _PaginationButton2 = _interopRequireDefault(_PaginationButton);

var _PaginationIcon = __webpack_require__("hhcd");

var _PaginationIcon2 = _interopRequireDefault(_PaginationIcon);

var _PaginationWrapper = __webpack_require__("YP5e");

var _PaginationWrapper2 = _interopRequireDefault(_PaginationWrapper);

var _PaginationFiller = __webpack_require__("Kqdu");

var _PaginationFiller2 = _interopRequireDefault(_PaginationFiller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateKey = function generateKey(pre) {
    return pre + '_' + new Date().getTime();
};

var Pagination = function Pagination(_ref) {
    var currentPage = _ref.currentPage,
        pageCount = _ref.pageCount,
        displayLimit = _ref.displayLimit,
        handleSetPage = _ref.handleSetPage;

    var isLast = currentPage === pageCount;
    var isActive = function isActive(page) {
        return page === currentPage;
    };

    // Ensure we have at least one page to show. One number and two fillers.
    var displayPages = Math.max(1, displayLimit);

    // Don't brake the app, but log the error.
    if (currentPage > pageCount) {
        console.error('Current page number exceeds total pages.');
        return _react2.default.createElement(
            'div',
            { className: 'stolo-hidden' },
            'PAGINATION BROKEN'
        );
    }

    var handleNext = function handleNext() {
        console.info('Current page %s.', currentPage);
        handleSetPage(currentPage + 1);
    };
    var handlePrev = function handlePrev() {
        return handleSetPage(currentPage - 1);
    };

    var displayAll = false;
    var displayFirstFiller = false;
    var displayLastFiller = false;
    var min = void 0;
    var max = void 0;

    if (pageCount <= displayPages) {
        displayAll = true;
        min = 2;
        max = pageCount - 1;
    }

    if (pageCount > displayPages) {
        var remaining = pageCount - currentPage;

        min = currentPage - Math.floor(displayPages * 0.5);
        max = currentPage + Math.floor(displayPages * 0.5) || pageCount - 1;

        // We start at a minimum from 2. Put any difference in containters (displayPages) to the right side.
        if (min <= 2) {
            max = Math.max(max + min, displayPages);
            min = 2;
        }

        // We stop at totalPages -1. Put any remaining to the left.
        if (max > pageCount - 1) {
            min = Math.min(min - remaining, min - max + pageCount + 1);
            max = pageCount - 1;
        }

        displayFirstFiller = remaining === 0 || min > 2;
        displayLastFiller = max < pageCount - 1;
    }

    var buildItems = function buildItems() {
        var items = [];

        items[0] = _react2.default.createElement(_PaginationIcon2.default, {
            direction: 'left',
            disabled: isActive(1),
            handleClick: handlePrev,
            key: generateKey('left')
        });

        items[1] = _react2.default.createElement(_PaginationButton2.default, {
            pageNumber: 1, handleClick: function handleClick() {
                return handleSetPage(1);
            },
            key: generateKey('first'), disabled: isActive(1)
        });

        if (pageCount > 1) {
            if (pageCount > 2) {
                if (!displayAll && displayFirstFiller) {
                    items.push(_react2.default.createElement(_PaginationFiller2.default, { key: generateKey('filler1') }));
                }

                var _loop = function _loop(i) {
                    items.push(_react2.default.createElement(_PaginationButton2.default, {
                        pageNumber: i,
                        handleClick: function handleClick() {
                            return handleSetPage(i);
                        },
                        key: generateKey(i),
                        disabled: isActive(i)
                    }));
                };

                for (var i = min; i <= max; i++) {
                    _loop(i);
                }
                if (!displayAll && displayLastFiller) {
                    items.push(_react2.default.createElement(_PaginationFiller2.default, { key: generateKey('filler2') }));
                }
            }

            items.push(_react2.default.createElement(_PaginationButton2.default, {
                pageNumber: pageCount,
                handleClick: function handleClick() {
                    return handleSetPage(pageCount);
                },
                key: generateKey('last'),
                disabled: isLast
            }));
        }

        items.push(_react2.default.createElement(_PaginationIcon2.default, {
            direction: 'right',
            disabled: isLast,
            handleClick: handleNext,
            key: generateKey('right')
        }));

        return items;
    };

    return _react2.default.createElement(_PaginationWrapper2.default, { key: generateKey('pager'), items: buildItems() });
};

exports.default = Pagination;

/***/ }),

/***/ "ExK/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Picture = function Picture(_ref) {
    var src = _ref.src,
        webp = _ref.webp,
        altText = _ref.altText,
        png = _ref.png,
        gif = _ref.gif;

    var StyledImage = _styledComponents2.default.img.withConfig({
        displayName: 'Picture__StyledImage',
        componentId: 'sc-sjj3zq-0'
    })(['\n        height: auto;\n        width: auto;\n        max-width: 100%;\n    ']);

    return _react2.default.createElement(
        'picture',
        null,
        webp ? _react2.default.createElement('source', { srcSet: webp, type: 'image/webp' }) : null,
        gif ? _react2.default.createElement('source', { srcSet: gif, type: 'image/gif' }) : null,
        _react2.default.createElement(StyledImage, { src: src, alt: altText || 'image' })
    );
};

exports.default = Picture;

/***/ }),

/***/ "Ga6y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeRootMargin;
/* harmony export (immutable) */ __webpack_exports__["c"] = getItemCount;
/* harmony export (immutable) */ __webpack_exports__["b"] = computeSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__("rkok");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);

function computeRootMargin(_ref) {
  var threshold = _ref.threshold,
      axis = _ref.axis;
  var margins = [threshold];
  var unit = threshold.match(/^-?\d*\.?\d+(px|%)$/) || [''];
  var value = "0" + unit.pop();

  if (axis === 'y') {
    margins.push(value);
  } else {
    margins.unshift(value);
  }

  return margins.join(' ');
}
function getItemCount(_ref2, warnIfConflict) {
  var itemCount = _ref2.itemCount,
      items = _ref2.items;
  var hasItemCount = typeof itemCount !== 'undefined';
  var hasItems = typeof items !== 'undefined';
  var defaultValue = 0;

  if (warnIfConflict) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(hasItemCount && hasItems), 'ReactIntersectionList: cannot use itemCount and items props at the same time, choose one to determine the number of items to render.');
  }

  if (hasItemCount) {
    return itemCount;
  }

  return hasItems ? items.length || items.size || defaultValue : defaultValue;
}
function computeSize(pageSize, itemCount) {
  return Math.max(0, Math.min(pageSize, itemCount));
}

/***/ }),

/***/ "GhsM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__("HBRR"));

var _createClass2 = _interopRequireDefault(__webpack_require__("ud+X"));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__("rjj8"));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__("X+J+"));

var _inherits2 = _interopRequireDefault(__webpack_require__("ymoH"));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__("n9va"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _reactDom = _interopRequireDefault(__webpack_require__("O27J"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _warning = _interopRequireDefault(__webpack_require__("mG8X"));

var _keycode = _interopRequireDefault(__webpack_require__("ljAp"));

var _ownerDocument = _interopRequireDefault(__webpack_require__("2BhH"));

var _RootRef = _interopRequireDefault(__webpack_require__("URv/"));

var _Portal = _interopRequireDefault(__webpack_require__("kgLe"));

var _helpers = __webpack_require__("QbVD");

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var _ModalManager = _interopRequireDefault(__webpack_require__("qSSY"));

var _Backdrop = _interopRequireDefault(__webpack_require__("x3fr"));

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom.default.findDOMNode(container) || defaultContainer;
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },

    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: 'hidden'
    }
  };
};
/* istanbul ignore if */


exports.styles = styles;

if (false) {
  throw new Error('Material-UI: react@16.3.0 or greater is required.');
}
/**
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */


var Modal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Modal, _React$Component);

  function Modal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Modal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Modal).call(this));
    _this.mountNode = null;
    _this.modalRef = null;
    _this.dialogRef = null;
    _this.mounted = false;

    _this.handleRendered = function () {
      _this.autoFocus(); // Fix a bug on Chrome where the scroll isn't initially 0.


      _this.modalRef.scrollTop = 0;

      if (_this.props.onRendered) {
        _this.props.onRendered();
      }
    };

    _this.handleOpen = function () {
      var doc = (0, _ownerDocument.default)(_this.mountNode);
      var container = getContainer(_this.props.container, doc.body);

      _this.props.manager.add((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), container);

      doc.addEventListener('keydown', _this.handleDocumentKeyDown);
      doc.addEventListener('focus', _this.enforceFocus, true);
    };

    _this.handleClose = function () {
      _this.props.manager.remove((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));

      var doc = (0, _ownerDocument.default)(_this.mountNode);
      doc.removeEventListener('keydown', _this.handleDocumentKeyDown);
      doc.removeEventListener('focus', _this.enforceFocus, true);

      _this.restoreLastFocus();
    };

    _this.handleExited = function () {
      _this.setState({
        exited: true
      });

      _this.handleClose();
    };

    _this.handleBackdropClick = function (event) {
      if (event.target !== event.currentTarget) {
        return;
      }

      if (_this.props.onBackdropClick) {
        _this.props.onBackdropClick(event);
      }

      if (!_this.props.disableBackdropClick && _this.props.onClose) {
        _this.props.onClose(event, 'backdropClick');
      }
    };

    _this.handleDocumentKeyDown = function (event) {
      if (!_this.isTopModal() || (0, _keycode.default)(event) !== 'esc') {
        return;
      } // Ignore events that have been `event.preventDefault()` marked.


      if (event.defaultPrevented) {
        return;
      }

      if (_this.props.onEscapeKeyDown) {
        _this.props.onEscapeKeyDown(event);
      }

      if (!_this.props.disableEscapeKeyDown && _this.props.onClose) {
        _this.props.onClose(event, 'escapeKeyDown');
      }
    };

    _this.checkForFocus = function () {
      _this.lastFocus = (0, _ownerDocument.default)(_this.mountNode).activeElement;
    };

    _this.enforceFocus = function () {
      if (_this.props.disableEnforceFocus || !_this.mounted || !_this.isTopModal()) {
        return;
      }

      var currentActiveElement = (0, _ownerDocument.default)(_this.mountNode).activeElement;

      if (_this.dialogRef && !_this.dialogRef.contains(currentActiveElement)) {
        _this.dialogRef.focus();
      }
    };

    _this.state = {
      exited: !props.open
    };
    return _this;
  }

  (0, _createClass2.default)(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;

      if (this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.open && this.props.open) {
        this.checkForFocus();
      }

      if (prevProps.open && !this.props.open && !getHasTransition(this.props)) {
        // Otherwise handleExited will call this.
        this.handleClose();
      } else if (!prevProps.open && this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;

      if (this.props.open || getHasTransition(this.props) && !this.state.exited) {
        this.handleClose();
      }
    }
  }, {
    key: "autoFocus",
    value: function autoFocus() {
      if (this.props.disableAutoFocus) {
        return;
      }

      var currentActiveElement = (0, _ownerDocument.default)(this.mountNode).activeElement;

      if (this.dialogRef && !this.dialogRef.contains(currentActiveElement)) {
        this.lastFocus = currentActiveElement;

        if (!this.dialogRef.hasAttribute('tabIndex')) {
           false ? (0, _warning.default)(false, ['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n')) : void 0;
          this.dialogRef.setAttribute('tabIndex', -1);
        }

        this.dialogRef.focus();
      }
    }
  }, {
    key: "restoreLastFocus",
    value: function restoreLastFocus() {
      if (this.props.disableRestoreFocus) {
        return;
      }

      if (this.lastFocus) {
        // Not all elements in IE11 have a focus method.
        // Because IE11 market share is low, we accept the restore focus being broken
        // and we silent the issue.
        if (this.lastFocus.focus) {
          this.lastFocus.focus();
        }

        this.lastFocus = null;
      }
    }
  }, {
    key: "isTopModal",
    value: function isTopModal() {
      return this.props.manager.isTopModal(this);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          BackdropComponent = _this$props.BackdropComponent,
          BackdropProps = _this$props.BackdropProps,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          container = _this$props.container,
          disableAutoFocus = _this$props.disableAutoFocus,
          disableBackdropClick = _this$props.disableBackdropClick,
          disableEnforceFocus = _this$props.disableEnforceFocus,
          disableEscapeKeyDown = _this$props.disableEscapeKeyDown,
          disablePortal = _this$props.disablePortal,
          disableRestoreFocus = _this$props.disableRestoreFocus,
          hideBackdrop = _this$props.hideBackdrop,
          keepMounted = _this$props.keepMounted,
          manager = _this$props.manager,
          onBackdropClick = _this$props.onBackdropClick,
          onClose = _this$props.onClose,
          onEscapeKeyDown = _this$props.onEscapeKeyDown,
          onRendered = _this$props.onRendered,
          open = _this$props.open,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["BackdropComponent", "BackdropProps", "children", "classes", "className", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);
      var exited = this.state.exited;
      var hasTransition = getHasTransition(this.props);
      var childProps = {};

      if (!keepMounted && !open && (!hasTransition || exited)) {
        return null;
      } // It's a Transition like component


      if (hasTransition) {
        childProps.onExited = (0, _helpers.createChainedFunction)(this.handleExited, children.props.onExited);
      }

      if (children.props.role === undefined) {
        childProps.role = children.props.role || 'document';
      }

      if (children.props.tabIndex === undefined) {
        childProps.tabIndex = children.props.tabIndex || '-1';
      }

      return _react.default.createElement(_Portal.default, {
        ref: function ref(_ref2) {
          _this2.mountNode = _ref2 ? _ref2.getMountNode() : _ref2;
        },
        container: container,
        disablePortal: disablePortal,
        onRendered: this.handleRendered
      }, _react.default.createElement("div", (0, _extends2.default)({
        ref: function ref(_ref) {
          _this2.modalRef = _ref;
        },
        className: (0, _classnames.default)(classes.root, className, (0, _defineProperty2.default)({}, classes.hidden, exited))
      }, other), hideBackdrop ? null : _react.default.createElement(BackdropComponent, (0, _extends2.default)({
        open: open,
        onClick: this.handleBackdropClick
      }, BackdropProps)), _react.default.createElement(_RootRef.default, {
        rootRef: function rootRef(ref) {
          _this2.dialogRef = ref;
        }
      }, _react.default.cloneElement(children, childProps))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.open) {
        return {
          exited: false
        };
      }

      if (!getHasTransition(nextProps)) {
        // Otherwise let handleExited take care of marking exited.
        return {
          exited: true
        };
      }

      return null;
    }
  }]);
  return Modal;
}(_react.default.Component);

Modal.propTypes =  false ? {
  /**
   * A backdrop component. This property enables custom backdrop rendering.
   */
  BackdropComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Properties applied to the [`Backdrop`](/api/backdrop) element.
   */
  BackdropProps: _propTypes.default.object,

  /**
   * A single child content element.
   */
  children: _propTypes.default.element,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: _propTypes.default.bool,

  /**
   * If `true`, clicking the backdrop will not fire any callback.
   */
  disableBackdropClick: _propTypes.default.bool,

  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: _propTypes.default.bool,

  /**
   * If `true`, hitting escape will not fire any callback.
   */
  disableEscapeKeyDown: _propTypes.default.bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes.default.bool,

  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: _propTypes.default.bool,

  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: _propTypes.default.bool,

  /**
   * Always keep the children in the DOM.
   * This property can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */
  keepMounted: _propTypes.default.bool,

  /**
   * A modal manager used to track and manage the state of open
   * Modals. This enables customizing how modals interact within a container.
   */
  manager: _propTypes.default.object,

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes.default.func,

  /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` property took effect.
   */
  onRendered: _propTypes.default.func,

  /**
   * If `true`, the modal is open.
   */
  open: _propTypes.default.bool.isRequired
} : {};
Modal.defaultProps = {
  disableAutoFocus: false,
  disableBackdropClick: false,
  disableEnforceFocus: false,
  disableEscapeKeyDown: false,
  disablePortal: false,
  disableRestoreFocus: false,
  hideBackdrop: false,
  keepMounted: false,
  // Modals don't open on the server so this won't conflict with concurrent requests.
  manager: new _ModalManager.default(),
  BackdropComponent: _Backdrop.default
};

var _default = (0, _withStyles.default)(styles, {
  flip: false,
  name: 'MuiModal'
})(Modal);

exports.default = _default;

/***/ }),

/***/ "HAop":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _selectors = __webpack_require__("NLvv");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Translatable = function Translatable(_ref) {
    var message = _ref.message,
        className = _ref.className,
        key = _ref.key,
        children = _ref.children;
    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            'span',
            { className: className, key: key },
            message,
            children
        )
    );
};

var makeMapStateToProps = function makeMapStateToProps(initialState, initialOwnProps) {
    var message = initialOwnProps.message;

    var mapStateToProps = function mapStateToProps(state) {
        return {
            message: (0, _selectors.getMessage)(state, message)
        };
    };
    return mapStateToProps;
};

exports.default = (0, _reactRedux.connect)(makeMapStateToProps)(Translatable);

/***/ }),

/***/ "HH1Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Snackbar.default;
  }
});

var _Snackbar = _interopRequireDefault(__webpack_require__("rKgX"));

/***/ }),

/***/ "IfHf":
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__("Oy1H")["default"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "JrkZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _actionTypes = __webpack_require__("EA8k");

var types = _interopRequireWildcard(_actionTypes);

var _Text = __webpack_require__("8/ml");

var _Text2 = _interopRequireDefault(_Text);

var _Translatable = __webpack_require__("HAop");

var _Translatable2 = _interopRequireDefault(_Translatable);

var _InternalLink = __webpack_require__("XSs2");

var _InternalLink2 = _interopRequireDefault(_InternalLink);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectedValuesPane = function SelectedValuesPane(_ref) {
    var sewpatId = _ref.sewpatId,
        previousLocation = _ref.previousLocation;

    var StyledSelectedValuesPane = _styledComponents2.default.div.withConfig({
        displayName: 'SelectedValuesPane__StyledSelectedValuesPane',
        componentId: 'sc-s4od0t-0'
    })(['\n        display: grid;\n        grid-template-columns: repeat(3,minmax(7em, 10em));\n        grid-column-gap: 1em;\n        font-size: 0.81em;\n        line-height: 1.1;\n\n        & .schnoffle-selection-label {\n          grid-row: 1 / span 2;\n        }\n        & .schnoffle-selection-edit {\n          grid-row: 2;\n        }\n        & .schnoffle-capitalize {\n          text-transform: capitalize;\n        }\n\n    ']);

    var getChangePatternLink = function getChangePatternLink() {
        if (previousLocation) {
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'schnoffle-capitalize' },
                    _react2.default.createElement(_Translatable2.default, {
                        message: 'CHANGE_PATTERN_SELECTION'
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'schnoffle-selection-edit' },
                    _react2.default.createElement(
                        _InternalLink2.default,
                        {
                            to: previousLocation
                        },
                        _react2.default.createElement(_Translatable2.default, { message: 'CHANGE_SELECTION_LABEL' })
                    )
                )
            );
        }
        return null;
    };

    return _react2.default.createElement(
        _Text2.default,
        { colored: true, margin: '0.5rem 0' },
        _react2.default.createElement(
            StyledSelectedValuesPane,
            null,
            _react2.default.createElement(
                'div',
                { className: 'schnoffle-selection-label' },
                _react2.default.createElement(_Translatable2.default, {
                    message: 'SELECTED_VALUES_LABEL'
                })
            ),
            _react2.default.createElement(
                'div',
                { className: 'schnoffle-capitalize' },
                _react2.default.createElement(_Translatable2.default, {
                    message: 'SEWPAT_SHORT'
                }),
                ': ',
                sewpatId
            ),
            _react2.default.createElement(
                'div',
                { className: 'schnoffle-selection-edit' },
                _react2.default.createElement(
                    _InternalLink2.default,
                    {
                        to: {
                            type: types.NAVIGATED_TO_SEWPAT_GALLERY
                        }
                    },
                    _react2.default.createElement(_Translatable2.default, { message: 'CHANGE_SELECTION_LABEL' })
                )
            ),
            getChangePatternLink()
        )
    );
};

exports.default = SelectedValuesPane;

/***/ }),

/***/ "Kqdu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationFiller = function PaginationFiller() {
    var StyledFiller = _styledComponents2.default.span.withConfig({
        displayName: 'PaginationFiller__StyledFiller',
        componentId: 'sc-h4iemt-0'
    })(['\n      border: 1px solid ', ';\n      margin-left: -1px;\n      padding: 0.6em 0.5em 0;\n    '], function (props) {
        return props.theme.palette.blueGrey[200];
    });

    return _react2.default.createElement(
        StyledFiller,
        { className: 'stolo-pager-notclickable' },
        '...'
    );
};

exports.default = PaginationFiller;

/***/ }),

/***/ "L4KW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__("HBRR"));

var _createClass2 = _interopRequireDefault(__webpack_require__("ud+X"));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__("rjj8"));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__("X+J+"));

var _inherits2 = _interopRequireDefault(__webpack_require__("ymoH"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var _ButtonBase = _interopRequireDefault(__webpack_require__("32DM"));

var _reactHelpers = __webpack_require__("ToDL");

var styles = function styles(theme) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      paddingTop: 12,
      paddingBottom: 12
    },

    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: 'relative'
    },
    // TODO: Sanity check this - why is focusVisibleClassName prop apparently applied to a div?

    /* Styles applied to the `component`'s `focusVisibleClassName` property if `button={true}`. */
    focusVisible: {
      backgroundColor: theme.palette.action.hover
    },

    /* Legacy styles applied to the root element. Use `root` instead. */
    default: {},

    /* Styles applied to the `component` element if `dense={true}` or `children` includes `Avatar`. */
    dense: {
      paddingTop: 8,
      paddingBottom: 8
    },

    /* Styles applied to the inner `component` element if `disabled={true}`. */
    disabled: {
      opacity: 0.5
    },

    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: theme.mixins.gutters(),

    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positionned.
      paddingRight: 32
    }
  };
};

exports.styles = styles;

var ListItem =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ListItem, _React$Component);

  function ListItem() {
    (0, _classCallCheck2.default)(this, ListItem);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ListItem).apply(this, arguments));
  }

  (0, _createClass2.default)(ListItem, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        dense: this.props.dense || this.context.dense || false
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          button = _this$props.button,
          childrenProp = _this$props.children,
          classes = _this$props.classes,
          classNameProp = _this$props.className,
          componentProp = _this$props.component,
          ContainerComponent = _this$props.ContainerComponent,
          _this$props$Container = _this$props.ContainerProps;
      _this$props$Container = _this$props$Container === void 0 ? {} : _this$props$Container;
      var ContainerClassName = _this$props$Container.className,
          ContainerProps = (0, _objectWithoutProperties2.default)(_this$props$Container, ["className"]),
          dense = _this$props.dense,
          disabled = _this$props.disabled,
          disableGutters = _this$props.disableGutters,
          divider = _this$props.divider,
          focusVisibleClassName = _this$props.focusVisibleClassName,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName"]);
      var isDense = dense || this.context.dense || false;

      var children = _react.default.Children.toArray(childrenProp);

      var hasAvatar = children.some(function (value) {
        return (0, _reactHelpers.isMuiElement)(value, ['ListItemAvatar']);
      });
      var hasSecondaryAction = children.length && (0, _reactHelpers.isMuiElement)(children[children.length - 1], ['ListItemSecondaryAction']);
      var className = (0, _classnames.default)(classes.root, classes.default, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.dense, isDense || hasAvatar), (0, _defineProperty2.default)(_classNames, classes.gutters, !disableGutters), (0, _defineProperty2.default)(_classNames, classes.divider, divider), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.button, button), (0, _defineProperty2.default)(_classNames, classes.secondaryAction, hasSecondaryAction), _classNames), classNameProp);
      var componentProps = (0, _extends2.default)({
        className: className,
        disabled: disabled
      }, other);
      var Component = componentProp || 'li';

      if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, _classnames.default)(classes.focusVisible, focusVisibleClassName);
        Component = _ButtonBase.default;
      }

      if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

        if (ContainerComponent === 'li') {
          if (Component === 'li') {
            Component = 'div';
          } else if (componentProps.component === 'li') {
            componentProps.component = 'div';
          }
        }

        return _react.default.createElement(ContainerComponent, (0, _extends2.default)({
          className: (0, _classnames.default)(classes.container, ContainerClassName)
        }, ContainerProps), _react.default.createElement(Component, componentProps, children), children.pop());
      }

      return _react.default.createElement(Component, componentProps, children);
    }
  }]);
  return ListItem;
}(_react.default.Component);

ListItem.propTypes =  false ? {
  /**
   * If `true`, the list item will be a button (using `ButtonBase`).
   */
  button: _propTypes.default.bool,

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * The container component used when a `ListItemSecondaryAction` is rendered.
   */
  ContainerComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Properties applied to the container element when the component
   * is used to display a `ListItemSecondaryAction`.
   */
  ContainerProps: _propTypes.default.object,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: _propTypes.default.bool,

  /**
   * If `true`, the list item will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: _propTypes.default.bool,

  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   */
  divider: _propTypes.default.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: _propTypes.default.string
} : {};
ListItem.defaultProps = {
  button: false,
  ContainerComponent: 'li',
  dense: false,
  disabled: false,
  disableGutters: false,
  divider: false
};
ListItem.contextTypes = {
  dense: _propTypes.default.bool
};
ListItem.childContextTypes = {
  dense: _propTypes.default.bool
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItem'
})(ListItem);

exports.default = _default;

/***/ }),

/***/ "L4iW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Paper.default;
  }
});

var _Paper = _interopRequireDefault(__webpack_require__("P4HR"));

/***/ }),

/***/ "MTWR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BottomNavigationAction = __webpack_require__("jaTo");

var _BottomNavigationAction2 = _interopRequireDefault(_BottomNavigationAction);

var _Menu = __webpack_require__("BAI3");

var _Menu2 = _interopRequireDefault(_Menu);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _queryString = __webpack_require__("OAwv");

var _queryString2 = _interopRequireDefault(_queryString);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("Pq8k");

var _reactRedux = __webpack_require__("RH2O");

var _uiActions = __webpack_require__("rj0T");

var _i18n = __webpack_require__("lg9U");

var _page = __webpack_require__("4f5n");

var _sewpats = __webpack_require__("iBUI");

var _Icon = __webpack_require__("PlKq");

var _Icon2 = _interopRequireDefault(_Icon);

var _FlatInputShareMenu = __webpack_require__("AuuR");

var _FlatInputShareMenu2 = _interopRequireDefault(_FlatInputShareMenu);

var _IconText = __webpack_require__("lyam");

var _IconText2 = _interopRequireDefault(_IconText);

var _PinterestIcon = __webpack_require__("OhP/");

var _PinterestIcon2 = _interopRequireDefault(_PinterestIcon);

var _ShareMenuItem = __webpack_require__("Yx17");

var _ShareMenuItem2 = _interopRequireDefault(_ShareMenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(0, _reactIntl.defineMessages)({
    shareOnPinterest: {
        id: 'SHARE_ON_PINTEREST_BUTTON_LABEL',
        defaultMessage: 'Pin it'
    },
    shareOnPinterestPrefix: {
        id: 'SHARE_ON_PINTEREST_DEFAULT_PREFIX',
        description: 'Text we put in front of pattern title and description.',
        defaultMessage: 'Meine Farben. Mein Stoff. Mein Designerstück. Selbst designt bei www.schnoffle.de #designerstück #diy #diyfashion #fashion #schnittmuster #madeingermany #fashiondesign #nähen #nähenfürmich #geschenkidee #stofflove #stoffliebe'
    },
    shareOnPinterestSuffix: {
        id: 'SHARE_ON_PINTEREST_DEFAULT_SUFFIX',
        description: 'Text we put after the pattern title and description.',
        defaultMessage: 'Meine Farben. Mein Stoff. Mein Designerstück. Selbst designt bei www.schnoffle.de #designerstück #diy #diyfashion #fashion #schnittmuster #madeingermany #fashiondesign #nähen #nähenfürmich #geschenkidee #stofflove #stoffliebe'
    },
    shareOnInstagram: {
        id: 'SHARE_ON_INSTAGRAM_BUTTON_LABEL',
        defaultMessage: 'Instagram'
    },
    shareOnFacebook: {
        id: 'SHARE_ON_FACEBOOK_BUTTON_LABEL',
        defaultMessage: 'Facebook'
    },
    sharePerLink: {
        id: 'SHARE_COPY_LINK_BUTTON_LABEL',
        defaultMessage: 'Link kopieren'
    },
    shareOnWhatsapp: {
        id: 'SHARE_ON_WHATSAPP_BUTTON_LABEL',
        defaultMessage: 'Whatsapp'
    },
    snackCopied: {
        id: 'SNACK_LINK_COPIED_TO_CLIPBOARD',
        defaultMessage: 'Der Link zum Motiv wurde in die Zwischenablage kopiert.'
    }
});

var ShareMenu = function (_React$Component) {
    _inherits(ShareMenu, _React$Component);

    function ShareMenu() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ShareMenu);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ShareMenu.__proto__ || Object.getPrototypeOf(ShareMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            anchorEl: null,
            open: false
        }, _this.handleClick = function (event) {
            _this.setState({
                open: true,
                anchorEl: event.currentTarget
            });
        }, _this.pinProps = {
            name: 'icon-pinterest2',
            width: '1.3em',
            height: '1.3em',
            iconColor: 'blueGrey.700'
        }, _this.linkProps = {
            name: 'icon-link',
            width: '1.4em',
            height: '1.2em',
            iconColor: 'blueGrey.700'
        }, _this.iconProps = {
            name: 'icon-share',
            width: '1.5rem',
            height: '1.5rem',
            iconColor: 'blueGrey.700'
        }, _this.onCopyClick = function () {
            if (_this.input && _this.input.select) {
                // select text
                _this.input.select();
                try {
                    // copy text
                    document.execCommand('copy');
                    _this.input.blur();
                } catch (err) {
                    alert('please press Ctrl/Cmd+C to copy');
                }
            }
            _this.props.showSavedToClipBoard(Date.now());
            _this.handleRequestClose();
        }, _this.handleRequestClose = function () {
            _this.setState({
                open: false,
                anchorEl: null
            });
        }, _this.getUri = function () {
            var uri = _this.props.shareBaseUri;
            uri = uri + '/schnoff/' + _this.props.sewpatId + '/' + _this.props.pattern.id;
            if (_this.props.query) {
                var query = _queryString2.default.stringify(_this.props.query);
                if (query.length > 0) {
                    uri = uri + '?' + query;
                }
            }
            return uri;
        }, _this.getMedia = function () {
            return _this.props.imgSrc || (((_this.props.pattern || {}).thumbnails || {}).xlargeDiscreet || {}).url;
        }, _this.getDescription = function () {
            var pattern = _this.props.pattern;
            var description = _this.props.pattern.title + ' - Designerst\xFCck (Schnittmuster Berlin) auf umf\xE4rbbaren Stoffmotiv designt von ' + _this.props.designerName + ' | www.schnoffle.de';
            return description;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ShareMenu, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var shareMenuLabel = this.props.shareMenuLabel;

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(_BottomNavigationAction2.default, {
                    onClick: this.state.open ? null : this.handleClick,
                    component: 'div',
                    label: _react2.default.createElement(
                        _IconText2.default,
                        null,
                        shareMenuLabel
                    ),
                    value: 'share',
                    icon: _react2.default.createElement(_Icon2.default, this.iconProps),
                    id: this.props.patternid,
                    key: this.props.patternid,
                    show: true
                }),
                _react2.default.createElement(
                    _Menu2.default,
                    {
                        id: 'simple-menu',
                        anchorEl: this.state.anchorEl,
                        open: this.state.open,
                        onClose: this.handleRequestClose
                    },
                    _react2.default.createElement(
                        _ShareMenuItem2.default,
                        { handleClick: this.handleRequestClose },
                        _react2.default.createElement(_PinterestIcon2.default, {
                            iconProps: this.pinProps,
                            buttonText: this.props.sharePinterestLabel,
                            shareTarget: this.getUri(),
                            media: this.getMedia(),
                            description: this.getDescription()
                        })
                    ),
                    _react2.default.createElement(
                        _ShareMenuItem2.default,
                        {
                            ref: function ref(element) {
                                _this2.button = element;
                            }, handleClick: this.onCopyClick
                        },
                        _react2.default.createElement(
                            _FlatInputShareMenu2.default,
                            null,
                            _react2.default.createElement(_Icon2.default, this.linkProps),
                            ' ',
                            this.props.shareLinkLabel,
                            _react2.default.createElement('input', {
                                ref: function ref(element) {
                                    _this2.input = element;
                                },
                                type: 'text',
                                value: this.getUri(),
                                readOnly: true
                            })
                        )
                    )
                )
            );
        }
    }]);

    return ShareMenu;
}(_react2.default.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        showSavedToClipBoard: function showSavedToClipBoard(id) {
            return dispatch((0, _uiActions.showSnack)(id, 'SNACK_LINK_COPIED_TO_CLIPBOARD', null, 3000, null));
        }
    };
};

var makeMapStateToProps = function makeMapStateToProps(initialState, initialOwnProps) {
    var sharePinterest = (0, _i18n.getMessage)(initialState, 'SHARE_ON_PINTEREST_BUTTON_LABEL');
    var sharePinterestPrefix = (0, _i18n.getMessage)(initialState, 'SHARE_ON_PINTEREST_DEFAULT_PREFIX');
    var shareLabel = (0, _i18n.getMessage)(initialState, 'ICON_LABEL_SHARE');
    var shareLink = (0, _i18n.getMessage)(initialState, initialOwnProps.messageId || 'SHARE_COPY_LINK_BUTTON_LABEL');
    var sewpatId = (0, _sewpats.getActiveSewpatId)(initialState);
    var mapStateToProps = function mapStateToProps(state) {
        return _extends({
            sharePinterestLabel: sharePinterest,
            sharePinterestPrefix: sharePinterestPrefix,
            shareLinkLabel: shareLink,
            shareBaseUri: (0, _page.getCurrentBaseUri)(state),
            shareMenuLabel: shareLabel,
            sewpatId: sewpatId
        }, initialOwnProps);
    };
    return mapStateToProps;
};

ShareMenu.defaultProps = {
    pattern: {}
};

ShareMenu.propTypes = {
    pattern: _propTypes2.default.object.required
};

exports.default = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps)(ShareMenu);

/***/ }),

/***/ "N+yN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SnackbarContent.default;
  }
});

var _SnackbarContent = _interopRequireDefault(__webpack_require__("0hRY"));

/***/ }),

/***/ "NGS2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactImage = __webpack_require__("SGZo");

var _reactImage2 = _interopRequireDefault(_reactImage);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ImagePlaceholder = __webpack_require__("mjrp");

var _ImagePlaceholder2 = _interopRequireDefault(_ImagePlaceholder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pattern = function Pattern(_ref) {
    var src = _ref.src;
    return _react2.default.createElement(_reactImage2.default, {
        src: src,
        loader: _react2.default.createElement(_ImagePlaceholder2.default, null),
        unloader: _react2.default.createElement(_ImagePlaceholder2.default, null)
    });
};

Pattern.propTypes = {
    src: _propTypes2.default.string
};

Pattern.defaultProps = {
    src: ''
};

exports.default = Pattern;

/***/ }),

/***/ "Nqaz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__("HBRR"));

var _createClass2 = _interopRequireDefault(__webpack_require__("ud+X"));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__("rjj8"));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__("X+J+"));

var _inherits2 = _interopRequireDefault(__webpack_require__("ymoH"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _reactDom = _interopRequireDefault(__webpack_require__("O27J"));

var _keycode = _interopRequireDefault(__webpack_require__("ljAp"));

var _warning = _interopRequireDefault(__webpack_require__("mG8X"));

var _ownerDocument = _interopRequireDefault(__webpack_require__("2BhH"));

var _List = _interopRequireDefault(__webpack_require__("1k1m"));

// @inheritedComponent List
var MenuList =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(MenuList, _React$Component);

  function MenuList() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, MenuList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(MenuList)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.listRef = null;
    _this.selectedItemRef = null;
    _this.blurTimer = null;
    _this.state = {
      currentTabIndex: null
    };

    _this.handleBlur = function (event) {
      _this.blurTimer = setTimeout(function () {
        if (_this.listRef) {
          var list = _this.listRef;
          var currentFocus = (0, _ownerDocument.default)(list).activeElement;

          if (!list.contains(currentFocus)) {
            _this.resetTabIndex();
          }
        }
      }, 30);

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    };

    _this.handleKeyDown = function (event) {
      var list = _this.listRef;
      var key = (0, _keycode.default)(event);
      var currentFocus = (0, _ownerDocument.default)(list).activeElement;

      if ((key === 'up' || key === 'down') && (!currentFocus || currentFocus && !list.contains(currentFocus))) {
        if (_this.selectedItemRef) {
          _this.selectedItemRef.focus();
        } else {
          list.firstChild.focus();
        }
      } else if (key === 'down') {
        event.preventDefault();

        if (currentFocus.nextElementSibling) {
          currentFocus.nextElementSibling.focus();
        }
      } else if (key === 'up') {
        event.preventDefault();

        if (currentFocus.previousElementSibling) {
          currentFocus.previousElementSibling.focus();
        }
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event, key);
      }
    };

    _this.handleItemFocus = function (event) {
      var list = _this.listRef;

      if (list) {
        for (var i = 0; i < list.children.length; i += 1) {
          if (list.children[i] === event.currentTarget) {
            _this.setTabIndex(i);

            break;
          }
        }
      }
    };

    return _this;
  }

  (0, _createClass2.default)(MenuList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resetTabIndex();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.blurTimer);
    }
  }, {
    key: "setTabIndex",
    value: function setTabIndex(index) {
      this.setState({
        currentTabIndex: index
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      var currentTabIndex = this.state.currentTabIndex;
      var list = this.listRef;

      if (!list || !list.children || !list.firstChild) {
        return;
      }

      if (currentTabIndex && currentTabIndex >= 0) {
        list.children[currentTabIndex].focus();
      } else {
        list.firstChild.focus();
      }
    }
  }, {
    key: "resetTabIndex",
    value: function resetTabIndex() {
      var list = this.listRef;
      var currentFocus = (0, _ownerDocument.default)(list).activeElement;
      var items = [];

      for (var i = 0; i < list.children.length; i += 1) {
        items.push(list.children[i]);
      }

      var currentFocusIndex = items.indexOf(currentFocus);

      if (currentFocusIndex !== -1) {
        return this.setTabIndex(currentFocusIndex);
      }

      if (this.selectedItemRef) {
        return this.setTabIndex(items.indexOf(this.selectedItemRef));
      }

      return this.setTabIndex(0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          onBlur = _this$props.onBlur,
          onKeyDown = _this$props.onKeyDown,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "onBlur", "onKeyDown"]);
      return _react.default.createElement(_List.default, (0, _extends2.default)({
        role: "menu",
        ref: function ref(_ref) {
          _this2.listRef = _reactDom.default.findDOMNode(_ref);
        },
        className: className,
        onKeyDown: this.handleKeyDown,
        onBlur: this.handleBlur
      }, other), _react.default.Children.map(children, function (child, index) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the MenuList component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
        return _react.default.cloneElement(child, {
          tabIndex: index === _this2.state.currentTabIndex ? 0 : -1,
          ref: child.props.selected ? function (ref) {
            _this2.selectedItemRef = _reactDom.default.findDOMNode(ref);
          } : undefined,
          onFocus: _this2.handleItemFocus
        });
      }));
    }
  }]);
  return MenuList;
}(_react.default.Component);

MenuList.propTypes =  false ? {
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func
} : {};
var _default = MenuList;
exports.default = _default;

/***/ }),

/***/ "NvCw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var _Fade = _interopRequireDefault(__webpack_require__("rqlL"));

var styles = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    // Disable scroll capabilities.
    touchAction: 'none'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
exports.styles = styles;

function Backdrop(props) {
  var classes = props.classes,
      className = props.className,
      invisible = props.invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "invisible", "open", "transitionDuration"]);
  return _react.default.createElement(_Fade.default, (0, _extends2.default)({
    appear: true,
    in: open,
    timeout: transitionDuration
  }, other), _react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.invisible, invisible), className),
    "aria-hidden": "true"
  }));
}

Backdrop.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: _propTypes.default.bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : {};
Backdrop.defaultProps = {
  invisible: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiBackdrop'
})(Backdrop);

exports.default = _default;

/***/ }),

/***/ "O7GD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var _ListItem = _interopRequireDefault(__webpack_require__("+fsC"));

// @inheritedComponent ListItem
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0, _extends2.default)({}, theme.typography.subheading, {
      height: 24,
      boxSizing: 'content-box',
      width: 'auto',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      paddingLeft: 16,
      paddingRight: 16,
      '&$selected': {
        backgroundColor: theme.palette.action.selected
      }
    }),

    /* Styles applied to the root element if `selected={true}`. */
    selected: {}
  };
};

exports.styles = styles;

function MenuItem(props) {
  var classes = props.classes,
      className = props.className,
      component = props.component,
      selected = props.selected,
      role = props.role,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "selected", "role"]);
  return _react.default.createElement(_ListItem.default, (0, _extends2.default)({
    button: true,
    role: role,
    tabIndex: -1,
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.selected, selected), className),
    component: component
  }, other));
}

MenuItem.propTypes =  false ? {
  /**
   * Menu item contents.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * @ignore
   */
  role: _propTypes.default.string,

  /**
   * Use to apply selected styling.
   */
  selected: _propTypes.default.bool
} : {};
MenuItem.defaultProps = {
  component: 'li',
  role: 'menuitem',
  selected: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiMenuItem'
})(MenuItem);

exports.default = _default;

/***/ }),

/***/ "OOzO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),

/***/ "OXhf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _GalleryOverlay = __webpack_require__("ggcY");

var _GalleryOverlay2 = _interopRequireDefault(_GalleryOverlay);

var _PatternRepeat = __webpack_require__("bV1x");

var _PatternRepeat2 = _interopRequireDefault(_PatternRepeat);

var _Pattern = __webpack_require__("NGS2");

var _Pattern2 = _interopRequireDefault(_Pattern);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Media = _styledComponents2.default.div.withConfig({
    displayName: 'PatternCardPattern__Media',
    componentId: 'sc-1v7pxj4-0'
})(['\n    overflow: hidden;\n    position: relative;\n    width: 100%;\n    max-height: 80vh;\n\n    & img {\n      height: 100%;\n      width: 100%;\n    }\n\n    &:last-child {\n      padding-bottom: 0px;\n    }\n']);

var Pattern = function Pattern(_ref) {
    var imgUri = _ref.imgUri,
        overlay = _ref.overlay,
        overlayPath = _ref.overlayPath;
    return _react2.default.createElement(
        Media,
        null,
        _react2.default.createElement(
            _GalleryOverlay2.default,
            { overlay: overlay, path: overlayPath },
            _react2.default.createElement(_PatternRepeat2.default, { item: _react2.default.createElement(_Pattern2.default, { src: imgUri }) })
        )
    );
};

exports.default = Pattern;

/***/ }),

/***/ "OhP/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("Pq8k");

var _reactRedux = __webpack_require__("RH2O");

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _i18n = __webpack_require__("lg9U");

var _ActionableIcon = __webpack_require__("uX6S");

var _ActionableIcon2 = _interopRequireDefault(_ActionableIcon);

var _PinterestLinkGenerator = __webpack_require__("Ve+c");

var _PinterestLinkGenerator2 = _interopRequireDefault(_PinterestLinkGenerator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _reactIntl.defineMessages)({
    defaultPinterest: {
        id: 'DEFAULT_PINTEREST_SHARE_DESCRIPTION',
        defaultMessage: 'www.schnoffle.de | "Näh Dir Dein Designerstück!" ist unser Motto. Dafür bekommst Du Designer-Schnitt und Stoff im Näh-Paket. Das Besondere: Du gestaltest die Stoffe selbst. Alles wird nach Deinen Vorgaben hier in Deutschland bedruckt. Alles für perfekte Unikate.'
    }
});

var SharePinterest = function SharePinterest(_ref) {
    var shareTarget = _ref.shareTarget,
        media = _ref.media,
        description = _ref.description,
        buttonText = _ref.buttonText,
        buttonLabel = _ref.buttonLabel,
        onHover = _ref.onHover,
        iconProps = _ref.iconProps,
        handleClick = _ref.handleClick;

    var Icon = (0, _styledComponents2.default)(_ActionableIcon2.default).withConfig({
        displayName: 'PinterestIcon__Icon',
        componentId: 'sc-1klzpvj-0'
    })(['\n        &.schnoffle-pinterest-button {\n            width: 100%;\n            height: ', ';\n            flex-direction: row;\n            \n            & > svg {\n              margin-right: 1rem;\n            }\n        }\n    '], function (props) {
        return props.theme.space[10];
    });

    var ShareLink = (0, _PinterestLinkGenerator2.default)(shareTarget, media, description);

    var StyledLink = _styledComponents2.default.a.withConfig({
        displayName: 'PinterestIcon__StyledLink',
        componentId: 'sc-1klzpvj-1'
    })(['\n\n        color: inherit;\n        text-decoration: none;\n\n        &:focus,\n        &:hover {\n          text-decoration: none;\n        }\n\n        &:active {\n          color: inherit;\n        }\n\n        &:visited {\n          color: inherit;\n        }\n\n    ']);

    return _react2.default.createElement(
        StyledLink,
        {
            onClick: handleClick, href: ShareLink, target: '_blank',
            'aria-label': 'Share on Pinterest'
        },
        _react2.default.createElement(Icon, {
            text: buttonText || null, label: buttonLabel || null,
            onHover: onHover || null, iconProps: iconProps,
            className: 'schnoffle-pinterest-button'
        })
    );
};

var makeMapStateToProps = function makeMapStateToProps(initialState, initialOwnProps) {
    var message = (0, _i18n.getMessage)(initialState, initialOwnProps.messageId || 'DEFAULT_PINTEREST_SHARE_DESCRIPTION');
    var mapStateToProps = function mapStateToProps() {
        return _extends({
            description: message
        }, initialOwnProps);
    };
    return mapStateToProps;
};

exports.default = (0, _reactRedux.connect)(makeMapStateToProps)(SharePinterest);

/***/ }),

/***/ "P4HR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _warning = _interopRequireDefault(__webpack_require__("mG8X"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0, _extends2.default)({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    }
  }, elevations);
};

exports.styles = styles;

function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
   false ? (0, _warning.default)(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
  var className = (0, _classnames.default)(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2.default)({}, classes.rounded, !square), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Paper.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: _propTypes.default.number,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: _propTypes.default.bool
} : {};
Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPaper'
})(Paper);

exports.default = _default;

/***/ }),

/***/ "R8Bv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__("HBRR"));

var _createClass2 = _interopRequireDefault(__webpack_require__("ud+X"));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__("rjj8"));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__("X+J+"));

var _inherits2 = _interopRequireDefault(__webpack_require__("ymoH"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _reactDom = _interopRequireDefault(__webpack_require__("O27J"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _reactEventListener = _interopRequireDefault(__webpack_require__("/Ngn"));

var _ownerDocument = _interopRequireDefault(__webpack_require__("2BhH"));

// @inheritedComponent EventListener

/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */
var ClickAwayListener =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ClickAwayListener, _React$Component);

  function ClickAwayListener() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ClickAwayListener);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ClickAwayListener)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.node = null;
    _this.mounted = null;

    _this.handleClickAway = function (event) {
      // Ignore events that have been `event.preventDefault()` marked.
      if (event.defaultPrevented) {
        return;
      } // IE11 support, which trigger the handleClickAway even after the unbind


      if (!_this.mounted) {
        return;
      } // The child might render null.


      if (!_this.node) {
        return;
      }

      var doc = (0, _ownerDocument.default)(_this.node);

      if (doc.documentElement && doc.documentElement.contains(event.target) && !_this.node.contains(event.target)) {
        _this.props.onClickAway(event);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(ClickAwayListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Finds the first child when a component returns a fragment.
      // https://github.com/facebook/react/blob/036ae3c6e2f056adffc31dfb78d1b6f0c63272f0/packages/react-dom/src/__tests__/ReactDOMFiber-test.js#L105
      this.node = _reactDom.default.findDOMNode(this);
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          mouseEvent = _this$props.mouseEvent,
          touchEvent = _this$props.touchEvent,
          onClickAway = _this$props.onClickAway,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "mouseEvent", "touchEvent", "onClickAway"]);
      var listenerProps = {};

      if (mouseEvent !== false) {
        listenerProps[mouseEvent] = this.handleClickAway;
      }

      if (touchEvent !== false) {
        listenerProps[touchEvent] = this.handleClickAway;
      }

      return _react.default.createElement(_reactEventListener.default, (0, _extends2.default)({
        target: "document"
      }, listenerProps, other), children);
    }
  }]);
  return ClickAwayListener;
}(_react.default.Component);

ClickAwayListener.propTypes =  false ? {
  /**
   * The wrapped element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   */
  mouseEvent: _propTypes.default.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),

  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: _propTypes.default.func.isRequired,

  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   */
  touchEvent: _propTypes.default.oneOf(['onTouchStart', 'onTouchEnd', false])
} : {};
ClickAwayListener.defaultProps = {
  mouseEvent: 'onMouseUp',
  touchEvent: 'onTouchEnd'
};
var _default = ClickAwayListener;
exports.default = _default;

/***/ }),

/***/ "RV4I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "S9Yq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("R6lU");

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__("cFFW"));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),

/***/ "SGZo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__("IfHf");

var _interopRequireDefault = __webpack_require__("R6lU");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__("Biqn"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("t9TF"));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__("Z60a"));

var _createClass2 = _interopRequireDefault(__webpack_require__("C9uT"));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__("T/v0"));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__("tNLN"));

var _inherits2 = _interopRequireDefault(__webpack_require__("j/rp"));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__("M1I4"));

var _defineProperty2 = _interopRequireDefault(__webpack_require__("fKPv"));

var _react = _interopRequireWildcard(__webpack_require__("GiK3"));

var _propTypes = __webpack_require__("D1TY");

var cache = {};
var imgPropTypes = {
  loader: _propTypes.node,
  unloader: _propTypes.node,
  decode: _propTypes.bool,
  src: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.array]),
  container: _propTypes.func,
  loaderContainer: _propTypes.func,
  unloaderContainer: _propTypes.func
};

if (false) {
  imgPropTypes.containermockImage = (0, _propTypes.instanceOf)(Image); //used for testing only
}

var Img =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Img, _Component);

  function Img(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Img);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Img).call(this, props)); // default loader/unloader container to just container. If no container was set
    // this will be a noop

    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "srcToArray", function (src) {
      return (Array.isArray(src) ? src : [src]).filter(function (x) {
        return x;
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onLoad", function () {
      cache[_this.sourceList[_this.state.currentIndex]] = true;
      /* istanbul ignore else */

      if (_this.i) _this.setState({
        isLoaded: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onError", function () {
      cache[_this.sourceList[_this.state.currentIndex]] = false; // if the current image has already been destroyed, we are probably no longer mounted
      // no need to do anything then

      /* istanbul ignore else */

      if (!_this.i) return false; // before loading the next image, check to see if it was ever loaded in the past

      for (var nextIndex = _this.state.currentIndex + 1; nextIndex < _this.sourceList.length; nextIndex++) {
        // get next img
        var src = _this.sourceList[nextIndex]; // if we have never seen it, its the one we want to try next

        if (!(src in cache)) {
          _this.setState({
            currentIndex: nextIndex
          });

          break;
        } // if we know it exists, use it!


        if (cache[src] === true) {
          _this.setState({
            currentIndex: nextIndex,
            isLoading: false,
            isLoaded: true
          });

          return true;
        } // if we know it doesn't exist, skip it!

        /* istanbul ignore else */


        if (cache[src] === false) continue;
      } // currentIndex is zero bases, length is 1 based.
      // if we have no more sources to try, return - we are done


      if (nextIndex === _this.sourceList.length) return _this.setState({
        isLoading: false
      }); // otherwise, try the next img

      _this.loadImg();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "loadImg", function () {
      if (false) {
        _this.i = _this.props.mockImage || new Image();
      } else {
        _this.i = new Image();
      }

      _this.i.src = _this.sourceList[_this.state.currentIndex];

      if (_this.props.decode && _this.i.decode) {
        _this.i.decode().then(_this.onLoad).catch(_this.onError);
      } else {
        _this.i.onload = _this.onLoad;
      }

      _this.i.onerror = _this.onError;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "unloadImg", function () {
      delete _this.i.onerror;
      delete _this.i.onload;

      try {
        delete _this.i.src;
      } catch (e) {// On Safari in Strict mode this will throw an exception,
        //  - https://github.com/mbrevda/react-image/issues/187
        // We don't need to do anything about it.
      }

      delete _this.i;
    });
    _this.loaderContainer = props.loaderContainer || props.container;
    _this.unloaderContainer = props.unloaderContainer || props.container;
    _this.sourceList = _this.srcToArray(_this.props.src); // check cache to decide at which index to start

    for (var i = 0; i < _this.sourceList.length; i++) {
      // if we've never seen this image before, the cache wont help.
      // no need to look further, just start loading

      /* istanbul ignore else */
      if (!(_this.sourceList[i] in cache)) break; // if we have loaded this image before, just load it again

      /* istanbul ignore else */

      if (cache[_this.sourceList[i]] === true) {
        _this.state = {
          currentIndex: i,
          isLoading: false,
          isLoaded: true
        };
        return (0, _possibleConstructorReturn2.default)(_this, true);
      }
    }

    _this.state = _this.sourceList.length ? // 'normal' opperation: start at 0 and try to load
    {
      currentIndex: 0,
      isLoading: true,
      isLoaded: false
    } : // if we dont have any sources, jump directly to unloaded
    {
      isLoading: false,
      isLoaded: false
    };
    return _this;
  }

  (0, _createClass2.default)(Img, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // kick off process

      /* istanbul ignore else */
      if (this.state.isLoading) this.loadImg();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // ensure that we dont leave any lingering listeners

      /* istanbul ignore else */
      if (this.i) this.unloadImg();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      this.loaderContainer = nextProps.loaderContainer || nextProps.container;
      this.unloaderContainer = nextProps.unloaderContainer || nextProps.container;
      var src = this.srcToArray(nextProps.src);
      var srcAdded = src.filter(function (s) {
        return _this2.sourceList.indexOf(s) === -1;
      });
      var srcRemoved = this.sourceList.filter(function (s) {
        return src.indexOf(s) === -1;
      }); // if src prop changed, restart the loading process

      if (srcAdded.length || srcRemoved.length) {
        this.sourceList = src; // if we dont have any sources, jump directly to unloader

        if (!src.length) return this.setState({
          isLoading: false,
          isLoaded: false
        });
        this.setState({
          currentIndex: 0,
          isLoading: true,
          isLoaded: false
        }, this.loadImg);
      }
    }
  }, {
    key: "render",
    value: function render() {
      // set img props as rest
      var _this$props = this.props,
          container = _this$props.container,
          loader = _this$props.loader,
          unloader = _this$props.unloader,
          src = _this$props.src,
          decode = _this$props.decode,
          loaderContainer = _this$props.loaderContainer,
          unloaderContainer = _this$props.unloaderContainer,
          mockImage = _this$props.mockImage,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["container", "loader", "unloader", "src", "decode", "loaderContainer", "unloaderContainer", "mockImage"]); //eslint-disable-line
      // if we have loaded, show img

      if (this.state.isLoaded) {
        var imgProps = (0, _objectSpread2.default)({}, {
          src: this.sourceList[this.state.currentIndex]
        }, rest);
        return container(_react.default.createElement("img", imgProps));
      } // if we are still trying to load, show img and a loader if requested


      if (!this.state.isLoaded && this.state.isLoading) {
        return loader ? this.loaderContainer(loader) : null;
      } // if we have given up on loading, show a place holder if requested, or nothing

      /* istanbul ignore else */


      if (!this.state.isLoaded && !this.state.isLoading) {
        return unloader ? this.unloaderContainer(unloader) : null;
      }
    }
  }]);
  return Img;
}(_react.Component);

(0, _defineProperty2.default)(Img, "defaultProps", {
  loader: false,
  unloader: false,
  decode: true,
  src: [],
  // by default, just return what gets sent in. Can be used for advanced rendering
  // such as animations
  container: function container(x) {
    return x;
  }
});
Img.propTypes =  false ? imgPropTypes : {};
var _default = Img;
exports.default = _default;

/***/ }),

/***/ "STj0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ClickAwayListener.default;
  }
});

var _ClickAwayListener = _interopRequireDefault(__webpack_require__("R8Bv"));

/***/ }),

/***/ "SZDM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.hr.withConfig({
    displayName: 'HorizontalDivider',
    componentId: 'sc-2e8hns-0'
})(['\n    border: 0;\n    height: 1px;\n    background-image: linear-gradient(to right, rgba(69, 90, 100, 0.05), rgba(69, 90, 100, 0.5), rgba(69, 90, 100, 0.05));\n    margin: ', ';\n    clear: both;\n    overflow: hidden;\n'], function (props) {
    return props.margin ? props.margin : '2em 0 1em';
});

/***/ }),

/***/ "T1RF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransitionProps = getTransitionProps;
exports.reflow = void 0;

var reflow = function reflow(node) {
  return node.scrollTop;
};

exports.reflow = reflow;

function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode],
    delay: style.transitionDelay
  };
}

/***/ }),

/***/ "ToDL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneElementWithClassName = cloneElementWithClassName;
exports.cloneChildrenWithClassName = cloneChildrenWithClassName;
exports.isMuiElement = isMuiElement;
exports.isMuiComponent = isMuiComponent;

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

/* eslint-disable import/prefer-default-export */
function cloneElementWithClassName(child, className) {
  return _react.default.cloneElement(child, {
    className: (0, _classnames.default)(child.props.className, className)
  });
}

function cloneChildrenWithClassName(children, className) {
  return _react.default.Children.map(children, function (child) {
    return _react.default.isValidElement(child) && cloneElementWithClassName(child, className);
  });
}

function isMuiElement(element, muiNames) {
  return _react.default.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function isMuiComponent(element, muiNames) {
  return muiNames.indexOf(element.muiName) !== -1;
}

/***/ }),

/***/ "UHYW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactIntersectionList = __webpack_require__("nF0i");

var _reactIntersectionList2 = _interopRequireDefault(_reactIntersectionList);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("Pq8k");

var _reactRedux = __webpack_require__("RH2O");

var _navigation = __webpack_require__("LYcX");

var _uiActions = __webpack_require__("rj0T");

var _page = __webpack_require__("4f5n");

var _patterns = __webpack_require__("MTZW");

var _sewpats = __webpack_require__("iBUI");

var _ui = __webpack_require__("362K");

var _ui2 = __webpack_require__("7Gpa");

var _CategoriesTrail = __webpack_require__("2+hv");

var _CategoriesTrail2 = _interopRequireDefault(_CategoriesTrail);

var _MessagePage = __webpack_require__("Zskj");

var _MessagePage2 = _interopRequireDefault(_MessagePage);

var _SelectedValuesPane = __webpack_require__("JrkZ");

var _SelectedValuesPane2 = _interopRequireDefault(_SelectedValuesPane);

var _Text = __webpack_require__("8/ml");

var _Text2 = _interopRequireDefault(_Text);

var _Heading = __webpack_require__("6GnX");

var _Heading2 = _interopRequireDefault(_Heading);

var _LinearProgress = __webpack_require__("3efK");

var _LinearProgress2 = _interopRequireDefault(_LinearProgress);

var _Pagination = __webpack_require__("DhMB");

var _Pagination2 = _interopRequireDefault(_Pagination);

var _PatternCard = __webpack_require__("unQw");

var _PatternCard2 = _interopRequireDefault(_PatternCard);

var _PatternGalleryAppBar = __webpack_require__("+0PG");

var _PatternGalleryAppBar2 = _interopRequireDefault(_PatternGalleryAppBar);

var _PatternGalleryItems = __webpack_require__("hHDH");

var _PatternGalleryItems2 = _interopRequireDefault(_PatternGalleryItems);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(0, _reactIntl.defineMessages)({
    nosearchresult: {
        id: 'SEARCH_NO_RESULT',
        defaultMessage: 'Sorry, aber wir haben keine passenden Stoffe für Dich gefunden.'
    }
});

var PatternGalleries = function (_Component) {
    _inherits(PatternGalleries, _Component);

    function PatternGalleries() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PatternGalleries);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PatternGalleries.__proto__ || Object.getPrototypeOf(PatternGalleries)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            itemsToRender: _this.props.itemsToRender,
            renderList: false
        }, _this.itemRenderer = function (index, key) {
            var _this$props = _this.props,
                patternIds = _this$props.patternIds,
                thumbnailType = _this$props.thumbnailType,
                figurineOverlay = _this$props.figurineOverlay,
                sewpat = _this$props.sewpat,
                appBarType = _this$props.appBarType,
                favoritesMode = _this$props.favoritesMode,
                patterns = _this$props.patterns;

            var sewpatId = sewpat.id;
            return _react2.default.createElement(
                _PatternCard2.default,
                {
                    id: patternIds[index],
                    key: key,
                    pattern: patterns[patternIds[index]],
                    thumbnailType: thumbnailType,
                    overlay: figurineOverlay,
                    overlayPath: 'schnittmuster/' + sewpatId,
                    sewpatId: sewpatId
                },
                _react2.default.createElement(_PatternGalleryAppBar2.default, {
                    patternid: patternIds[index],
                    type: appBarType,
                    favoritesMode: favoritesMode
                })
            );
        }, _this.getHelp = function () {
            if (_this.props.helpText) {
                return _react2.default.createElement(
                    'p',
                    null,
                    _this.props.helpText
                );
            }
            return null;
        }, _this.handleSetPage = function (page) {
            _this.props.setPage(page);
        }, _this.handleIntersection = function (size, pageSize) {
            _this.props.intersectionTriggered(size, pageSize);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PatternGalleries, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            __webpack_require__("p3C9");
            this.setState(Object.assign({}, this.state, { renderList: true }));
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.isFetching) {
                return _react2.default.createElement(_LinearProgress2.default, null);
            }

            if (this.props.numberOfPatterns === 0) {
                return _react2.default.createElement(_MessagePage2.default, {
                    messageId: 'SEARCH_NO_RESULT',
                    title: this.title
                });
            }

            if (this.state.renderList) {
                return _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(_CategoriesTrail2.default, null),
                    _react2.default.createElement(_SelectedValuesPane2.default, { sewpatId: this.props.sewpat.id }),
                    _react2.default.createElement(
                        _Text2.default,
                        null,
                        _react2.default.createElement(_Text2.default.Heading, { text: this.props.galleryTitle || null, level: 3, center: true }),
                        this.getHelp()
                    ),
                    _react2.default.createElement(_reactIntersectionList2.default, {
                        itemCount: this.props.numberOfPatterns,
                        itemsRenderer: _PatternGalleryItems2.default, threshold: '25%',
                        pageSize: this.props.itemsToRender || 10,
                        onIntersection: this.handleIntersection,
                        renderItem: this.itemRenderer
                    }),
                    _react2.default.createElement(
                        _Text2.default,
                        null,
                        _ui.showPagination ? _react2.default.createElement(_Pagination2.default, _extends({}, this.props.paginationProps, {
                            handleSetPage: this.handleSetPage
                        })) : null,
                        this.props.showLoader && !this.props.showPagination ? _react2.default.createElement(_LinearProgress2.default, null) : null
                    )
                );
            }
            return _react2.default.createElement(
                'div',
                null,
                'LOADING ...',
                _react2.default.createElement(_LinearProgress2.default, null)
            );
        }
    }]);

    return PatternGalleries;
}(_react.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        setPage: function setPage(page) {
            return dispatch((0, _navigation.setPage)(page));
        },
        intersectionTriggered: function intersectionTriggered(count, pagePerLoad) {
            return dispatch((0, _uiActions.intersectionTriggered)(count, pagePerLoad));
        }
    };
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
    var totalHits = ownProps.totalHits,
        patterns = ownProps.patterns,
        items = ownProps.items,
        title = ownProps.title;

    var number = items ? items.length : 0;
    var sewpat = (0, _sewpats.getActiveSewpat)(state);
    var figurineOverlay = (0, _sewpats.getSewpatGalleryOverlay)(state);
    return {
        patterns: patterns,
        patternIds: items,
        sewpat: sewpat,
        figurineOverlay: figurineOverlay,
        numberOfPatterns: number,
        isFetching: (0, _patterns.getIsFetchingPatterns)(state),
        itemsToRender: (0, _ui2.getPatternsCountToRender)(state),
        thumbnailType: (0, _ui2.getGalleryThumbnailType)(state),
        appBarType: (0, _ui2.getAppBarType)(state),
        galleryTitle: title,
        showPagination: (0, _ui.showPagination)(state, totalHits),
        showLoader: (0, _ui2.showLoader)(state, totalHits),
        paginationProps: {
            pageCount: (0, _ui.getPaginationPageCount)(state, totalHits),
            displayLimit: (0, _ui.getContainerPaginationLimit)(state),
            currentPage: (0, _page.getCurrentPageNumber)(state)
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PatternGalleries);

/***/ }),

/***/ "URv/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RootRef.default;
  }
});

var _RootRef = _interopRequireDefault(__webpack_require__("W0KI"));

/***/ }),

/***/ "Ve+c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _queryString = __webpack_require__("OAwv");

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PinterestTarget = function PinterestTarget(shareTarget, media, description) {
    var baseUri = "https://www.pinterest.com/pin/create/button/?";

    var query = {
        url: shareTarget || "https://www.schnoffle.de/",
        media: media || "https://www.schnoffle.de/media/schnoffle.29e34cbe.jpg",
        description: description
    };

    return baseUri + _queryString2.default.stringify(query);
};

exports.default = PinterestTarget;

/***/ }),

/***/ "VjCY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("R6lU");

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__("ChDW"));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),

/***/ "VuSO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IntersectionObserver__ = __webpack_require__("g6PY");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__IntersectionObserver__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("1fQI");
/* unused harmony reexport parseRootMargin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hook__ = __webpack_require__("3ru4");
/* unused harmony namespace reexport */





/***/ }),

/***/ "W0KI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__("HBRR"));

var _createClass2 = _interopRequireDefault(__webpack_require__("ud+X"));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__("rjj8"));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__("X+J+"));

var _inherits2 = _interopRequireDefault(__webpack_require__("ymoH"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _reactDom = _interopRequireDefault(__webpack_require__("O27J"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _exactProp = _interopRequireDefault(__webpack_require__("esoQ"));

function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
/**
 * Helper component to allow attaching a ref to a
 * wrapped element to access the underlying DOM element.
 *
 * It's highly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801.
 * For example:
 * ```jsx
 * import React from 'react';
 * import RootRef from '@material-ui/core/RootRef';
 *
 * class MyComponent extends React.Component {
 *   constructor() {
 *     super();
 *     this.domRef = React.createRef();
 *   }
 *
 *   componentDidMount() {
 *     console.log(this.domRef.current); // DOM node
 *   }
 *
 *   render() {
 *     return (
 *       <RootRef rootRef={this.domRef}>
 *         <SomeChildComponent />
 *       </RootRef>
 *     );
 *   }
 * }
 * ```
 */


var RootRef =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(RootRef, _React$Component);

  function RootRef() {
    (0, _classCallCheck2.default)(this, RootRef);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RootRef).apply(this, arguments));
  }

  (0, _createClass2.default)(RootRef, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      setRef(this.props.rootRef, _reactDom.default.findDOMNode(this));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.rootRef !== this.props.rootRef) {
        setRef(prevProps.rootRef, null);
        setRef(this.props.rootRef, _reactDom.default.findDOMNode(this));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      setRef(this.props.rootRef, null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return RootRef;
}(_react.default.Component);

RootRef.propTypes =  false ? {
  /**
   * The wrapped element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Provide a way to access the DOM node of the wrapped element.
   * You can provide a callback ref or a `React.createRef()` ref.
   */
  rootRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]).isRequired
} : {};
RootRef.propTypes =  false ? (0, _exactProp.default)(RootRef.propTypes) : {};
var _default = RootRef;
exports.default = _default;

/***/ }),

/***/ "WkCf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _PaginationButton = __webpack_require__("y40A");

var _PaginationButton2 = _interopRequireDefault(_PaginationButton);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationButton = function PaginationButton(_ref) {
    var pageNumber = _ref.pageNumber,
        disabled = _ref.disabled,
        handleClick = _ref.handleClick;
    return _react2.default.createElement(
        _PaginationButton2.default,
        {
            onClick: handleClick,
            disabled: disabled,
            className: disabled ? 'stolo-pager-notclickable stolo-pager-active' : ''
        },
        pageNumber
    );
};

PaginationButton.defaultProps = {
    disabled: false
};

PaginationButton.propTypes = {
    pageNumber: _propTypes2.default.number.isRequired,
    disabled: _propTypes2.default.bool,
    handleClick: _propTypes2.default.func.isRequired
};

exports.default = PaginationButton;

/***/ }),

/***/ "XhuR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export observerElementsMap */
/* unused harmony export getPooled */
/* unused harmony export findObserverElement */
/* unused harmony export callback */
/* harmony export (immutable) */ __webpack_exports__["a"] = createObserver;
/* harmony export (immutable) */ __webpack_exports__["b"] = observeElement;
/* harmony export (immutable) */ __webpack_exports__["c"] = unobserveElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__("1fQI");

var observerElementsMap = new Map();
function getPooled(options) {
    if (options === void 0) { options = {}; }
    var root = options.root || null;
    var rootMargin = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* parseRootMargin */])(options.rootMargin);
    var threshold = Array.isArray(options.threshold)
        ? options.threshold
        : [options.threshold != null ? options.threshold : 0];
    var observers = observerElementsMap.keys();
    var observer;
    while ((observer = observers.next().value)) {
        var unmatched = root !== observer.root ||
            rootMargin !== observer.rootMargin ||
            Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* shallowCompare */])(threshold, observer.thresholds);
        if (!unmatched) {
            return observer;
        }
    }
    return null;
}
function findObserverElement(observer, entry) {
    var elements = observerElementsMap.get(observer);
    if (elements) {
        var values = elements.values();
        var element = void 0;
        while ((element = values.next().value)) {
            if (element.target === entry.target) {
                return element;
            }
        }
    }
    return null;
}
/**
 * The Intersection Observer API callback that is called whenever one element
 * – namely the target – intersects either the device viewport or a specified element.
 * Also will get called whenever the visibility of the target element changes and
 * crosses desired amounts of intersection with the root.
 */
function callback(entries, observer) {
    for (var i = 0; i < entries.length; i++) {
        var element = findObserverElement(observer, entries[i]);
        /* istanbul ignore next line */
        if (element) {
            element.handleChange(entries[i]);
        }
    }
}
function createObserver(options) {
    var pooled = getPooled(options);
    if (pooled) {
        return pooled;
    }
    var observer = new IntersectionObserver(callback, options);
    observerElementsMap.set(observer, new Set());
    return observer;
}
function observeElement(element) {
    var _a;
    if (element.observer && !observerElementsMap.has(element.observer)) {
        observerElementsMap.set(element.observer, new Set());
    }
    (_a = observerElementsMap.get(element.observer)) === null || _a === void 0 ? void 0 : _a.add(element);
    element.observer.observe(element.target);
}
function unobserveElement(element, target) {
    if (observerElementsMap.has(element.observer)) {
        var targets = observerElementsMap.get(element.observer);
        if (targets === null || targets === void 0 ? void 0 : targets.delete(element)) {
            if (targets.size > 0) {
                element.observer.unobserve(target);
            }
            else {
                element.observer.disconnect();
                observerElementsMap.delete(element.observer);
            }
        }
    }
}


/***/ }),

/***/ "Y2YK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CategoryPatterns = __webpack_require__("gHwZ");

Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CategoryPatterns).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "YP5e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationWrapper = function PaginationWrapper(_ref) {
    var items = _ref.items;


    var StyledPagination = _styledComponents2.default.nav.withConfig({
        displayName: 'PaginationWrapper__StyledPagination',
        componentId: 'sc-enhn0r-0'
    })(['\n        display: flex;\n        flex-direction: row;\n        flex-wrap: nowrap;\n        justify-content: center;\n        align-items: stretch;\n        margin-top: 1em;\n        height: ', ';\n        color: ', ';\n        \n        & .stolo-pager-notclickable {\n          background-color: ', ';\n          cursor: not-allowed;\n        }\n\n        & .stolo-pager-active {\n          border-bottom: 2px solid ', ';\n        }\n    '], function (props) {
        return props.theme.space[12];
    }, function (props) {
        return props.theme.palette.blueGrey[300];
    }, function (props) {
        return props.theme.palette.blueGrey[50];
    }, function (props) {
        return props.theme.palette.primary[500];
    });

    return _react2.default.createElement(
        StyledPagination,
        { role: 'navigation' },
        items
    );
};

exports.default = PaginationWrapper;

/***/ }),

/***/ "Yx17":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _MenuItem = __webpack_require__("1A5N");

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareMenuItem = function ShareMenuItem(_ref) {
    var children = _ref.children,
        handleClick = _ref.handleClick;

    var StyledShareMenuItem = (0, _styledComponents2.default)(_MenuItem2.default).withConfig({
        displayName: 'ShareMenuItem__StyledShareMenuItem',
        componentId: 'sc-8x889o-0'
    })(['\n      &.schnoffle-menu-item{\n        height: 2.63em;\n      }\n    ']);

    return _react2.default.createElement(
        StyledShareMenuItem,
        { onClick: handleClick, classes: { root: 'schnoffle-menu-item' } },
        children
    );
};

exports.default = ShareMenuItem;

/***/ }),

/***/ "Zskj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Translatable = __webpack_require__("HAop");

var _Translatable2 = _interopRequireDefault(_Translatable);

var _Heading = __webpack_require__("6GnX");

var _Heading2 = _interopRequireDefault(_Heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessagePage = function MessagePage(_ref) {
    var title = _ref.title,
        level = _ref.level,
        messageId = _ref.messageId,
        textClass = _ref.textClass;
    return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_Heading2.default, { text: title, level: level, center: true }),
        _react2.default.createElement(_Translatable2.default, { message: messageId, className: textClass })
    );
};

MessagePage.defaultProps = {
    level: '3',
    textClass: ''
};

MessagePage.propTypes = {
    title: _propTypes2.default.string.isRequired,
    level: _propTypes2.default.string,
    messageId: _propTypes2.default.string.isRequired,
    textClass: _propTypes2.default.string
};

exports.default = MessagePage;

/***/ }),

/***/ "bV1x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PatternRepeat = function PatternRepeat(_ref) {
    var item = _ref.item;

    var RepeatContainer = _styledComponents2.default.div.withConfig({
        displayName: 'PatternRepeat__RepeatContainer',
        componentId: 'sc-e9t4mv-0'
    })(['\n        display: flex;\n        flex-wrap: wrap;\n        position: absolute;\n        top: 0;\n        left: 0;\n    ']);

    var RepeatItem = _styledComponents2.default.div.withConfig({
        displayName: 'PatternRepeat__RepeatItem',
        componentId: 'sc-e9t4mv-1'
    })(['\n        width: 33%;\n        margin: 0;\n        padding: 0;\n        box-sizing: border-box;\n        line-height: 0;\n    ']);

    return _react2.default.createElement(
        RepeatContainer,
        null,
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        ),
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        ),
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        ),
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        ),
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        ),
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        ),
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        ),
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        ),
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        ),
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        ),
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        ),
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        ),
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        ),
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        ),
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        ),
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        ),
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        ),
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        ),
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        ),
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        ),
        _react2.default.createElement(
            RepeatItem,
            null,
            item
        )
    );
};

exports.default = PatternRepeat;

/***/ }),

/***/ "e1dG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__("HBRR"));

var _createClass2 = _interopRequireDefault(__webpack_require__("ud+X"));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__("rjj8"));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__("X+J+"));

var _inherits2 = _interopRequireDefault(__webpack_require__("ymoH"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _reactDom = _interopRequireDefault(__webpack_require__("O27J"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _ownerDocument = _interopRequireDefault(__webpack_require__("2BhH"));

var _exactProp = _interopRequireDefault(__webpack_require__("esoQ"));

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom.default.findDOMNode(container) || defaultContainer;
}

function getOwnerDocument(element) {
  return (0, _ownerDocument.default)(_reactDom.default.findDOMNode(element));
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */


var Portal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Portal, _React$Component);

  function Portal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Portal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Portal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getMountNode = function () {
      return _this.mountNode;
    };

    return _this;
  }

  (0, _createClass2.default)(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setMountNode(this.props.container); // Only rerender if needed

      if (!this.props.disablePortal) {
        this.forceUpdate(this.props.onRendered);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.container !== this.props.container || prevProps.disablePortal !== this.props.disablePortal) {
        this.setMountNode(this.props.container); // Only rerender if needed

        if (!this.props.disablePortal) {
          this.forceUpdate(this.props.onRendered);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mountNode = null;
    }
  }, {
    key: "setMountNode",
    value: function setMountNode(container) {
      if (this.props.disablePortal) {
        this.mountNode = _reactDom.default.findDOMNode(this).parentElement;
        return;
      }

      this.mountNode = getContainer(container, getOwnerDocument(this).body);
    }
    /**
     * @public
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          disablePortal = _this$props.disablePortal;

      if (disablePortal) {
        return children;
      }

      return this.mountNode ? _reactDom.default.createPortal(children, this.mountNode) : null;
    }
  }]);
  return Portal;
}(_react.default.Component);

Portal.propTypes =  false ? {
  /**
   * The children to render into the `container`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes.default.bool,

  /**
   * Callback fired once the children has been mounted into the `container`.
   */
  onRendered: _propTypes.default.func
} : {};
Portal.defaultProps = {
  disablePortal: false
};
Portal.propTypes =  false ? (0, _exactProp.default)(Portal.propTypes) : {};
var _default = Portal;
exports.default = _default;

/***/ }),

/***/ "eIqZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _Paper = _interopRequireDefault(__webpack_require__("L4iW"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

// @inheritedComponent Paper
var styles = {
  /* Styles applied to the root element. */
  root: {
    overflow: 'hidden'
  }
};
exports.styles = styles;

function Card(props) {
  var classes = props.classes,
      className = props.className,
      raised = props.raised,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "raised"]);
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className),
    elevation: raised ? 8 : 1
  }, other));
}

Card.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the card will use raised styling.
   */
  raised: _propTypes.default.bool
} : {};
Card.defaultProps = {
  raised: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCard'
})(Card);

exports.default = _default;

/***/ }),

/***/ "eudt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var _helpers = __webpack_require__("QbVD");

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      margin: 0
    },

    /* Styles applied to the root element if `variant="display4"`. */
    display4: theme.typography.display4,

    /* Styles applied to the root element if `variant="display3"`. */
    display3: theme.typography.display3,

    /* Styles applied to the root element if `variant="display2"`. */
    display2: theme.typography.display2,

    /* Styles applied to the root element if `variant="display1"`. */
    display1: theme.typography.display1,

    /* Styles applied to the root element if `variant="headline"`. */
    headline: theme.typography.headline,

    /* Styles applied to the root element if `variant="title"`. */
    title: theme.typography.title,

    /* Styles applied to the root element if `variant="subheading"`. */
    subheading: theme.typography.subheading,

    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,

    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,

    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,

    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `align="nowrap"`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: '0.35em'
    },

    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    }
  };
};

exports.styles = styles;

function Typography(props) {
  var _classNames;

  var align = props.align,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      componentProp = props.component,
      gutterBottom = props.gutterBottom,
      headlineMapping = props.headlineMapping,
      noWrap = props.noWrap,
      paragraph = props.paragraph,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["align", "classes", "className", "color", "component", "gutterBottom", "headlineMapping", "noWrap", "paragraph", "variant"]);
  var className = (0, _classnames.default)(classes.root, classes[variant], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.noWrap, noWrap), (0, _defineProperty2.default)(_classNames, classes.gutterBottom, gutterBottom), (0, _defineProperty2.default)(_classNames, classes.paragraph, paragraph), (0, _defineProperty2.default)(_classNames, classes["align".concat((0, _helpers.capitalize)(align))], align !== 'inherit'), _classNames), classNameProp);
  var Component = componentProp || (paragraph ? 'p' : headlineMapping[variant]) || 'span';
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Typography.propTypes =  false ? {
  /**
   * Set the text-align on the component.
   */
  align: _propTypes.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the variant to a good default headline component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: _propTypes.default.bool,

  /**
   * We are empirically mapping the variant property to a range of different DOM element types.
   * For instance, h1 to h6. If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` property.
   */
  headlineMapping: _propTypes.default.object,

  /**
   * If `true`, the text will not wrap, but instead will truncate with an ellipsis.
   */
  noWrap: _propTypes.default.bool,

  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: _propTypes.default.bool,

  /**
   * Applies the theme typography styles.
   */
  variant: _propTypes.default.oneOf(['display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading', 'body2', 'body1', 'caption', 'button'])
} : {};
Typography.defaultProps = {
  align: 'inherit',
  color: 'default',
  gutterBottom: false,
  headlineMapping: {
    display4: 'h1',
    display3: 'h1',
    display2: 'h1',
    display1: 'h1',
    headline: 'h1',
    title: 'h2',
    subheading: 'h3',
    body2: 'aside',
    body1: 'p'
  },
  noWrap: false,
  paragraph: false,
  variant: 'body1'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTypography'
})(Typography);

exports.default = _default;

/***/ }),

/***/ "fKPv":
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "fsZm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTranslateValue = setTranslateValue;
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__("HBRR"));

var _createClass2 = _interopRequireDefault(__webpack_require__("ud+X"));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__("rjj8"));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__("X+J+"));

var _inherits2 = _interopRequireDefault(__webpack_require__("ymoH"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _reactDom = _interopRequireDefault(__webpack_require__("O27J"));

var _reactEventListener = _interopRequireDefault(__webpack_require__("/Ngn"));

var _debounce = _interopRequireDefault(__webpack_require__("HhAh"));

var _Transition = _interopRequireDefault(__webpack_require__("TAxY"));

var _ownerWindow = _interopRequireDefault(__webpack_require__("3zl2"));

var _withTheme = _interopRequireDefault(__webpack_require__("MDtq"));

var _transitions = __webpack_require__("z+QM");

var _utils = __webpack_require__("T1RF");

// @inheritedComponent Transition
// < 1kb payload overhead when lodash/debounce is > 3kb.
var GUTTER = 24; // Translate the node so he can't be seen on the screen.
// Later, we gonna translate back the node to his original location
// with `translate3d(0, 0, 0)`.`

function getTranslateValue(props, node) {
  var direction = props.direction;
  var rect = node.getBoundingClientRect();
  var transform;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = (0, _ownerWindow.default)(node).getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  var offsetX = 0;
  var offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    var transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    return "translateX(100vw) translateX(-".concat(rect.left - offsetX, "px)");
  }

  if (direction === 'right') {
    return "translateX(-".concat(rect.left + rect.width + GUTTER - offsetX, "px)");
  }

  if (direction === 'up') {
    return "translateY(100vh) translateY(-".concat(rect.top - offsetY, "px)");
  } // direction === 'down'


  return "translateY(-".concat(rect.top + rect.height + GUTTER - offsetY, "px)");
}

function setTranslateValue(props, node) {
  var transform = getTranslateValue(props, node);

  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}
/**
 * The Slide transition is used by the [Snackbar](/demos/snackbars) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */


var Slide =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Slide, _React$Component);

  function Slide() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Slide);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Slide)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.mounted = false;
    _this.transition = null;
    _this.handleResize = (0, _debounce.default)(function () {
      // Skip configuration where the position is screen size invariant.
      if (_this.props.in || _this.props.direction === 'down' || _this.props.direction === 'right') {
        return;
      }

      if (_this.transitionRef) {
        setTranslateValue(_this.props, _this.transitionRef);
      }
    }, 166);

    _this.handleEnter = function (node) {
      setTranslateValue(_this.props, node);
      (0, _utils.reflow)(node);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleEntering = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
        easing: theme.transitions.easing.easeOut
      }));
      node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
        easing: theme.transitions.easing.easeOut
      }));
      node.style.webkitTransform = 'translate(0, 0)';
      node.style.transform = 'translate(0, 0)';

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    };

    _this.handleExit = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
        easing: theme.transitions.easing.sharp
      }));
      node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
        easing: theme.transitions.easing.sharp
      }));
      setTranslateValue(_this.props, node);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.handleExited = function (node) {
      // No need for transitions when the component is hidden
      node.style.webkitTransition = '';
      node.style.transition = '';

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Slide, [{
    key: "componentDidMount",
    // Corresponds to 10 frames at 60 Hz.
    value: function componentDidMount() {
      // state.mounted handle SSR, once the component is mounted, we need
      // to properly hide it.
      if (!this.props.in) {
        // We need to set initial translate values of transition element
        // otherwise component will be shown when in=false.
        this.updatePosition();
      }

      this.mounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.direction !== this.props.direction && !this.props.in) {
        // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        this.updatePosition();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
    }
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      if (this.transitionRef) {
        this.transitionRef.style.visibility = 'inherit';
        setTranslateValue(this.props, this.transitionRef);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          onEnter = _this$props.onEnter,
          onEntering = _this$props.onEntering,
          onExit = _this$props.onExit,
          onExited = _this$props.onExited,
          styleProp = _this$props.style,
          theme = _this$props.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "onEnter", "onEntering", "onExit", "onExited", "style", "theme"]);
      var style = {}; // We use this state to handle the server-side rendering.
      // We don't know the width of the children ahead of time.
      // We need to render it.

      if (!this.props.in && !this.mounted) {
        style.visibility = 'hidden';
      }

      style = (0, _extends2.default)({}, style, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }, _react.default.createElement(_Transition.default, (0, _extends2.default)({
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onExit: this.handleExit,
        onExited: this.handleExited,
        appear: true,
        style: style,
        ref: function ref(_ref) {
          _this2.transitionRef = _reactDom.default.findDOMNode(_ref);
        }
      }, other), children));
    }
  }]);
  return Slide;
}(_react.default.Component);

Slide.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * Direction the child node will enter from.
   */
  direction: _propTypes.default.oneOf(['left', 'right', 'up', 'down']),

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onEntering: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  onExited: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : {};
Slide.defaultProps = {
  direction: 'down',
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withTheme.default)()(Slide);

exports.default = _default;

/***/ }),

/***/ "g6PY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observer__ = __webpack_require__("XhuR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("1fQI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__("6aW6");
/* unused harmony namespace reexport */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var observerOptions = ['root', 'rootMargin', 'threshold'];
var observableProps = ['root', 'rootMargin', 'threshold', 'disabled'];
var getOptions = function (props) {
    return observerOptions.reduce(function (options, key) {
        var _a;
        var isRootString = key === 'root' && __WEBPACK_IMPORTED_MODULE_3__utils__["f" /* toString */].call(props.root) === '[object String]';
        return Object.assign(options, (_a = {},
            _a[key] = isRootString
                ? document.querySelector(props[key])
                : props[key],
            _a));
    }, {});
};
var ReactIntersectionObserver = /** @class */ (function (_super) {
    __extends(ReactIntersectionObserver, _super);
    function ReactIntersectionObserver() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (event) {
            _this.props.onChange(event, _this.externalUnobserve);
        };
        _this.handleNode = function (target) {
            var children = _this.props.children;
            /**
             * Forward hijacked ref to user.
             */
            if (Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* isChildrenWithRef */])(children)) {
                var childenRef = children.ref;
                if (typeof childenRef === 'function') {
                    childenRef(target);
                }
                else if (childenRef && __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* hasOwnProperty */].call(childenRef, 'current')) {
                    /*
                     * The children ref.current is read-only, we aren't allowed to do this, so
                     * in future release it has to go away, and the ref shall be
                     * forwarded and assigned to a DOM node by the user.
                     */
                    childenRef.current = target;
                }
            }
            _this.targetNode = undefined;
            if (target) {
                var targetNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(target);
                if (targetNode && targetNode.nodeType === 1) {
                    _this.targetNode = targetNode;
                }
            }
        };
        _this.observe = function () {
            if (_this.props.children == null || _this.props.disabled) {
                return false;
            }
            if (!_this.targetNode) {
                throw new Error("ReactIntersectionObserver: Can't find DOM node in the provided children. Make sure to render at least one DOM node in the tree.");
            }
            _this.observer = Object(__WEBPACK_IMPORTED_MODULE_2__observer__["a" /* createObserver */])(getOptions(_this.props));
            _this.target = _this.targetNode;
            Object(__WEBPACK_IMPORTED_MODULE_2__observer__["b" /* observeElement */])(_this);
            return true;
        };
        _this.unobserve = function (target) {
            Object(__WEBPACK_IMPORTED_MODULE_2__observer__["c" /* unobserveElement */])(_this, target);
        };
        _this.externalUnobserve = function () {
            if (_this.targetNode) {
                _this.unobserve(_this.targetNode);
            }
        };
        return _this;
    }
    ReactIntersectionObserver.prototype.getSnapshotBeforeUpdate = function (prevProps) {
        var _this = this;
        this.prevTargetNode = this.targetNode;
        var relatedPropsChanged = observableProps.some(function (prop) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* shallowCompare */])(_this.props[prop], prevProps[prop]);
        });
        if (relatedPropsChanged) {
            if (this.prevTargetNode) {
                if (!prevProps.disabled) {
                    this.unobserve(this.prevTargetNode);
                }
            }
        }
        return relatedPropsChanged;
    };
    ReactIntersectionObserver.prototype.componentDidUpdate = function (_, __, relatedPropsChanged) {
        var targetNodeChanged = false;
        // check if we didn't unobserve previously due to a prop change
        if (!relatedPropsChanged) {
            targetNodeChanged = this.prevTargetNode !== this.targetNode;
            // check we have a previous node we want to unobserve
            if (targetNodeChanged && this.prevTargetNode != null) {
                this.unobserve(this.prevTargetNode);
            }
        }
        if (relatedPropsChanged || targetNodeChanged) {
            this.observe();
        }
    };
    ReactIntersectionObserver.prototype.componentDidMount = function () {
        this.observe();
    };
    ReactIntersectionObserver.prototype.componentWillUnmount = function () {
        if (this.targetNode) {
            this.unobserve(this.targetNode);
        }
    };
    ReactIntersectionObserver.prototype.render = function () {
        var children = this.props.children;
        return children != null
            ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children), {
                ref: this.handleNode,
            })
            : null;
    };
    ReactIntersectionObserver.displayName = 'IntersectionObserver';
    return ReactIntersectionObserver;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ReactIntersectionObserver);



/***/ }),

/***/ "gBd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),

/***/ "gHwZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _PatternGalleries = __webpack_require__("UHYW");

var _PatternGalleries2 = _interopRequireDefault(_PatternGalleries);

var _patterns = __webpack_require__("MTZW");

var _categories = __webpack_require__("afi0");

var _utils = __webpack_require__("iXJB");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CategoryPatterns = function CategoryPatterns(props) {
    return _react2.default.createElement(_PatternGalleries2.default, props);
};

var makeMapStateToProps = function makeMapStateToProps(initialState) {
    var title = (0, _categories.getCategoryTitle)(initialState);
    return function (state) {
        var _getGalleryData = (0, _patterns.getGalleryData)(state),
            patterns = _getGalleryData.patterns,
            items = _getGalleryData.items;

        var sorted = items.sort(_utils.sortNumberDesc);
        return {
            title: title,
            patterns: patterns,
            items: sorted,
            totalHits: 100
        };
    };
};

exports.default = (0, _reactRedux.connect)(makeMapStateToProps)(CategoryPatterns);

/***/ }),

/***/ "ggcY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _CloudFrontPicture = __webpack_require__("k6iV");

var _CloudFrontPicture2 = _interopRequireDefault(_CloudFrontPicture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GalleryOverlay = function GalleryOverlay(_ref) {
    var children = _ref.children,
        overlay = _ref.overlay,
        path = _ref.path;

    var PatternContainer = _styledComponents2.default.div.withConfig({
        displayName: 'GalleryOverlay__PatternContainer',
        componentId: 'sc-1aqo8ik-0'
    })(['\n        position: relative;\n        top: 0;\n        left: 0;\n        max-width: ', 'px;\n        overflow: hidden;\n        margin-left: auto;\n        margin-right: auto;\n    '], overlay.width - 2);
    var PatternOverlay = _styledComponents2.default.div.withConfig({
        displayName: 'GalleryOverlay__PatternOverlay',
        componentId: 'sc-1aqo8ik-1'
    })(['\n        position: relative;\n        top: 0;\n        left: 0;\n        z-index: 2;\n        line-height: 0;\n    ']);

    return _react2.default.createElement(
        PatternContainer,
        null,
        children,
        _react2.default.createElement(
            PatternOverlay,
            null,
            _react2.default.createElement(_CloudFrontPicture2.default, {
                src: overlay.src, wepb: overlay.webp, png: true, schnoffle: true,
                path: path,
                altText: 'Sewing pattern shadow overlay, displays patterns as a figurine.'
            })
        )
    );
};

GalleryOverlay.propTypes = {
    overlay: _propTypes2.default.shape({
        src: _propTypes2.default.string.isRequired,
        webp: _propTypes2.default.string.isRequired,
        height: _propTypes2.default.number.isRequired,
        width: _propTypes2.default.number.isRequired,
        width2: _propTypes2.default.number,
        height2: _propTypes2.default.number
    }).isRequired,
    path: _propTypes2.default.string.isRequired
};

exports.default = GalleryOverlay;

/***/ }),

/***/ "hHDH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GalleryWrapper = _styledComponents2.default.div.withConfig({
    displayName: 'PatternGalleryItems__GalleryWrapper',
    componentId: 'sc-1ci0y38-0'
})(['\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n\n    @supports (display: grid) {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n      grid-gap: 1rem;\n    }\n']);

var PatternGalleryItems = function PatternGalleryItems(items, ref) {
    return _react2.default.createElement(
        'div',
        { ref: ref },
        _react2.default.createElement(
            GalleryWrapper,
            null,
            items
        )
    );
};

exports.default = PatternGalleryItems;

/***/ }),

/***/ "hSOe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Card.default;
  }
});

var _Card = _interopRequireDefault(__webpack_require__("eIqZ"));

/***/ }),

/***/ "hhcd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PaginationButton = __webpack_require__("y40A");

var _PaginationButton2 = _interopRequireDefault(_PaginationButton);

var _Icon = __webpack_require__("PlKq");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationIcon = function PaginationIcon(_ref) {
    var direction = _ref.direction,
        disabled = _ref.disabled,
        handleClick = _ref.handleClick;

    var IconWrapper = (0, _styledComponents2.default)(_PaginationButton2.default).withConfig({
        displayName: 'PaginationIcon__IconWrapper',
        componentId: 'sc-lm2nan-0'
    })(['\n        background-color: ', ';\n        display: flex;\n        align-items: center;\n        cursor: pointer;\n    '], function (props) {
        return props.theme.palette.blueGrey[50];
    });

    return _react2.default.createElement(
        IconWrapper,
        {
            disabled: disabled,
            onClick: handleClick,
            className: disabled ? 'stolo-pager-notclickable' : ''
        },
        _react2.default.createElement(_Icon2.default, {
            width: '1.5em',
            height: '1.5em',
            name: 'icon-keyboard_arrow_' + direction,
            iconColor: disabled ? 'blueGrey.200' : 'blueGrey.500'
        })
    );
};

PaginationIcon.defaultProps = {
    disabled: false
};

PaginationIcon.propTypes = {
    direction: _propTypes2.default.oneOf(['left', 'right']).isRequired,
    disabled: _propTypes2.default.bool,
    handleClick: _propTypes2.default.func.isRequired
};

exports.default = PaginationIcon;

/***/ }),

/***/ "iTmf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Grow.default;
  }
});

var _Grow = _interopRequireDefault(__webpack_require__("s/J2"));

/***/ }),

/***/ "jSee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__researchgate_react_intersection_observer__ = __webpack_require__("VuSO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("Ga6y");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var Sentinel = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Sentinel, _Component);

  var _super = _createSuper(Sentinel);

  function Sentinel(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "setRootElement", function (rootElement) {
      _this.setState({
        rootElement: rootElement
      });
    });

    _this.state = {
      rootElement: undefined,
      rootMargin: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* computeRootMargin */])(props)
    };
    _this.target = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("template", {
      style: {
        height: 1,
        minWidth: 1,
        display: 'block'
      }
    });
    props.setRef(_this.setRootElement);
    return _this;
  }

  Sentinel.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var threshold = _ref.threshold,
        axis = _ref.axis;
    var newState = null;

    if (threshold !== prevState.threshold || axis !== prevState.axis) {
      newState = {
        threshold: threshold,
        axis: axis,
        rootMargin: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* computeRootMargin */])({
          threshold: threshold,
          axis: axis
        })
      };
    }

    return newState;
  };

  var _proto = Sentinel.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, _ref2) {
    var rootMargin = _ref2.rootMargin,
        rootElement = _ref2.rootElement;
    var _this$state = this.state,
        currentRootMargin = _this$state.rootMargin,
        currentRootElement = _this$state.rootElement; // When the rootMargin stays the same but the sentinel is repositioned, it can fall within
    // its threshold prematurely. In this case we don't get any update from the Observer instance.
    // We need to guarantee an update, and re-observing is a cheap way to accomplish this.

    if (currentRootMargin === rootMargin && currentRootElement === rootElement) {
      this.observer.externalUnobserve();
      this.observer.observe();
      return false;
    }

    return true;
  };

  _proto.render = function render() {
    var _this2 = this;

    var onChange = this.props.onChange;
    var _this$state2 = this.state,
        rootElement = _this$state2.rootElement,
        rootMargin = _this$state2.rootMargin;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__researchgate_react_intersection_observer__["a" /* default */], {
      ref: function ref(instance) {
        _this2.observer = instance;
      },
      disabled: typeof rootElement === 'undefined',
      root: rootElement,
      rootMargin: rootMargin,
      onChange: onChange
    }, this.target);
  };

  return Sentinel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

 false ? Sentinel.propTypes = {
  axis: PropTypes.oneOf(['x', 'y']).isRequired,
  threshold: PropTypes.string.isRequired,
  setRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Sentinel);

/***/ }),

/***/ "jaTo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _BottomNavigationAction.default;
  }
});

var _BottomNavigationAction = _interopRequireDefault(__webpack_require__("xpsS"));

/***/ }),

/***/ "k6iV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__("ExK/");

var _Picture2 = _interopRequireDefault(_Picture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloudFrontPicture = function CloudFrontPicture(_ref) {
    var src = _ref.src,
        webp = _ref.webp,
        gif = _ref.gif,
        altText = _ref.altText,
        png = _ref.png,
        schnoffle = _ref.schnoffle,
        _ref$path = _ref.path,
        path = _ref$path === undefined ? 'images' : _ref$path,
        noQuery = _ref.noQuery;

    var queryString = noQuery ? '' : '?x-schnoffle-request=gallery';
    var base = schnoffle ? 'https://d1hifgxwzqc0jz.cloudfront.net/' + path + '/' : 'https://dd2k02hhj0n6fcf.cloudfront.net/' + path + '/';
    var webpSource = webp ? base + webp + queryString : null;
    var imgSource = src ? base + src + queryString : null;
    var gifSource = gif ? base + gif + queryString : null;

    return _react2.default.createElement(_Picture2.default, {
        webp: webpSource, gif: gifSource, src: imgSource, altText: altText,
        png: png
    });
};

exports.default = CloudFrontPicture;

/***/ }),

/***/ "kgLe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Portal.default;
  }
});

var _Portal = _interopRequireDefault(__webpack_require__("e1dG"));

/***/ }),

/***/ "lyam":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['font-size: 0.53em;'], ['font-size: 0.53em;']);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _breakpoints = __webpack_require__("xE7l");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

exports.default = _styledComponents2.default.span.withConfig({
    displayName: 'IconText',
    componentId: 'sc-jt7041-0'
})(['\n    font-size: 0.58em\n    line-height: 1;\n    \n    ', '\n    ', '\n    \n'], _breakpoints.media.wideScreenUp(_templateObject), _breakpoints.media.tweak1600up(_templateObject));

/***/ }),

/***/ "m/+C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("R6lU");

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__("ChDW"));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__("mWV2"));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__("VjCY"));

var _removeStyle = _interopRequireDefault(__webpack_require__("DBHA"));

var _properties = __webpack_require__("S9Yq");

var _isTransform = _interopRequireDefault(__webpack_require__("OOzO"));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),

/***/ "mWV2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("R6lU");

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__("wrUV"));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),

/***/ "mjrp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactRedux = __webpack_require__("RH2O");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Placeholder = function Placeholder(_ref) {
    var icons = _ref.icons;


    var SVG = _styledComponents2.default.svg.withConfig({
        displayName: 'ImagePlaceholder__SVG',
        componentId: 'sc-1aebw5t-0'
    })(['\n        max-width: 400px;\n        max-height: 400px;\n        min-height: 250px;\n        min-width: 250px;\n        background: #607D8B;\n        background: linear-gradient(to bottom, #607D8B 0%, #ECEFF1 100%);\n        width: 100%;\n        height: 100%;\n        flex-grow: 1;\n        flex-shrink: 1;\n        fill: ', ';\n        margin: 0 auto;\n    '], function (props) {
        return props.theme.palette.blueGrey[100];
    });

    return _react2.default.createElement(
        SVG,
        null,
        _react2.default.createElement('use', { xlinkHref: icons + '#icon-image-placeholder' })
    );
};

var makeMapStateToProps = function makeMapStateToProps(initialState) {
    var icons = initialState.icons.icons;

    var mapStateToProps = function mapStateToProps() {
        return {
            icons: icons
        };
    };
    return mapStateToProps;
};

exports.default = (0, _reactRedux.connect)(makeMapStateToProps)(Placeholder);

/***/ }),

/***/ "nF0i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__("p0U1");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });


/***/ }),

/***/ "nKa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['flex-basis: 23vw;'], ['flex-basis: 23vw;']),
    _templateObject2 = _taggedTemplateLiteral(['flex-basis: 30vw;'], ['flex-basis: 30vw;']),
    _templateObject3 = _taggedTemplateLiteral(['\n          font-size: 0.95rem;\n          flex-basis: 40vw; \n          max-width: 47%;\n        '], ['\n          font-size: 0.95rem;\n          flex-basis: 40vw; \n          max-width: 47%;\n        ']),
    _templateObject4 = _taggedTemplateLiteral(['\n          font-size: 0.95rem;\n          flex-basis: 80vw; \n          max-width: 400px;\n        '], ['\n          font-size: 0.95rem;\n          flex-basis: 80vw; \n          max-width: 400px;\n        ']);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _InternalLink = __webpack_require__("XSs2");

var _InternalLink2 = _interopRequireDefault(_InternalLink);

var _breakpoints = __webpack_require__("xE7l");

var _PatternCardHeader = __webpack_require__("xp2j");

var _PatternCardHeader2 = _interopRequireDefault(_PatternCardHeader);

var _PatternCardPattern = __webpack_require__("OXhf");

var _PatternCardPattern2 = _interopRequireDefault(_PatternCardPattern);

var _Card = __webpack_require__("hSOe");

var _Card2 = _interopRequireDefault(_Card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledCard = (0, _styledComponents2.default)(_Card2.default).withConfig({
    displayName: 'PatternCardBase__StyledCard',
    componentId: 'sc-b7nqdv-0'
})(['\n        max-width: 400px;\n        max-height: 95vh;\n        margin-top: 1em;\n        flex-shrink: 1;\n        flex-grow:1;\n        font-family:  ', ';\n        box-sizing: border-box;\n        text-align: center;\n        position: relative;\n        padding-bottom: ', ';\n        overflow: hidden;\n        margin-right: 0.5em;\n        margin-left: 0.5em;\n        \n        ', '\n        ', '\n        ', '\n        ', '\n        ', '\n        \n        & a:hover {\n            text-decoration-color: ', ';\n        }\n         \n        & .stolo-gallery-img-link {\n            display: block;\n            border-bottom: 1px dashed #DDD;\n        }\n    \n    & .card-to-bottom {\n      margin-top: 0px;\n      width: 100%;\n    }\n    \n    @supports (display:grid){\n       width: inherit;\n       max-width: 92%;\n       margin: 0 auto;\n    }\n    \n   '], function (props) {
    return props.theme.condensed;
}, function (props) {
    return props.theme.space[3];
}, _breakpoints.media.wideScreenUp(_templateObject), _breakpoints.media.normalLandscapeUp(_templateObject), _breakpoints.media.tweak900up(_templateObject2), _breakpoints.media.normalPortraitUp(_templateObject3), _breakpoints.media.tweak600up(_templateObject4), function (props) {
    return props.theme.palette.common.text;
});

var PatternCardBase = function PatternCardBase(_ref) {
    var imgUri = _ref.imgUri,
        LinkProps = _ref.LinkProps,
        title = _ref.title,
        children = _ref.children,
        overlay = _ref.overlay,
        overlayPath = _ref.overlayPath;
    return _react2.default.createElement(
        StyledCard,
        null,
        _react2.default.createElement(
            _InternalLink2.default,
            { to: LinkProps, className: 'stolo-gallery-img-link' },
            _react2.default.createElement(_PatternCardPattern2.default, { imgUri: imgUri, overlay: overlay, overlayPath: overlayPath })
        ),
        _react2.default.createElement(
            'div',
            { className: 'card-to-bottom' },
            _react2.default.createElement(
                _InternalLink2.default,
                { to: LinkProps },
                _react2.default.createElement(_PatternCardHeader2.default, { title: title })
            ),
            children
        )
    );
};

exports.default = PatternCardBase;

/***/ }),

/***/ "nOk+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BottomNavigation = __webpack_require__("6Gx2");

var _BottomNavigation2 = _interopRequireDefault(_BottomNavigation);

var _BottomNavigationAction = __webpack_require__("jaTo");

var _BottomNavigationAction2 = _interopRequireDefault(_BottomNavigationAction);

var _Menu = __webpack_require__("BAI3");

var _Menu2 = _interopRequireDefault(_Menu);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _queryString = __webpack_require__("OAwv");

var _queryString2 = _interopRequireDefault(_queryString);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _uiActions = __webpack_require__("rj0T");

var _i18n = __webpack_require__("lg9U");

var _page = __webpack_require__("4f5n");

var _sewpats = __webpack_require__("iBUI");

var _Icon = __webpack_require__("PlKq");

var _Icon2 = _interopRequireDefault(_Icon);

var _PinterestIcon = __webpack_require__("OhP/");

var _PinterestIcon2 = _interopRequireDefault(_PinterestIcon);

var _ShareMenu = __webpack_require__("MTWR");

var _ShareMenu2 = _interopRequireDefault(_ShareMenu);

var _ShareMenuItem = __webpack_require__("Yx17");

var _ShareMenuItem2 = _interopRequireDefault(_ShareMenuItem);

var _SnackBar = __webpack_require__("1nqX");

var _SnackBar2 = _interopRequireDefault(_SnackBar);

var _FlatInputShareMenu = __webpack_require__("AuuR");

var _FlatInputShareMenu2 = _interopRequireDefault(_FlatInputShareMenu);

var _IconText = __webpack_require__("lyam");

var _IconText2 = _interopRequireDefault(_IconText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ActionBar = (0, _styledComponents2.default)(_BottomNavigation2.default).withConfig({
    displayName: 'PatternGalleryBarFull__ActionBar',
    componentId: 'sc-14drxsw-0'
})(['\n    &.stolo-gallery-bar {\n        height: ', ';\n        position: relative;\n    }\n    \n    & .stolo-gallery-bar-button {\n      padding-top: 0.3em;\n    }\n    \n    & .stolo-gallery-bar-button span {\n      margin-top: -0.1em;\n      line-height: 1;\n    }\n'], function (props) {
    return props.theme.space[13];
});

var PatternGalleryBarFull = function (_React$Component) {
    _inherits(PatternGalleryBarFull, _React$Component);

    function PatternGalleryBarFull() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PatternGalleryBarFull);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PatternGalleryBarFull.__proto__ || Object.getPrototypeOf(PatternGalleryBarFull)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            anchorEl: null,
            open: false
        }, _this.handleClick = function (event) {
            _this.setState({
                open: true,
                anchorEl: event.currentTarget
            });
        }, _this.onCopyClick = function () {
            if (_this.input && _this.input.select) {
                // select text
                _this.input.select();
                try {
                    // copy text
                    document.execCommand('copy');
                    _this.input.blur();
                } catch (err) {
                    alert('please press Ctrl/Cmd+C to copy');
                }
            }
            _this.props.showSavedToClipBoard(Date.now());
            _this.handleRequestClose();
        }, _this.handleRequestClose = function () {
            _this.setState({
                open: false,
                anchorEl: null
            });
        }, _this.getUri = function () {
            var uri = _this.props.shareBaseUri;
            uri = uri + '/schnoff/' + _this.props.sewpatId + '/' + _this.props.pattern.id;
            if (_this.props.query) {
                var query = _queryString2.default.stringify(_this.props.query);
                if (query.length > 0) {
                    uri = uri + '?' + query;
                }
            }
            return uri;
        }, _this.getMedia = function () {
            return _this.props.imgSrc || (((_this.props.pattern || {}).thumbnails || {}).xlargeDiscreet || {}).url;
        }, _this.getDescription = function () {
            var pattern = _this.props.pattern;
            var description = _this.props.pattern.title + ' - Designerst\xFCck (Schnittmuster Berlin) auf umf\xE4rbbaren Stoffmotiv designt von ' + _this.props.designerName + ' | www.schnoffle.de';
            return description;
        }, _this.handleAddToFavorites = function () {
            _this.props.addToFavorites(_this.props.pattern.id, _this.props.sewpatId);
            _this.props.showAddedToFavorites(Date.now());
        }, _this.handleRemoveFromFavorites = function () {
            _this.props.removeFromFavorites(_this.props.pattern.id, _this.props.sewpatId, _this.props.query);
        }, _this.handleGoToPattern = function () {
            _this.props.goToPattern(_this.props.pattern.id, _this.props.sewpatId, _this.props.query);
        }, _this.iconColor = 'blueGrey.700', _this.iconDimension = {
            width: '1.5rem',
            height: '1.5rem'
        }, _this.FavoritesAction = function () {
            if (_this.props.removeFavorites !== true) {
                return _react2.default.createElement(_BottomNavigationAction2.default, {
                    onClick: _this.handleAddToFavorites,
                    component: 'div',
                    label: _react2.default.createElement(
                        _IconText2.default,
                        null,
                        _this.props.labelAddToFavorites
                    ),
                    value: 'addtofavorite',
                    icon: _react2.default.createElement(_Icon2.default, _extends({
                        name: 'icon-heartadd'
                    }, _this.iconDimension, {
                        iconColor: _this.iconColor
                    }))
                });
            }
            return _react2.default.createElement(_BottomNavigationAction2.default, {
                onClick: _this.handleRemoveFromFavorites,
                component: 'div',
                label: _react2.default.createElement(
                    _IconText2.default,
                    null,
                    _this.props.labelRemoveFromFavorites
                ),
                value: 'removefavorite',
                icon: _react2.default.createElement(_Icon2.default, _extends({
                    name: 'icon-heartremove'
                }, _this.iconDimension, {
                    iconColor: _this.iconColor
                }))
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PatternGalleryBarFull, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                labelAddToCart = _props.labelAddToCart,
                labelAddToFavorites = _props.labelAddToFavorites,
                labelRemoveFromFavorites = _props.labelRemoveFromFavorites,
                labelColoring = _props.labelColoring,
                pattern = _props.pattern,
                addToFavorites = _props.addToFavorites,
                removeFromFavorites = _props.removeFromFavorites,
                goToPattern = _props.goToPattern,
                removeFavorites = _props.removeFavorites,
                query = _props.query,
                showAddedToFavorites = _props.showAddedToFavorites,
                imgSrc = _props.imgSrc,
                designerName = _props.designerName,
                sewpatId = _props.sewpatId,
                shareMenuLabel = _props.shareMenuLabel;


            return _react2.default.createElement(
                ActionBar,
                {
                    classes: { root: 'stolo-gallery-bar' },
                    showLabels: true,
                    value: 'null'
                },
                this.FavoritesAction(),
                _react2.default.createElement(_BottomNavigationAction2.default, {
                    onClick: this.state.open ? null : this.handleClick,
                    component: 'div',
                    label: _react2.default.createElement(
                        _IconText2.default,
                        null,
                        this.props.shareMenuLabel
                    ),
                    value: 'share',
                    icon: _react2.default.createElement(_Icon2.default, _extends({
                        name: 'icon-share'
                    }, this.iconDimension, {
                        iconColor: this.iconColor
                    })),
                    id: this.props.patternid,
                    key: this.props.patternid
                }),
                _react2.default.createElement(
                    _Menu2.default,
                    {
                        id: 'simple-menu',
                        anchorEl: this.state.anchorEl,
                        open: this.state.open,
                        onClose: this.handleRequestClose
                    },
                    _react2.default.createElement(
                        _ShareMenuItem2.default,
                        { handleClick: this.handleRequestClose },
                        _react2.default.createElement(_PinterestIcon2.default, {
                            iconProps: {
                                name: 'icon-pinterest2',
                                width: '1.3em',
                                height: '1.3em',
                                iconColor: 'blueGrey.700'
                            },
                            buttonText: this.props.sharePinterestLabel,
                            shareTarget: this.getUri(),
                            media: this.getMedia(),
                            description: this.getDescription()
                        })
                    ),
                    _react2.default.createElement(
                        _ShareMenuItem2.default,
                        {
                            ref: function ref(element) {
                                _this2.button = element;
                            }, handleClick: this.onCopyClick
                        },
                        _react2.default.createElement(
                            _FlatInputShareMenu2.default,
                            null,
                            _react2.default.createElement(_Icon2.default, {
                                name: 'icon-link',
                                width: '1.4em',
                                height: '1.2em',
                                iconColor: 'blueGrey.700'
                            }),
                            ' ',
                            this.props.shareLinkLabel,
                            _react2.default.createElement('input', {
                                ref: function ref(element) {
                                    _this2.input = element;
                                },
                                type: 'text',
                                value: this.getUri(),
                                readOnly: true
                            })
                        )
                    )
                ),
                _react2.default.createElement(_BottomNavigationAction2.default, {
                    onClick: this.handleGoToPattern,
                    component: 'div',
                    label: _react2.default.createElement(
                        _IconText2.default,
                        null,
                        labelColoring
                    ),
                    value: 'color',
                    icon: _react2.default.createElement(_Icon2.default, _extends({
                        name: 'icon-palette'
                    }, this.iconDimension, {
                        iconColor: this.iconColor
                    }))
                }),
                _react2.default.createElement(_SnackBar2.default, null)
            );
        }
    }]);

    return PatternGalleryBarFull;
}(_react2.default.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        showSavedToClipBoard: function showSavedToClipBoard(id) {
            return dispatch((0, _uiActions.showSnack)(id, 'SNACK_LINK_COPIED_TO_CLIPBOARD', null, 3000, null));
        }
    };
};

var makeMapStateToProps = function makeMapStateToProps(initialState, initialOwnProps) {
    var sharePinterest = (0, _i18n.getMessage)(initialState, 'SHARE_ON_PINTEREST_BUTTON_LABEL');
    var sharePinterestPrefix = (0, _i18n.getMessage)(initialState, 'SHARE_ON_PINTEREST_DEFAULT_PREFIX');
    var shareLabel = (0, _i18n.getMessage)(initialState, 'ICON_LABEL_SHARE');
    var shareLink = (0, _i18n.getMessage)(initialState, initialOwnProps.messageId || 'SHARE_COPY_LINK_BUTTON_LABEL');
    var sewpatId = (0, _sewpats.getActiveSewpatId)(initialState);
    var mapStateToProps = function mapStateToProps(state) {
        return _extends({
            sharePinterestLabel: sharePinterest,
            sharePinterestPrefix: sharePinterestPrefix,
            shareLinkLabel: shareLink,
            shareBaseUri: (0, _page.getCurrentBaseUri)(state),
            shareMenuLabel: shareLabel,
            sewpatId: sewpatId
        }, initialOwnProps);
    };
    return mapStateToProps;
};

_ShareMenu2.default.defaultProps = {
    pattern: {}
};

_ShareMenu2.default.propTypes = {
    pattern: _propTypes2.default.object.required
};

exports.default = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps)(PatternGalleryBarFull);

/***/ }),

/***/ "p0U1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__("rkok");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sentinel__ = __webpack_require__("jSee");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__("Ga6y");
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var AXIS_CSS_MAP = {
  x: 'overflowX',
  y: 'overflowY'
};

var List = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(List, _PureComponent);

  var _super = _createSuper(List);

  function List() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      size: 0
    });

    _defineProperty(_assertThisInitialized(_this), "setRef", function (callback) {
      var prevRootNode;

      _this.setRootNode = function (node) {
        if (node !== prevRootNode) {
          prevRootNode = node;

          var overflow = window.getComputedStyle(node)[AXIS_CSS_MAP[_this.props.axis]];

          callback(['auto', 'scroll', 'overlay'].indexOf(overflow) !== -1 ? node : null);
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleUpdate", function (_ref) {
      var isIntersecting = _ref.isIntersecting;
      var _this$props = _this.props,
          awaitMore = _this$props.awaitMore,
          onIntersection = _this$props.onIntersection;
      var _this$state = _this.state,
          size = _this$state.size,
          itemCount = _this$state.itemCount,
          pageSize = _this$state.pageSize;

      if (!_this.prematureIntersectionChecked) {
        _this.prematureIntersectionChecked = true;
        __WEBPACK_IMPORTED_MODULE_2_warning___default()(!isIntersecting, 'ReactIntersectionList: the sentinel detected a viewport with a bigger size than the size of its items. ' + 'This could lead to detrimental behavior, e.g.: triggering more than one onIntersection callback at the start.\n' + 'To prevent this, use either a bigger `pageSize` value or avoid using the prop awaitMore initially.');
      }

      if (isIntersecting) {
        var nextSize = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* computeSize */])(size + pageSize, itemCount);

        if (size !== nextSize) {
          _this.setState({
            size: nextSize
          });
        }

        if (onIntersection && (!awaitMore || _this.awaitIntersection)) {
          if (_this.awaitIntersection) {
            _this.awaitIntersection = false;
          }

          onIntersection(nextSize, pageSize);
        }
      }
    });

    return _this;
  }

  List.getDerivedStateFromProps = function getDerivedStateFromProps(_ref2, prevState) {
    var pageSize = _ref2.pageSize,
        props = _objectWithoutPropertiesLoose(_ref2, ["pageSize"]);

    var itemCount = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* getItemCount */])(props, true);
    var newSize;

    if (prevState.size === 0) {
      newSize = pageSize;
    } else {
      if (prevState.itemCount < itemCount) {
        newSize = prevState.size + pageSize;
      } else {
        newSize = prevState.size + -(prevState.pageSize - pageSize);
      }
    }

    return {
      pageSize: pageSize,
      itemCount: itemCount,
      size: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* computeSize */])(newSize, itemCount)
    };
  };

  var _proto = List.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.prematureIntersectionChecked = this.state.size === 0;
  };

  _proto.getItemRenderer = function getItemRenderer() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        renderItem = _this$props2.renderItem;
    var hasChildren = typeof children !== 'undefined';
    var hasRender = typeof renderItem !== 'undefined';
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(hasChildren && hasRender), 'ReactIntersectionList: cannot use children and renderItem props as render function at the same time.');

    if (hasChildren) {
      return children;
    }

    return hasRender ? renderItem : function (index, key) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        key: key
      }, index);
    };
  };

  _proto.renderItems = function renderItems() {
    var _this2 = this;

    var _this$props3 = this.props,
        awaitMore = _this$props3.awaitMore,
        axis = _this$props3.axis,
        initialIndex = _this$props3.initialIndex,
        itemsRenderer = _this$props3.itemsRenderer,
        threshold = _this$props3.threshold;
    var _this$state2 = this.state,
        size = _this$state2.size,
        itemCount = _this$state2.itemCount;
    var itemRenderer = this.getItemRenderer();
    var items = [];

    for (var i = 0; i < size; ++i) {
      items.push(itemRenderer(initialIndex + i, i));
    }

    var sentinel;

    if (size < itemCount || awaitMore) {
      sentinel = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Sentinel__["a" /* default */], {
        key: "sentinel",
        threshold: threshold,
        axis: axis,
        setRef: this.setRef,
        onChange: this.handleUpdate
      });
      items.push(sentinel);

      if (awaitMore) {
        this.awaitIntersection = true;
      }
    }

    return itemsRenderer(items, function (node) {
      if (node && sentinel) {
        _this2.setRootNode(node);
      }
    });
  };

  _proto.render = function render() {
    return this.renderItems();
  };

  return List;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

_defineProperty(List, "defaultProps", {
  axis: 'y',
  initialIndex: 0,
  itemsRenderer: function itemsRenderer(items, ref) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      ref: ref
    }, items);
  },
  pageSize: 10,
  threshold: '100px'
});

 false ? List.propTypes = {
  awaitMore: PropTypes.bool,
  axis: PropTypes.oneOf(['x', 'y']),
  children: PropTypes.func,
  initialIndex: PropTypes.number,
  items: function items(props, propName) {
    var object = props[propName];

    if (object != null && !(Array.isArray(object) || typeof object[Symbol.iterator] === 'function')) {
      return new Error("`" + propName + "` must be of type Array or a native type implementing the iterable interface");
    }

    return undefined;
  },
  itemCount: PropTypes.number,
  itemsRenderer: PropTypes.func,
  onIntersection: PropTypes.func,
  pageSize: PropTypes.number,
  renderItem: PropTypes.func,
  threshold: PropTypes.string
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (List);

/***/ }),

/***/ "p3C9":
/***/ (function(module, exports) {

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */

(function(window, document) {
'use strict';


// Exits early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}


/**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */
var registry = [];


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = entry.rootBounds;
  this.boundingClientRect = entry.boundingClientRect;
  this.intersectionRect = entry.intersectionRect || getEmptyRect();
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    // Round the intersection ratio to avoid floating point math issues:
    // https://github.com/w3c/IntersectionObserver/issues/324
    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (options.root && options.root.nodeType != 1) {
    throw new Error('root must be an Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections();
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {

    return item.element != target;
  });
  if (!this._observationTargets.length) {
    this._unmonitorIntersections();
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function() {
  if (!this._monitoringIntersections) {
    this._monitoringIntersections = true;

    // If a poll interval is set, use polling instead of listening to
    // resize and scroll events or DOM mutations.
    if (this.POLL_INTERVAL) {
      this._monitoringInterval = setInterval(
          this._checkForIntersections, this.POLL_INTERVAL);
    }
    else {
      addEvent(window, 'resize', this._checkForIntersections, true);
      addEvent(document, 'scroll', this._checkForIntersections, true);

      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
        this._domObserver = new MutationObserver(this._checkForIntersections);
        this._domObserver.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function() {
  if (this._monitoringIntersections) {
    this._monitoringIntersections = false;

    clearInterval(this._monitoringInterval);
    this._monitoringInterval = null;

    removeEvent(window, 'resize', this._checkForIntersections, true);
    removeEvent(document, 'scroll', this._checkForIntersections, true);

    if (this._domObserver) {
      this._domObserver.disconnect();
      this._domObserver = null;
    }
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, rootRect);

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: rootRect,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, rootRect) {

  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var targetRect = getBoundingClientRect(target);
  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return;

    if (parent == this.root || parent == document) {
      atRoot = true;
      parentRect = rootRect;
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      if (parent != document.body &&
          parent != document.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);

      if (!intersectionRect) break;
    }
    parent = getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {Object} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var html = document.documentElement;
    var body = document.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {Object} rect The rect object to expand.
 * @return {Object} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  return containsDeep(this.root || document, target);
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
  if (registry.indexOf(this) < 0) {
    registry.push(this);
  }
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
  var index = registry.indexOf(this);
  if (index != -1) registry.splice(index, 1);
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detatchEvent == 'function') {
    node.detatchEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object} The intersection rect or undefined if no intersection
 *     is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  };
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {Object} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {Object} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}

/**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }
  return parent;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}(window, document));


/***/ }),

/***/ "qNdj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Slide.default;
  }
});

var _Slide = _interopRequireDefault(__webpack_require__("fsZm"));

/***/ }),

/***/ "qSSY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__("HBRR"));

var _createClass2 = _interopRequireDefault(__webpack_require__("ud+X"));

var _style = _interopRequireDefault(__webpack_require__("m/+C"));

var _scrollbarSize = _interopRequireDefault(__webpack_require__("y6rd"));

var _ownerDocument = _interopRequireDefault(__webpack_require__("2BhH"));

var _isOverflowing = _interopRequireDefault(__webpack_require__("CxMQ"));

var _manageAriaHidden = __webpack_require__("8UK+");

function findIndexOf(data, callback) {
  var idx = -1;
  data.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function getPaddingRight(node) {
  return parseInt((0, _style.default)(node, 'paddingRight') || 0, 10);
}

function setContainerStyle(data, container) {
  var style = {
    overflow: 'hidden'
  }; // We are only interested in the actual `style` here because we will override it.

  data.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (data.overflowing) {
    var scrollbarSize = (0, _scrollbarSize.default)(); // Use computed style, here to get the real padding to add our scrollbar width.

    style.paddingRight = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.

    var fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');

    for (var i = 0; i < fixedNodes.length; i += 1) {
      var paddingRight = getPaddingRight(fixedNodes[i]);
      data.prevPaddings.push(paddingRight);
      fixedNodes[i].style.paddingRight = "".concat(paddingRight + scrollbarSize, "px");
    }
  }

  Object.keys(style).forEach(function (key) {
    container.style[key] = style[key];
  });
}

function removeContainerStyle(data, container) {
  Object.keys(data.style).forEach(function (key) {
    container.style[key] = data.style[key];
  });
  var fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');

  for (var i = 0; i < fixedNodes.length; i += 1) {
    fixedNodes[i].style.paddingRight = "".concat(data.prevPaddings[i], "px");
  }
}
/**
 * @ignore - do not document.
 *
 * Proper state managment for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */


var ModalManager =
/*#__PURE__*/
function () {
  function ModalManager() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, ModalManager);
    var _options$hideSiblingN = options.hideSiblingNodes,
        hideSiblingNodes = _options$hideSiblingN === void 0 ? true : _options$hideSiblingN,
        _options$handleContai = options.handleContainerOverflow,
        handleContainerOverflow = _options$handleContai === void 0 ? true : _options$handleContai;
    this.hideSiblingNodes = hideSiblingNodes;
    this.handleContainerOverflow = handleContainerOverflow; // this.modals[modalIdx] = modal

    this.modals = []; // this.containers[containerIdx] = container

    this.containers = []; // this.data[containerIdx] = {
    //   modals: [],
    // }

    this.data = [];
  }

  (0, _createClass2.default)(ModalManager, [{
    key: "add",
    value: function add(modal, container) {
      var modalIdx = this.modals.indexOf(modal);

      if (modalIdx !== -1) {
        return modalIdx;
      }

      modalIdx = this.modals.length;
      this.modals.push(modal);

      if (this.hideSiblingNodes) {
        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
      }

      var containerIdx = this.containers.indexOf(container);

      if (containerIdx !== -1) {
        this.data[containerIdx].modals.push(modal);
        return modalIdx;
      }

      var data = {
        modals: [modal],
        overflowing: (0, _isOverflowing.default)(container),
        prevPaddings: []
      };

      if (this.handleContainerOverflow) {
        setContainerStyle(data, container);
      }

      this.containers.push(container);
      this.data.push(data);
      return modalIdx;
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var modalIdx = this.modals.indexOf(modal);

      if (modalIdx === -1) {
        return modalIdx;
      }

      var containerIdx = findIndexOf(this.data, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var data = this.data[containerIdx];
      var container = this.containers[containerIdx];
      data.modals.splice(data.modals.indexOf(modal), 1);
      this.modals.splice(modalIdx, 1); // If that was the last modal in a container, clean up the container.

      if (data.modals.length === 0) {
        if (this.handleContainerOverflow) {
          removeContainerStyle(data, container);
        }

        if (this.hideSiblingNodes) {
          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
        }

        this.containers.splice(containerIdx, 1);
        this.data.splice(containerIdx, 1);
      } else if (this.hideSiblingNodes) {
        // Otherwise make sure the next top modal is visible to a screan reader.
        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
      }

      return modalIdx;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
  }]);
  return ModalManager;
}();

var _default = ModalManager;
exports.default = _default;

/***/ }),

/***/ "qZFC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__("HBRR"));

var _createClass2 = _interopRequireDefault(__webpack_require__("ud+X"));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__("rjj8"));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__("X+J+"));

var _inherits2 = _interopRequireDefault(__webpack_require__("ymoH"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _reactDom = _interopRequireDefault(__webpack_require__("O27J"));

var _warning = _interopRequireDefault(__webpack_require__("mG8X"));

var _debounce = _interopRequireDefault(__webpack_require__("HhAh"));

var _reactEventListener = _interopRequireDefault(__webpack_require__("/Ngn"));

var _ownerDocument = _interopRequireDefault(__webpack_require__("2BhH"));

var _ownerWindow = _interopRequireDefault(__webpack_require__("3zl2"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var _Modal = _interopRequireDefault(__webpack_require__("uD7C"));

var _Grow = _interopRequireDefault(__webpack_require__("iTmf"));

var _Paper = _interopRequireDefault(__webpack_require__("L4iW"));

// @inheritedComponent Modal
// < 1kb payload overhead when lodash/debounce is > 3kb.
function getOffsetTop(rect, vertical) {
  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}

function getOffsetLeft(rect, horizontal) {
  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? "".concat(n, "px") : n;
  }).join(' ');
} // Sum the scrollTop between two elements.


function getScrollParent(parent, child) {
  var element = child;
  var scrollTop = 0;

  while (element && element !== parent) {
    element = element.parentNode;
    scrollTop += element.scrollTop;
  }

  return scrollTop;
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var styles = {
  /* Styles applied to the `Paper` component. */
  paper: {
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 'none'
  }
};
exports.styles = styles;

var Popover =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Popover, _React$Component);

  function Popover() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Popover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Popover)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.paperRef = null;
    _this.handleGetOffsetTop = getOffsetTop;
    _this.handleGetOffsetLeft = getOffsetLeft;
    _this.handleResize = (0, _debounce.default)(function () {
      _this.setPositioningStyles(_this.paperRef);
    }, 166);

    _this.componentWillUnmount = function () {
      _this.handleResize.clear();
    };

    _this.setPositioningStyles = function (element) {
      if (element && element.style) {
        var positioning = _this.getPositioningStyle(element);

        if (positioning.top !== null) {
          element.style.top = positioning.top;
        }

        if (positioning.left !== null) {
          element.style.left = positioning.left;
        }

        element.style.transformOrigin = positioning.transformOrigin;
      }
    };

    _this.getPositioningStyle = function (element) {
      var _this$props = _this.props,
          anchorEl = _this$props.anchorEl,
          anchorReference = _this$props.anchorReference,
          marginThreshold = _this$props.marginThreshold; // Check if the parent has requested anchoring on an inner content node

      var contentAnchorOffset = _this.getContentAnchorOffset(element);

      var elemRect = {
        width: element.clientWidth,
        height: element.clientHeight
      }; // Get the transform origin point on the element itself

      var transformOrigin = _this.getTransformOrigin(elemRect, contentAnchorOffset);

      if (anchorReference === 'none') {
        return {
          top: null,
          left: null,
          transformOrigin: getTransformOriginValue(transformOrigin)
        };
      } // Get the offset of of the anchoring element


      var anchorOffset = _this.getAnchorOffset(contentAnchorOffset); // Calculate element positioning


      var top = anchorOffset.top - transformOrigin.vertical;
      var left = anchorOffset.left - transformOrigin.horizontal;
      var bottom = top + elemRect.height;
      var right = left + elemRect.width; // Use the parent window of the anchorEl if provided

      var containerWindow = (0, _ownerWindow.default)(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account

      var heightThreshold = containerWindow.innerHeight - marginThreshold;
      var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

      if (top < marginThreshold) {
        var diff = top - marginThreshold;
        top -= diff;
        transformOrigin.vertical += diff;
      } else if (bottom > heightThreshold) {
        var _diff = bottom - heightThreshold;

        top -= _diff;
        transformOrigin.vertical += _diff;
      }

       false ? (0, _warning.default)(elemRect.height < heightThreshold || !elemRect.height || !heightThreshold, ['Material-UI: the popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n')) : void 0; // Check if the horizontal axis needs shifting

      if (left < marginThreshold) {
        var _diff2 = left - marginThreshold;

        left -= _diff2;
        transformOrigin.horizontal += _diff2;
      } else if (right > widthThreshold) {
        var _diff3 = right - widthThreshold;

        left -= _diff3;
        transformOrigin.horizontal += _diff3;
      }

      return {
        top: "".concat(top, "px"),
        left: "".concat(left, "px"),
        transformOrigin: getTransformOriginValue(transformOrigin)
      };
    };

    _this.handleEnter = function (element) {
      if (_this.props.onEnter) {
        _this.props.onEnter(element);
      }

      _this.setPositioningStyles(element);
    };

    return _this;
  }

  (0, _createClass2.default)(Popover, [{
    key: "componentDidMount",
    // Corresponds to 10 frames at 60 Hz.
    value: function componentDidMount() {
      if (this.props.action) {
        this.props.action({
          updatePosition: this.handleResize
        });
      }
    }
  }, {
    key: "getAnchorOffset",
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    value: function getAnchorOffset(contentAnchorOffset) {
      var _this$props2 = this.props,
          anchorEl = _this$props2.anchorEl,
          anchorOrigin = _this$props2.anchorOrigin,
          anchorReference = _this$props2.anchorReference,
          anchorPosition = _this$props2.anchorPosition;

      if (anchorReference === 'anchorPosition') {
         false ? (0, _warning.default)(anchorPosition, 'Material-UI: you need to provide a `anchorPosition` property when using ' + '<Popover anchorReference="anchorPosition" />.') : void 0;
        return anchorPosition;
      } // If an anchor element wasn't provided, just use the parent body element of this Popover


      var anchorElement = getAnchorEl(anchorEl) || (0, _ownerDocument.default)(this.paperRef).body;
      var anchorRect = anchorElement.getBoundingClientRect();
      var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
      return {
        top: anchorRect.top + this.handleGetOffsetTop(anchorRect, anchorVertical),
        left: anchorRect.left + this.handleGetOffsetLeft(anchorRect, anchorOrigin.horizontal)
      };
    } // Returns the vertical offset of inner content to anchor the transform on if provided

  }, {
    key: "getContentAnchorOffset",
    value: function getContentAnchorOffset(element) {
      var _this$props3 = this.props,
          getContentAnchorEl = _this$props3.getContentAnchorEl,
          anchorReference = _this$props3.anchorReference;
      var contentAnchorOffset = 0;

      if (getContentAnchorEl && anchorReference === 'anchorEl') {
        var contentAnchorEl = getContentAnchorEl(element);

        if (contentAnchorEl && element.contains(contentAnchorEl)) {
          var scrollTop = getScrollParent(element, contentAnchorEl);
          contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
        } // != the default value


         false ? (0, _warning.default)(this.props.anchorOrigin.vertical === 'top', ['Material-UI: you can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` property to the popover component.', 'Only use one of the two properties.', 'Set `getContentAnchorEl` to `null | undefined`' + ' or leave `anchorOrigin.vertical` unchanged.'].join('\n')) : void 0;
      }

      return contentAnchorOffset;
    } // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use

  }, {
    key: "getTransformOrigin",
    value: function getTransformOrigin(elemRect) {
      var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var transformOrigin = this.props.transformOrigin;
      return {
        vertical: this.handleGetOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
        horizontal: this.handleGetOffsetLeft(elemRect, transformOrigin.horizontal)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          action = _this$props4.action,
          anchorEl = _this$props4.anchorEl,
          anchorOrigin = _this$props4.anchorOrigin,
          anchorPosition = _this$props4.anchorPosition,
          anchorReference = _this$props4.anchorReference,
          children = _this$props4.children,
          classes = _this$props4.classes,
          containerProp = _this$props4.container,
          elevation = _this$props4.elevation,
          getContentAnchorEl = _this$props4.getContentAnchorEl,
          marginThreshold = _this$props4.marginThreshold,
          ModalClasses = _this$props4.ModalClasses,
          onEnter = _this$props4.onEnter,
          onEntered = _this$props4.onEntered,
          onEntering = _this$props4.onEntering,
          onExit = _this$props4.onExit,
          onExited = _this$props4.onExited,
          onExiting = _this$props4.onExiting,
          open = _this$props4.open,
          PaperProps = _this$props4.PaperProps,
          role = _this$props4.role,
          transformOrigin = _this$props4.transformOrigin,
          TransitionComponent = _this$props4.TransitionComponent,
          transitionDurationProp = _this$props4.transitionDuration,
          TransitionProps = _this$props4.TransitionProps,
          other = (0, _objectWithoutProperties2.default)(_this$props4, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "container", "elevation", "getContentAnchorEl", "marginThreshold", "ModalClasses", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "role", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);
      var transitionDuration = transitionDurationProp;

      if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
        transitionDuration = undefined;
      } // If the container prop is provided, use that
      // If the anchorEl prop is provided, use its parent body element as the container
      // If neither are provided let the Modal take care of choosing the container


      var container = containerProp || (anchorEl ? (0, _ownerDocument.default)(getAnchorEl(anchorEl)).body : undefined);
      return _react.default.createElement(_Modal.default, (0, _extends2.default)({
        classes: ModalClasses,
        container: container,
        open: open,
        BackdropProps: {
          invisible: true
        }
      }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
        appear: true,
        in: open,
        onEnter: this.handleEnter,
        onEntered: onEntered,
        onEntering: onEntering,
        onExit: onExit,
        onExited: onExited,
        onExiting: onExiting,
        role: role,
        timeout: transitionDuration
      }, TransitionProps), _react.default.createElement(_Paper.default, (0, _extends2.default)({
        className: classes.paper,
        elevation: elevation,
        ref: function ref(_ref) {
          _this2.paperRef = _reactDom.default.findDOMNode(_ref);
        }
      }, PaperProps), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), children)));
    }
  }]);
  return Popover;
}(_react.default.Component);

Popover.propTypes =  false ? {
  /**
   * This is callback property. It's called by the component on mount.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports updatePosition() action.
   *
   * @param {object} actions This object contains all posible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,

  /**
   * This is the DOM element, or a function that returns the DOM element,
   * that may be used to set the position of the popover.
   */
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]).isRequired,
    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])]).isRequired
  }),

  /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */
  anchorPosition: _propTypes.default.shape({
    left: _propTypes.default.number.isRequired,
    top: _propTypes.default.number.isRequired
  }),

  /*
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */
  anchorReference: _propTypes.default.oneOf(['anchorEl', 'anchorPosition', 'none']),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * The elevation of the popover.
   */
  elevation: _propTypes.default.number,

  /**
   * This function is called in order to retrieve the content anchor element.
   * It's the opposite of the `anchorEl` property.
   * The content anchor element should be an element inside the popover.
   * It's used to correctly scroll and set the position of the popover.
   * The positioning strategy tries to make the content anchor element just above the
   * anchor element.
   */
  getContentAnchorEl: _propTypes.default.func,

  /**
   * Specifies how close to the edge of the window the popover can appear.
   */
  marginThreshold: _propTypes.default.number,

  /**
   * `classes` property applied to the [`Modal`](/api/modal) element.
   */
  ModalClasses: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the component is entering.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the component has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the component is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired before the component is exiting.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the component has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the component is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * If `true`, the popover is visible.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * Properties applied to the [`Paper`](/api/paper) element.
   */
  PaperProps: _propTypes.default.object,

  /**
   * @ignore
   */
  role: _propTypes.default.string,

  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]).isRequired,
    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])]).isRequired
  }),

  /**
   * Transition component.
   */
  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : {};
Popover.defaultProps = {
  anchorReference: 'anchorEl',
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  elevation: 8,
  marginThreshold: 16,
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  TransitionComponent: _Grow.default,
  transitionDuration: 'auto'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPopover'
})(Popover);

exports.default = _default;

/***/ }),

/***/ "rKgX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__("HBRR"));

var _createClass2 = _interopRequireDefault(__webpack_require__("ud+X"));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__("rjj8"));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__("X+J+"));

var _inherits2 = _interopRequireDefault(__webpack_require__("ymoH"));

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _extends8 = _interopRequireDefault(__webpack_require__("pd3r"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _reactEventListener = _interopRequireDefault(__webpack_require__("/Ngn"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var _transitions = __webpack_require__("z+QM");

var _ClickAwayListener = _interopRequireDefault(__webpack_require__("STj0"));

var _helpers = __webpack_require__("QbVD");

var _Slide = _interopRequireDefault(__webpack_require__("qNdj"));

var _SnackbarContent = _interopRequireDefault(__webpack_require__("N+yN"));

var styles = function styles(theme) {
  var gutter = 24;
  var top = {
    top: 0
  };
  var bottom = {
    bottom: 0
  };
  var right = {
    justifyContent: 'flex-end'
  };
  var left = {
    justifyContent: 'flex-start'
  };
  var topSpace = {
    top: gutter
  };
  var bottomSpace = {
    bottom: gutter
  };
  var rightSpace = {
    right: gutter
  };
  var leftSpace = {
    left: gutter
  };
  var center = {
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)'
  };
  return {
    /* Styles applied to the root element. */
    root: {
      zIndex: theme.zIndex.snackbar,
      position: 'fixed',
      display: 'flex',
      left: 0,
      right: 0,
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */
    anchorOriginTopCenter: (0, _extends8.default)({}, top, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({}, center))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */
    anchorOriginBottomCenter: (0, _extends8.default)({}, bottom, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({}, center))),

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */
    anchorOriginTopRight: (0, _extends8.default)({}, top, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({
      left: 'auto'
    }, topSpace, rightSpace))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */
    anchorOriginBottomRight: (0, _extends8.default)({}, bottom, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({
      left: 'auto'
    }, bottomSpace, rightSpace))),

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */
    anchorOriginTopLeft: (0, _extends8.default)({}, top, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({
      right: 'auto'
    }, topSpace, leftSpace))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */
    anchorOriginBottomLeft: (0, _extends8.default)({}, bottom, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({
      right: 'auto'
    }, bottomSpace, leftSpace)))
  };
};
/* istanbul ignore if */


exports.styles = styles;

if (false) {
  throw new Error('Material-UI: react@16.3.0 or greater is required.');
}

var Snackbar =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Snackbar, _React$Component);

  function Snackbar() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Snackbar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Snackbar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.timerAutoHide = null;
    _this.state = {};

    _this.handleMouseEnter = function (event) {
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }

      _this.handlePause();
    };

    _this.handleMouseLeave = function (event) {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }

      _this.handleResume();
    };

    _this.handleClickAway = function (event) {
      if (_this.props.onClose) {
        _this.props.onClose(event, 'clickaway');
      }
    };

    _this.handlePause = function () {
      clearTimeout(_this.timerAutoHide);
    };

    _this.handleResume = function () {
      if (_this.props.autoHideDuration != null) {
        if (_this.props.resumeHideDuration != null) {
          _this.setAutoHideTimer(_this.props.resumeHideDuration);

          return;
        }

        _this.setAutoHideTimer(_this.props.autoHideDuration * 0.5);
      }
    };

    _this.handleExited = function () {
      _this.setState({
        exited: true
      });
    };

    return _this;
  }

  (0, _createClass2.default)(Snackbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open) {
        this.setAutoHideTimer();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open !== this.props.open) {
        if (this.props.open) {
          this.setAutoHideTimer();
        } else {
          clearTimeout(this.timerAutoHide);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timerAutoHide);
    }
  }, {
    key: "setAutoHideTimer",
    // Timer that controls delay before snackbar auto hides
    value: function setAutoHideTimer(autoHideDuration) {
      var _this2 = this;

      var autoHideDurationBefore = autoHideDuration != null ? autoHideDuration : this.props.autoHideDuration;

      if (!this.props.onClose || autoHideDurationBefore == null) {
        return;
      }

      clearTimeout(this.timerAutoHide);
      this.timerAutoHide = setTimeout(function () {
        var autoHideDurationAfter = autoHideDuration != null ? autoHideDuration : _this2.props.autoHideDuration;

        if (!_this2.props.onClose || autoHideDurationAfter == null) {
          return;
        }

        _this2.props.onClose(null, 'timeout');
      }, autoHideDurationBefore);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          action = _this$props.action,
          _this$props$anchorOri = _this$props.anchorOrigin,
          vertical = _this$props$anchorOri.vertical,
          horizontal = _this$props$anchorOri.horizontal,
          autoHideDuration = _this$props.autoHideDuration,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          ContentProps = _this$props.ContentProps,
          disableWindowBlurListener = _this$props.disableWindowBlurListener,
          message = _this$props.message,
          onClose = _this$props.onClose,
          onEnter = _this$props.onEnter,
          onEntered = _this$props.onEntered,
          onEntering = _this$props.onEntering,
          onExit = _this$props.onExit,
          onExited = _this$props.onExited,
          onExiting = _this$props.onExiting,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseLeave = _this$props.onMouseLeave,
          open = _this$props.open,
          resumeHideDuration = _this$props.resumeHideDuration,
          TransitionComponent = _this$props.TransitionComponent,
          transitionDuration = _this$props.transitionDuration,
          TransitionProps = _this$props.TransitionProps,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["action", "anchorOrigin", "autoHideDuration", "children", "classes", "className", "ContentProps", "disableWindowBlurListener", "message", "onClose", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"]); // So we only render active snackbars.

      if (!open && this.state.exited) {
        return null;
      }

      return _react.default.createElement(_ClickAwayListener.default, {
        onClickAway: this.handleClickAway
      }, _react.default.createElement("div", (0, _extends8.default)({
        className: (0, _classnames.default)(classes.root, classes["anchorOrigin".concat((0, _helpers.capitalize)(vertical)).concat((0, _helpers.capitalize)(horizontal))], className),
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, other), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onFocus: disableWindowBlurListener ? undefined : this.handleResume,
        onBlur: disableWindowBlurListener ? undefined : this.handlePause
      }), _react.default.createElement(TransitionComponent, (0, _extends8.default)({
        appear: true,
        in: open,
        onEnter: onEnter,
        onEntered: onEntered,
        onEntering: onEntering,
        onExit: onExit,
        onExited: (0, _helpers.createChainedFunction)(this.handleExited, onExited),
        onExiting: onExiting,
        timeout: transitionDuration,
        direction: vertical === 'top' ? 'down' : 'up'
      }, TransitionProps), children || _react.default.createElement(_SnackbarContent.default, (0, _extends8.default)({
        message: message,
        action: action
      }, ContentProps)))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (typeof prevState.exited === 'undefined') {
        return {
          exited: !nextProps.open
        };
      }

      if (nextProps.open) {
        return {
          exited: false
        };
      }

      return null;
    }
  }]);
  return Snackbar;
}(_react.default.Component);

Snackbar.propTypes =  false ? {
  /**
   * The action to display.
   */
  action: _propTypes.default.node,

  /**
   * The anchor of the `Snackbar`.
   */
  anchorOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOf(['left', 'center', 'right']).isRequired,
    vertical: _propTypes.default.oneOf(['top', 'center', 'bottom']).isRequired
  }),

  /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   */
  autoHideDuration: _propTypes.default.number,

  /**
   * If you wish the take control over the children of the component you can use this property.
   * When used, you replace the `SnackbarContent` component with the children.
   */
  children: _propTypes.default.element,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Properties applied to the [`SnackbarContent`](/api/snackbar-content) element.
   */
  ContentProps: _propTypes.default.object,

  /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   */
  disableWindowBlurListener: _propTypes.default.bool,

  /**
   * When displaying multiple consecutive Snackbars from a parent rendering a single
   * <Snackbar/>, add the key property to ensure independent treatment of each message.
   * e.g. <Snackbar key={message} />, otherwise, the message may update-in-place and
   * features such as autoHideDuration may be canceled.
   */
  key: _propTypes.default.any,

  /**
   * The message to display.
   */
  message: _propTypes.default.node,

  /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the transition is entering.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the transition has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the transition is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired before the transition is exiting.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the transition has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the transition is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseLeave: _propTypes.default.func,

  /**
   * If true, `Snackbar` is open.
   */
  open: _propTypes.default.bool,

  /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` property isn't specified, it does nothing.
   * If `autoHideDuration` property is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: _propTypes.default.number,

  /**
   * Transition component.
   */
  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : {};
Snackbar.defaultProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center'
  },
  disableWindowBlurListener: false,
  TransitionComponent: _Slide.default,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withStyles.default)(styles, {
  flip: false,
  name: 'MuiSnackbar'
})(Snackbar);

exports.default = _default;

/***/ }),

/***/ "rkok":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ "rqlL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Fade.default;
  }
});

var _Fade = _interopRequireDefault(__webpack_require__("3sMm"));

/***/ }),

/***/ "s/J2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__("HBRR"));

var _createClass2 = _interopRequireDefault(__webpack_require__("ud+X"));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__("rjj8"));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__("X+J+"));

var _inherits2 = _interopRequireDefault(__webpack_require__("ymoH"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _Transition = _interopRequireDefault(__webpack_require__("TAxY"));

var _withTheme = _interopRequireDefault(__webpack_require__("MDtq"));

var _utils = __webpack_require__("T1RF");

// @inheritedComponent Transition
function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}

var styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    // Use translateZ to scrolling issue on Chrome.
    transform: "".concat(getScale(1), " translateZ(0)")
  }
};
/**
 * The Grow transition is used by the [Tooltip](/demos/tooltips) and
 * [Popover](/utils/popover) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Grow =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Grow, _React$Component);

  function Grow() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Grow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Grow)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.autoTimeout = null;
    _this.timer = null;

    _this.handleEnter = function (node) {
      var _this$props = _this.props,
          theme = _this$props.theme,
          timeout = _this$props.timeout;
      (0, _utils.reflow)(node); // So the animation always start from the start.

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration,
          delay = _getTransitionProps.delay;

      var duration = 0;

      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        _this.autoTimeout = duration;
      } else {
        duration = transitionDuration;
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration,
        delay: delay
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: delay
      })].join(',');

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleExit = function (node) {
      var _this$props2 = _this.props,
          theme = _this$props2.theme,
          timeout = _this$props2.timeout;
      var duration = 0;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration,
          delay = _getTransitionProps2.delay;

      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        _this.autoTimeout = duration;
      } else {
        duration = transitionDuration;
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration,
        delay: delay
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: delay || duration * 0.333
      })].join(',');
      node.style.opacity = '0';
      node.style.transform = getScale(0.75);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.addEndListener = function (_, next) {
      if (_this.props.timeout === 'auto') {
        _this.timer = setTimeout(next, _this.autoTimeout || 0);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Grow, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          onEnter = _this$props3.onEnter,
          onExit = _this$props3.onExit,
          styleProp = _this$props3.style,
          theme = _this$props3.theme,
          timeout = _this$props3.timeout,
          other = (0, _objectWithoutProperties2.default)(_this$props3, ["children", "onEnter", "onExit", "style", "theme", "timeout"]);
      var style = (0, _extends2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        appear: true,
        onEnter: this.handleEnter,
        onExit: this.handleExit,
        addEndListener: this.addEndListener,
        timeout: timeout === 'auto' ? null : timeout
      }, other), function (state, childProps) {
        return _react.default.cloneElement(children, (0, _extends2.default)({
          style: (0, _extends2.default)({
            opacity: 0,
            transform: getScale(0.75)
          }, styles[state], style)
        }, childProps));
      });
    }
  }]);
  return Grow;
}(_react.default.Component);

Grow.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : {};
Grow.defaultProps = {
  timeout: 'auto'
};
Grow.muiSupportAuto = true;

var _default = (0, _withTheme.default)()(Grow);

exports.default = _default;

/***/ }),

/***/ "sgHq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _MenuList.default;
  }
});

var _MenuList = _interopRequireDefault(__webpack_require__("Nqaz"));

/***/ }),

/***/ "twsF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("RV4I");

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "uD7C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Modal.default;
  }
});
Object.defineProperty(exports, "ModalManager", {
  enumerable: true,
  get: function get() {
    return _ModalManager.default;
  }
});

var _Modal = _interopRequireDefault(__webpack_require__("GhsM"));

var _ModalManager = _interopRequireDefault(__webpack_require__("qSSY"));

/***/ }),

/***/ "uX6S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ButtonBase = __webpack_require__("32DM");

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Icon = __webpack_require__("PlKq");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionableIcon = function ActionableIcon(_ref) {
    var onHover = _ref.onHover,
        handleClick = _ref.handleClick,
        label = _ref.label,
        text = _ref.text,
        component = _ref.component,
        disabled = _ref.disabled,
        className = _ref.className,
        iconProps = _ref.iconProps,
        width = _ref.width;

    var StyledIconWrapper = (0, _styledComponents2.default)(_ButtonBase2.default).withConfig({
        displayName: 'ActionableIcon__StyledIconWrapper',
        componentId: 'sc-l5rcmy-0'
    })(['\n        &.stolo-icon-label {\n            display: flex;\n            flex-direction: column;\n            width: ', ';\n            min-width: 72px; /* TouchTarget */\n            display: flex;\n            align-items: center;\n            position: relative;\n            padding-right: ', ';\n            \n            > svg {\n                  &:hover {\n                    fill: ', ';\n                  }\n            }\n        }\n    '], width, function (props) {
        return props.theme.space[5];
    }, onHover || 'inherit');

    var Label = _styledComponents2.default.span.withConfig({
        displayName: 'ActionableIcon__Label',
        componentId: 'sc-l5rcmy-1'
    })(['\n        color: ', ';\n        display: block;\n        padding: 0px;\n        margin: 0px;\n        text-transform: none;\n        font-weight: 100;\n        opacity: 1;\n        transition: font-size 0.2s, opacity 0.2s;\n        transition-delay: 0.1s;\n    '], function (props) {
        return (props.iconProps || {}).iconColor ? props.iconProps.iconColor.split('.').reduce(function (o, i) {
            return o[i];
        }, props.theme.palette) : props.theme.palette.common.lightBlack;
    });

    var IconLabel = _react2.default.createElement(
        Label,
        null,
        label
    );

    return _react2.default.createElement(
        StyledIconWrapper,
        {
            className: className, component: component || 'button',
            onClick: handleClick, disabled: disabled,
            classes: { root: 'stolo-icon-label' }
        },
        _react2.default.createElement(_Icon2.default, iconProps),
        IconLabel,
        text
    );
};

ActionableIcon.defaultProps = {
    onHover: '#CC0066',
    label: null,
    text: null,
    disabled: false,
    component: null,
    className: null,
    iconProps: {},
    width: '6em'
};

ActionableIcon.propTypes = {
    onHover: _propTypes2.default.string,
    handleClick: _propTypes2.default.func.isRequired,
    label: _propTypes2.default.string,
    text: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    component: _propTypes2.default.string,
    className: _propTypes2.default.string,
    iconProps: _propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired,
        width: _propTypes2.default.string,
        height: _propTypes2.default.string,
        iconColor: _propTypes2.default.string,
        className: _propTypes2.default.string,
        onHover: _propTypes2.default.string,
        icons: _propTypes2.default.objectOf(_propTypes2.default.any)
    }),
    width: _propTypes2.default.string
};

exports.default = ActionableIcon;

/***/ }),

/***/ "unQw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _actionTypes = __webpack_require__("EA8k");

var types = _interopRequireWildcard(_actionTypes);

var _PatternCardBase = __webpack_require__("nKa5");

var _PatternCardBase2 = _interopRequireDefault(_PatternCardBase);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PatternCard = function PatternCard(_ref) {
    var pattern = _ref.pattern,
        thumbnailType = _ref.thumbnailType,
        children = _ref.children,
        overlay = _ref.overlay,
        overlayPath = _ref.overlayPath,
        sewpatId = _ref.sewpatId;

    var imgUri = pattern.thumbnails[thumbnailType].url;

    var LinkProps = {
        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
        payload: {
            patternid: pattern.id,
            sewpatId: sewpatId
        }
    };

    var title = pattern.id + ': ' + pattern.title;

    return _react2.default.createElement(
        _PatternCardBase2.default,
        { imgUri: imgUri, title: title, LinkProps: LinkProps, overlay: overlay, overlayPath: overlayPath },
        children
    );
};

exports.default = PatternCard;

/***/ }),

/***/ "wrUV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),

/***/ "x3fr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Backdrop.default;
  }
});

var _Backdrop = _interopRequireDefault(__webpack_require__("NvCw"));

/***/ }),

/***/ "xp2j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _ButtonBase = __webpack_require__("32DM");

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardHeader = (0, _styledComponents2.default)(_ButtonBase2.default).withConfig({
    displayName: 'PatternCardHeader__CardHeader',
    componentId: 'sc-47taij-0'
})(['\n     &.stolo-card-header {\n          font-family:  ', ';\n          font-weight: normal;\n          margin: 0px;\n          padding: ', ';\n          padding-left: ', ';\n          color: ', ';\n          background-color: ', ';\n          text-transform: none;\n          width: 100%;\n          justify-content: flex-start;\n          min-height: inherit;\n      }\n    '], function (props) {
    return props.theme.condensed;
}, function (props) {
    return props.theme.space[2];
}, function (props) {
    return props.theme.space[3];
}, function (props) {
    return props.theme.palette.common.text;
}, function (props) {
    return props.theme.palette.background.paper;
});

var PatternCardHeader = function PatternCardHeader(_ref) {
    var title = _ref.title;
    return _react2.default.createElement(
        CardHeader,
        {
            classes: { root: 'stolo-card-header' },
            component: 'div'
        },
        title
    );
};

exports.default = PatternCardHeader;

/***/ }),

/***/ "xpsS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__("HBRR"));

var _createClass2 = _interopRequireDefault(__webpack_require__("ud+X"));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__("rjj8"));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__("X+J+"));

var _inherits2 = _interopRequireDefault(__webpack_require__("ymoH"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var _ButtonBase = _interopRequireDefault(__webpack_require__("32DM"));

var _unsupportedProp = _interopRequireDefault(__webpack_require__("7ICJ"));

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      transition: theme.transitions.create(['color', 'padding-top'], {
        duration: theme.transitions.duration.short
      }),
      paddingTop: 8,
      paddingBottom: 10,
      paddingLeft: 12,
      paddingRight: 12,
      minWidth: 80,
      maxWidth: 168,
      color: theme.palette.text.secondary,
      flex: '1',
      '&$iconOnly': {
        paddingTop: 16
      },
      '&$selected': {
        paddingTop: 6,
        color: theme.palette.primary.main
      }
    },

    /* Styles applied to the root element if selected. */
    selected: {},

    /* Styles applied to the root element if `showLabel={false}` and not selected. */
    iconOnly: {},

    /* Styles applied to the span element that wraps the icon and label. */
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column'
    },

    /* Styles applied to the label's span element. */
    label: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(12),
      opacity: 1,
      transition: 'font-size 0.2s, opacity 0.2s',
      transitionDelay: '0.1s',
      '&$iconOnly': {
        opacity: 0,
        transitionDelay: '0s'
      },
      '&$selected': {
        fontSize: theme.typography.pxToRem(14)
      }
    }
  };
};

exports.styles = styles;

var BottomNavigationAction =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(BottomNavigationAction, _React$Component);

  function BottomNavigationAction() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, BottomNavigationAction);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(BottomNavigationAction)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          value = _this$props.value,
          onClick = _this$props.onClick;

      if (onChange) {
        onChange(event, value);
      }

      if (onClick) {
        onClick(event);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(BottomNavigationAction, [{
    key: "render",
    value: function render() {
      var _classNames, _classNames2;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          classNameProp = _this$props2.className,
          icon = _this$props2.icon,
          label = _this$props2.label,
          onChange = _this$props2.onChange,
          onClick = _this$props2.onClick,
          selected = _this$props2.selected,
          showLabelProp = _this$props2.showLabel,
          value = _this$props2.value,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["classes", "className", "icon", "label", "onChange", "onClick", "selected", "showLabel", "value"]);
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.selected, selected), (0, _defineProperty2.default)(_classNames, classes.iconOnly, !showLabelProp && !selected), _classNames), classNameProp);
      var labelClassName = (0, _classnames.default)(classes.label, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.selected, selected), (0, _defineProperty2.default)(_classNames2, classes.iconOnly, !showLabelProp && !selected), _classNames2));
      return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
        className: className,
        focusRipple: true,
        onClick: this.handleChange
      }, other), _react.default.createElement("span", {
        className: classes.wrapper
      }, icon, _react.default.createElement("span", {
        className: labelClassName
      }, label)));
    }
  }]);
  return BottomNavigationAction;
}(_react.default.Component);

BottomNavigationAction.propTypes =  false ? {
  /**
   * This property isn't supported.
   * Use the `component` property if you need to change the children structure.
   */
  children: _unsupportedProp.default,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The icon element.
   */
  icon: _propTypes.default.node,

  /**
   * The label element.
   */
  label: _propTypes.default.node,

  /**
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * @ignore
   */
  selected: _propTypes.default.bool,

  /**
   * If `true`, the `BottomNavigationAction` will show its label.
   * By default, only the selected `BottomNavigationAction`
   * inside `BottomNavigation` will show its label.
   */
  showLabel: _propTypes.default.bool,

  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: _propTypes.default.any
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiBottomNavigationAction'
})(BottomNavigationAction);

exports.default = _default;

/***/ }),

/***/ "y40A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _ButtonBase = __webpack_require__("32DM");

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationButton = (0, _styledComponents2.default)(_ButtonBase2.default).withConfig({
    displayName: 'PaginationButton',
    componentId: 'sc-zjhwxv-0'
})(['\n    width: 3em;\n    min-width: 50px;\n    max-width: 72px;\n    border: 1px solid ', ';\n    margin-left: -1px;\n'], function (props) {
    return props.theme.palette.blueGrey[200];
});

exports.default = PaginationButton;

/***/ }),

/***/ "y6rd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("R6lU");

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__("cFFW"));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),

/***/ "ygcc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__("HBRR"));

var _createClass2 = _interopRequireDefault(__webpack_require__("ud+X"));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__("rjj8"));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__("X+J+"));

var _inherits2 = _interopRequireDefault(__webpack_require__("ymoH"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _reactDom = _interopRequireDefault(__webpack_require__("O27J"));

var _scrollbarSize = _interopRequireDefault(__webpack_require__("y6rd"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var _Popover = _interopRequireDefault(__webpack_require__("0yCV"));

var _MenuList = _interopRequireDefault(__webpack_require__("sgHq"));

// @inheritedComponent Popover
var RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
var LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};
var styles = {
  /* Styles applied to the `Paper` component. */
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: 'touch'
  }
};
exports.styles = styles;

var Menu =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Menu, _React$Component);

  function Menu() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Menu)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.menuListRef = null;

    _this.getContentAnchorEl = function () {
      if (!_this.menuListRef || !_this.menuListRef.selectedItemRef) {
        return _reactDom.default.findDOMNode(_this.menuListRef).firstChild;
      }

      return _reactDom.default.findDOMNode(_this.menuListRef.selectedItemRef);
    };

    _this.focus = function () {
      if (_this.menuListRef && _this.menuListRef.selectedItemRef) {
        _reactDom.default.findDOMNode(_this.menuListRef.selectedItemRef).focus();

        return;
      }

      var menuList = _reactDom.default.findDOMNode(_this.menuListRef);

      if (menuList && menuList.firstChild) {
        menuList.firstChild.focus();
      }
    };

    _this.handleEnter = function (element) {
      var _this$props = _this.props,
          disableAutoFocusItem = _this$props.disableAutoFocusItem,
          theme = _this$props.theme;

      var menuList = _reactDom.default.findDOMNode(_this.menuListRef); // Focus so the scroll computation of the Popover works as expected.


      if (disableAutoFocusItem !== true) {
        _this.focus();
      } // Let's ignore that piece of logic if users are already overriding the width
      // of the menu.


      if (menuList && element.clientHeight < menuList.clientHeight && !menuList.style.width) {
        var size = "".concat((0, _scrollbarSize.default)(), "px");
        menuList.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = size;
        menuList.style.width = "calc(100% + ".concat(size, ")");
      }

      if (_this.props.onEnter) {
        _this.props.onEnter(element);
      }
    };

    _this.handleListKeyDown = function (event, key) {
      if (key === 'tab') {
        event.preventDefault();

        if (_this.props.onClose) {
          _this.props.onClose(event);
        }
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open && this.props.disableAutoFocusItem !== true) {
        this.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          classes = _this$props2.classes,
          disableAutoFocusItem = _this$props2.disableAutoFocusItem,
          MenuListProps = _this$props2.MenuListProps,
          onEnter = _this$props2.onEnter,
          _this$props2$PaperPro = _this$props2.PaperProps,
          PaperProps = _this$props2$PaperPro === void 0 ? {} : _this$props2$PaperPro,
          PopoverClasses = _this$props2.PopoverClasses,
          theme = _this$props2.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["children", "classes", "disableAutoFocusItem", "MenuListProps", "onEnter", "PaperProps", "PopoverClasses", "theme"]);
      return _react.default.createElement(_Popover.default, (0, _extends2.default)({
        getContentAnchorEl: this.getContentAnchorEl,
        classes: PopoverClasses,
        onEnter: this.handleEnter,
        anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
        transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
        PaperProps: (0, _extends2.default)({}, PaperProps, {
          classes: (0, _extends2.default)({}, PaperProps.classes, {
            root: classes.paper
          })
        })
      }, other), _react.default.createElement(_MenuList.default, (0, _extends2.default)({
        onKeyDown: this.handleListKeyDown
      }, MenuListProps, {
        ref: function ref(_ref) {
          _this2.menuListRef = _ref;
        }
      }), children));
    }
  }]);
  return Menu;
}(_react.default.Component);

Menu.propTypes =  false ? {
  /**
   * The DOM element used to set the position of the menu.
   */
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * If `true`, the selected / first menu item will not be auto focused.
   */
  disableAutoFocusItem: _propTypes.default.bool,

  /**
   * Properties applied to the [`MenuList`](/api/menu-list) element.
   */
  MenuListProps: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the Menu enters.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the Menu has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the Menu is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired before the Menu exits.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the Menu has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the Menu is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * If `true`, the menu is visible.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: _propTypes.default.object,

  /**
   * `classes` property applied to the [`Popover`](/api/popover) element.
   */
  PopoverClasses: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : {};
Menu.defaultProps = {
  disableAutoFocusItem: false,
  transitionDuration: 'auto'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiMenu',
  withTheme: true
})(Menu);

exports.default = _default;

/***/ })

});


// WEBPACK FOOTER //
// async/CategoryPatterns.1ff9ffaa6d120eadb7de.js